
/* Cached formatter per performance */
/* KH-THOUSANDS 2026-10-01: separatore migliaia manuale (Intl it-IT non raggruppa in ambienti senza dati ICU completi -> 6871,90 invece di 6.871,90) */
const _fmtEur = (cents) => { var p=((cents||0)/100).toFixed(2).split('.'); p[0]=p[0].replace(/\B(?=(\d{3})+(?!\d))/g,'.'); return p[0]+','+p[1]+' €'; };
const baseCategoryTemplates = {
 'piastrelle': {
  keywords: ['piastrella', 'piastrelle', 'tile', 'tiles', 'mattonella', 'mattonelle', 'ceramica', 'ceramiche', 'gres', 'porcellanato', 'rivestimento', 'pavimento', 'pavimentazione', 'cotto', 'marmo', 'granito', 'pietra'],
  icon: `<svg width="48" height="48" viewBox="0 0 24 24" fill="none">
   <rect x="2" y="2" width="8.5" height="8.5" rx="0.3" stroke="currentColor" stroke-width="1" fill="none"/>
   <rect x="11.5" y="2" width="8.5" height="8.5" rx="0.3" stroke="currentColor" stroke-width="1" fill="none"/>
   <rect x="2" y="11.5" width="8.5" height="8.5" rx="0.3" stroke="currentColor" stroke-width="1" fill="none"/>
   <rect x="11.5" y="11.5" width="8.5" height="8.5" rx="0.3" stroke="currentColor" stroke-width="1" fill="none"/>
   <line x1="10.7" y1="2" x2="10.7" y2="20.5" stroke="currentColor" stroke-width="0.4"/>
   <line x1="2" y1="10.7" x2="20.5" y2="10.7" stroke="currentColor" stroke-width="0.4"/>
   <path d="M6.25 10.5 A 4.25 4.25 0 0 1 10.5 6.25" stroke="currentColor" stroke-width="0.4" fill="none" opacity="0.7"/>
   <path d="M10.5 6.25 A 4.25 4.25 0 0 1 14.75 10.5" stroke="currentColor" stroke-width="0.4" fill="none" opacity="0.7"/>
   <path d="M14.75 10.5 A 4.25 4.25 0 0 1 10.5 14.75" stroke="currentColor" stroke-width="0.4" fill="none" opacity="0.7"/>
   <path d="M10.5 14.75 A 4.25 4.25 0 0 1 6.25 10.5" stroke="currentColor" stroke-width="0.4" fill="none" opacity="0.7"/>
   <circle cx="6.25" cy="6.25" r="1.5" stroke="currentColor" stroke-width="0.3" fill="none" opacity="0.5"/>
   <circle cx="14.75" cy="6.25" r="1.5" stroke="currentColor" stroke-width="0.3" fill="none" opacity="0.5"/>
   <circle cx="6.25" cy="14.75" r="1.5" stroke="currentColor" stroke-width="0.3" fill="none" opacity="0.5"/>
   <circle cx="14.75" cy="14.75" r="1.5" stroke="currentColor" stroke-width="0.3" fill="none" opacity="0.5"/>
  </svg>`,
  title: 'Piastrelle',
  desc: 'Piastrelle per bagno, cucina e pavimenti'
 },
 'sanitari': {
  keywords: ['wc', 'bidet', 'lavabo', 'lavandino', 'lavelli', 'lavello', 'toilet', 'sanitario', 'sanitari', 'water', 'vaso', 'ceramica', 'coprivaso', 'sedile'],
  icon: `<svg width="48" height="48" viewBox="0 0 22.96 32" fill="none">
   <path d="M18.76,1.18H4.2a1.12,1.12,0,0,0-.86.36.76.76,0,0,0-.21.63L4.36,12.54H18.72L19.83,2.16a.78.78,0,0,0-.21-.62A1.14,1.14,0,0,0,18.76,1.18Z" fill="none" stroke="currentColor" stroke-width="1"/>
   <path d="M22.58,13a1.45,1.45,0,0,0-1.07-.48H19.9L21,2.65h.53a.58.58,0,1,0,0-1.16h-.58A2,2,0,0,0,20.5.75,2.32,2.32,0,0,0,18.76,0H4.2A2.33,2.33,0,0,0,2.46.76,2,2,0,0,0,2,2.31L3.17,12.55H1.45A1.45,1.45,0,0,0,.38,13,1.41,1.41,0,0,0,0,14.12a11.34,11.34,0,0,0,6.82,9.49L6.33,30a1.86,1.86,0,0,0,.49,1.39A1.83,1.83,0,0,0,8.17,32h6.62a1.83,1.83,0,0,0,1.84-2l-.54-6.38a11.49,11.49,0,0,0,3.2-2.05A11.29,11.29,0,0,0,23,14.12,1.41,1.41,0,0,0,22.58,13ZM3.13,2.17a.76.76,0,0,1,.21-.63,1.12,1.12,0,0,1,.86-.36H18.76a1.14,1.14,0,0,1,.86.36.78.78,0,0,1,.21.62L18.72,12.54H4.36ZM21.79,14A10.14,10.14,0,0,1,16,22.39c-.4.19-1.14.49-1.14.49l.1,1.17.5,6.06a.63.63,0,0,1-.17.5.65.65,0,0,1-.49.21H8.17a.65.65,0,0,1-.49-.21.61.61,0,0,1-.17-.5L8,24l.08-1.15-1.14-.52A10.12,10.12,0,0,1,1.17,14a.26.26,0,0,1,.07-.21.29.29,0,0,1,.21-.09H21.51a.29.29,0,0,1,.21.09A.26.26,0,0,1,21.79,14Z" fill="currentColor"/>
  </svg>`,
  title: 'Sanitari',
  desc: 'WC, bidet, lavabi e ceramiche sanitarie'
 },
 'vasche': {
  keywords: ['vasca', 'vasche', 'bath', 'bathtub', 'jacuzzi', 'idromassaggio', 'whirlpool'],
  icon: `<svg width="48" height="48" viewBox="0 0 33.52 32" fill="none">
   <path d="M31,7.92h0v-5a3.07,3.07,0,0,0-6.13,0,.58.58,0,0,0,.58.58A.61.61,0,0,0,26,2.89a1.92,1.92,0,1,1,3.83-.29,1.4,1.4,0,0,1,0,.29v5h-27A2.88,2.88,0,0,0,0,10.73v1.53a2.89,2.89,0,0,0,1.24,2.36v5.07a9.41,9.41,0,0,0,6.23,8.86h0L6.26,31.18a.58.58,0,0,0,.29.76.53.53,0,0,0,.24.06.56.56,0,0,0,.52-.34l1.28-2.77a8.32,8.32,0,0,0,2.05.23H22.83a9.1,9.1,0,0,0,3.1-.57h0a.83.83,0,0,0,.06.21l1.43,2.87a.54.54,0,0,0,.5.32.67.67,0,0,0,.31.05.57.57,0,0,0,.25-.77l-1.4-2.93a.27.27,0,0,0-.09-.12h0a9.4,9.4,0,0,0,5.29-8.45V14.65a2.86,2.86,0,0,0,1.24-2.35V10.77A2.87,2.87,0,0,0,31,7.92ZM12.43,14v4.3l-6.3-2.59V9h6.3ZM1.15,12.3V10.77A1.72,1.72,0,0,1,2.84,9H5v5H2.87A1.73,1.73,0,0,1,1.15,12.3ZM31,15.17v4.6A8.27,8.27,0,0,1,22.83,28H10.64a8.27,8.27,0,0,1-8.25-8.26v-4.6H5v1a.58.58,0,0,0,.35.53l7.46,3.05a.37.37,0,0,0,.21,0,.46.46,0,0,0,.32-.1.56.56,0,0,0,.26-.47V15.17H31Zm1.24-2.87A1.72,1.72,0,0,1,30.55,14h-17V9h17a1.72,1.72,0,0,1,1.72,1.72Z" fill="currentColor"/>
  </svg>`,
  title: 'Vasche',
  desc: 'Vasche da bagno, idromassaggio e design'
 },
 'rubinetti': {
  keywords: ['rubinetto', 'rubinetti', 'miscelatore', 'miscelatori', 'faucet', 'tap', 'bagno', 'cucina', 'doccia', 'soffione', 'doccetta'],
  icon: `<svg width="48" height="48" viewBox="0 0 24 24" fill="none">
   <rect x="8" y="2" width="8" height="4" rx="1" stroke="currentColor" stroke-width="2" fill="none"/>
   <rect x="6" y="6" width="12" height="6" rx="2" stroke="currentColor" stroke-width="2" fill="none"/>
   <line x1="10" y1="12" x2="10" y2="20" stroke="currentColor" stroke-width="2"/>
   <line x1="14" y1="12" x2="14" y2="20" stroke="currentColor" stroke-width="2"/>
   <path d="M6 20H18" stroke="currentColor" stroke-width="2"/>
  </svg>`,
  title: 'Rubinetti',
  desc: 'Rubinetti per bagno, cucina e doccia'
 },
 'arredo-bagno': {
  keywords: ['mobile', 'mobili', 'arredo', 'bagno', 'specchio', 'specchi', 'bathroom', 'furniture', 'mobiletto', 'mobiletti', 'pensile', 'pensili'],
  icon: `<svg width="48" height="48" viewBox="0 0 24 24" fill="none">
   <rect x="4" y="6" width="16" height="12" rx="1" stroke="currentColor" stroke-width="2" fill="none"/>
   <line x1="4" y1="12" x2="20" y2="12" stroke="currentColor" stroke-width="2"/>
   <circle cx="7" cy="9" r="1" fill="currentColor"/>
   <circle cx="17" cy="15" r="1" fill="currentColor"/>
   <line x1="10" y1="18" x2="10" y2="20" stroke="currentColor" stroke-width="2"/>
   <line x1="14" y1="18" x2="14" y2="20" stroke="currentColor" stroke-width="2"/>
  </svg>`,
  title: 'Arredo Bagno',
  desc: 'Mobili, specchi e accessori per il bagno'
 },
 'scrivanie': {
  keywords: ['scrivania', 'scrivanie', 'desk', 'bureau', 'ufficio', 'lavoro', 'studio', 'computer', 'pc'],
  icon: `<svg width="48" height="48" viewBox="0 0 24 24" fill="none">
   <rect x="3" y="8" width="18" height="2" stroke="currentColor" stroke-width="2" fill="none"/>
   <line x1="6" y1="10" x2="6" y2="18" stroke="currentColor" stroke-width="2"/>
   <line x1="18" y1="10" x2="18" y2="18" stroke="currentColor" stroke-width="2"/>
   <rect x="10" y="4" width="4" height="4" rx="1" stroke="currentColor" stroke-width="2" fill="none"/>
  </svg>`,
  title: 'Scrivanie',
  desc: 'Scrivanie per ufficio, casa e smart working'
 },
 'sedie-girevoli': {
  keywords: ['sedia', 'sedie', 'girevole', 'girevoli', 'ufficio', 'gaming', 'ergономica', 'ergonomiche', 'chair', 'office', 'swivel', 'operativa', 'operative'],
  icon: `<svg width="48" height="48" viewBox="0 0 24 24" fill="none">
   <rect x="7" y="4" width="10" height="8" rx="2" stroke="currentColor" stroke-width="2" fill="none"/>
   <line x1="12" y1="12" x2="12" y2="16" stroke="currentColor" stroke-width="2"/>
   <circle cx="12" cy="18" r="2" stroke="currentColor" stroke-width="2" fill="none"/>
   <line x1="10" y1="19" x2="8" y2="21" stroke="currentColor" stroke-width="2"/>
   <line x1="14" y1="19" x2="16" y2="21" stroke="currentColor" stroke-width="2"/>
  </svg>`,
  title: 'Sedie Girevoli',
  desc: 'Sedie da ufficio ergonomiche e gaming'
 },
 'sedie-poltrone': {
  keywords: ['sedia', 'sedie', 'poltrona', 'poltrone', 'chair', 'armchair', 'seduta', 'sedute', 'pranzo', 'soggiorno', 'dining'],
  icon: `<svg width="48" height="48" viewBox="0 0 24 24" fill="none">
   <rect x="6" y="8" width="12" height="8" rx="1" stroke="currentColor" stroke-width="2" fill="none"/>
   <rect x="5" y="6" width="2" height="10" rx="1" stroke="currentColor" stroke-width="2" fill="none"/>
   <rect x="17" y="6" width="2" height="10" rx="1" stroke="currentColor" stroke-width="2" fill="none"/>
   <line x1="8" y1="16" x2="8" y2="20" stroke="currentColor" stroke-width="2"/>
   <line x1="16" y1="16" x2="16" y2="20" stroke="currentColor" stroke-width="2"/>
  </svg>`,
  title: 'Sedie e Poltrone',
  desc: 'Sedie da pranzo, soggiorno e design'
 },
 'divani': {
  keywords: ['divano', 'divani', 'sofa', 'sofà', 'couch', 'salotto', 'soggiorno', 'relax', 'living'],
  icon: `<svg width="48" height="48" viewBox="0 0 24 24" fill="none">
   <rect x="3" y="10" width="18" height="8" rx="2" stroke="currentColor" stroke-width="2" fill="none"/>
   <rect x="2" y="8" width="3" height="6" rx="1" stroke="currentColor" stroke-width="2" fill="none"/>
   <rect x="19" y="8" width="3" height="6" rx="1" stroke="currentColor" stroke-width="2" fill="none"/>
   <line x1="6" y1="18" x2="6" y2="20" stroke="currentColor" stroke-width="2"/>
   <line x1="18" y1="18" x2="18" y2="20" stroke="currentColor" stroke-width="2"/>
  </svg>`,
  title: 'Divani',
  desc: 'Divani e sofà per il tuo soggiorno'
 },
 'tavoli': {
  keywords: ['tavolo', 'tavoli', 'table', 'tables', 'tavolino', 'tavolini', 'coffee', 'dining', 'pranzo', 'cucina', 'sala'],
  icon: `<svg width="48" height="48" viewBox="0 0 24 24" fill="none">
   <rect x="4" y="8" width="16" height="3" rx="1" stroke="currentColor" stroke-width="2" fill="none"/>
   <line x1="7" y1="11" x2="7" y2="19" stroke="currentColor" stroke-width="2"/>
   <line x1="17" y1="11" x2="17" y2="19" stroke="currentColor" stroke-width="2"/>
   <line x1="5" y1="19" x2="9" y2="19" stroke="currentColor" stroke-width="2"/>
   <line x1="15" y1="19" x2="19" y2="19" stroke="currentColor" stroke-width="2"/>
  </svg>`,
  title: 'Tavoli',
  desc: 'Tavoli da pranzo, cucina e salotto'
 },
 'illuminazione': {
  keywords: ['lampada', 'lampade', 'lampadario', 'lampadari', 'luce', 'luci', 'light', 'lights', 'illuminazione', 'applique', 'faretto', 'faretti', 'plafoniera', 'plafoniere'],
  icon: `<svg width="48" height="48" viewBox="0 0 24 24" fill="none">
   <circle cx="12" cy="10" r="4" stroke="currentColor" stroke-width="2" fill="none"/>
   <line x1="12" y1="2" x2="12" y2="4" stroke="currentColor" stroke-width="2"/>
   <line x1="12" y1="16" x2="12" y2="18" stroke="currentColor" stroke-width="2"/>
   <line x1="4.22" y1="4.22" x2="5.64" y2="5.64" stroke="currentColor" stroke-width="2"/>
   <line x1="18.36" y1="18.36" x2="19.78" y2="19.78" stroke="currentColor" stroke-width="2"/>
   <line x1="2" y1="10" x2="4" y2="10" stroke="currentColor" stroke-width="2"/>
   <line x1="20" y1="10" x2="22" y2="10" stroke="currentColor" stroke-width="2"/>
   <line x1="4.22" y1="15.78" x2="5.64" y2="14.36" stroke="currentColor" stroke-width="2"/>
   <line x1="18.36" y1="1.64" x2="19.78" y2="0.22" stroke="currentColor" stroke-width="2"/>
   <rect x="9" y="18" width="6" height="3" rx="1" stroke="currentColor" stroke-width="2" fill="none"/>
  </svg>`,
  title: 'Illuminazione',
  desc: 'Lampade, lampadari e sistemi di illuminazione'
 },
 'elettrodomestici': {
  keywords: ['frigorifero', 'frigoriferi', 'forno', 'forni', 'lavastoviglie', 'lavatrice', 'lavatrici', 'microonde', 'congelatore', 'congelatori', 'freezer', 'appliance', 'elettrodomestico', 'elettrodomestici'],
  icon: `<svg width="48" height="48" viewBox="0 0 24 24" fill="none">
   <rect x="5" y="3" width="14" height="18" rx="2" stroke="currentColor" stroke-width="2" fill="none"/>
   <line x1="5" y1="9" x2="19" y2="9" stroke="currentColor" stroke-width="2"/>
   <circle cx="8" cy="6" r="1" fill="currentColor"/>
   <circle cx="8" cy="15" r="1" fill="currentColor"/>
   <line x1="11" y1="12" x2="16" y2="12" stroke="currentColor" stroke-width="2"/>
   <line x1="11" y1="15" x2="14" y2="15" stroke="currentColor" stroke-width="2"/>
  </svg>`,
  title: 'Elettrodomestici',
  desc: 'Elettrodomestici per casa e cucina'
 },
 'materassi': {
  keywords: ['materasso', 'materassi', 'mattress', 'mattresses', 'letto', 'letti', 'bed', 'beds', 'riposo', 'sonno', 'memory', 'foam', 'latex', 'lattice', 'molle'],
  icon: `<svg width="48" height="48" viewBox="0 0 24 24" fill="none">
   <rect x="3" y="10" width="18" height="6" rx="1" stroke="currentColor" stroke-width="2" fill="none"/>
   <line x1="3" y1="13" x2="21" y2="13" stroke="currentColor" stroke-width="2"/>
   <rect x="6" y="6" width="12" height="4" rx="1" stroke="currentColor" stroke-width="2" fill="none"/>
   <line x1="6" y1="16" x2="6" y2="18" stroke="currentColor" stroke-width="2"/>
   <line x1="18" y1="16" x2="18" y2="18" stroke="currentColor" stroke-width="2"/>
  </svg>`,
  title: 'Materassi',
  desc: 'Materassi e accessori per il riposo'
 },
 'cucine': {
  keywords: ['cucina', 'cucine', 'kitchen', 'kitchens', 'componibile', 'componibili', 'ante', 'pensili', 'pensile', 'moderno', 'moderna', 'arredamento'],
  icon: `<svg width="48" height="48" viewBox="0 0 24 24" fill="none">
   <rect x="4" y="8" width="16" height="10" rx="1" stroke="currentColor" stroke-width="2" fill="none"/>
   <rect x="6" y="4" width="12" height="4" rx="1" stroke="currentColor" stroke-width="2" fill="none"/>
   <circle cx="8" cy="12" r="1" fill="currentColor"/>
   <circle cx="12" cy="12" r="1" fill="currentColor"/>
   <circle cx="16" cy="12" r="1" fill="currentColor"/>
   <line x1="10" y1="18" x2="10" y2="20" stroke="currentColor" stroke-width="2"/>
   <line x1="14" y1="18" x2="14" y2="20" stroke="currentColor" stroke-width="2"/>
  </svg>`,
  title: 'Cucine',
  desc: 'Cucine componibili e arredamento'
 },
 'accessori': {
  keywords: ['accessorio', 'accessori', 'accessory', 'accessories', 'complemento', 'complementi', 'decorazione', 'decorazioni', 'oggetto', 'oggetti', 'design'],
  icon: `<svg width="48" height="48" viewBox="0 0 24 24" fill="none">
   <circle cx="12" cy="12" r="8" stroke="currentColor" stroke-width="2" fill="none"/>
   <circle cx="12" cy="12" r="4" stroke="currentColor" stroke-width="2" fill="none"/>
   <circle cx="12" cy="12" r="1" fill="currentColor"/>
   <line x1="12" y1="4" x2="12" y2="6" stroke="currentColor" stroke-width="2"/>
   <line x1="12" y1="18" x2="12" y2="20" stroke="currentColor" stroke-width="2"/>
   <line x1="4" y1="12" x2="6" y2="12" stroke="currentColor" stroke-width="2"/>
   <line x1="18" y1="12" x2="20" y2="12" stroke="currentColor" stroke-width="2"/>
  </svg>`,
  title: 'Accessori',
  desc: 'Accessori e complementi d\'arredo'
 }
};
let currentCategory = null;
let allProducts = [];
let currentPage = 1;
let productsPerPage = 12;
/* KH-CLEAN 2026-10-07: dispositivo touch (no hover). Su questi NON creo la 2a immagine (ambiente) nelle
   card -> hover ELIMINATO alla fonte (non c'e' proprio niente da swappare), e tolgo i backdrop-filter. */
const _KH_TOUCH = !!(window.matchMedia && window.matchMedia('(hover: none), (pointer: coarse)').matches);
let totalPages = 1;
let dynamicCategories = {};
let sidebarScrollHandler = null;
let currentFilters = {
 availability: 'all',
 price: {
  min: 0,
  max: 10000
 },
 sort: 'recommended',
 advanced: {
  categories: [],
  brands: [],
  formati: [],
  finiture: [],
  ambienti: [],
  spessori: [],
  colori: [],
  installazione: [],
  versione: []
 }
};
function initHeroBanner() {
const banner = document.getElementById('fx-hero-banner');
if (!banner) {
return;
 }
 const clickable = document.getElementById('fx-hero-clickable');
 const bg1 = banner.querySelector('.fx-hero-bg-1');
 const bg2 = banner.querySelector('.fx-hero-bg-2');
 let activeBg = 1; // Traccia quale bg è attivo
let heroData = [];
 try {
  heroData = JSON.parse(banner.dataset.hero || '[]');
} catch (e) {
return;
 }
 if (heroData.length === 0) {
return;
 }
 let currentIndex = 0;
 function showSlide(index, animate = false) {
  const slide = heroData[index];
if (!slide) return;
  if (animate) {
   const nextBg = activeBg === 1 ? bg2 : bg1;
   const currentBgEl = activeBg === 1 ? bg1 : bg2;
   nextBg.style.backgroundImage = `url('${slide.image}')`;
   nextBg.classList.add('fx-active');
   currentBgEl.classList.remove('fx-active');
   activeBg = activeBg === 1 ? 2 : 1;
  } else {
   if (bg1) {
    bg1.style.backgroundImage = `url('${slide.image}')`;
    bg1.classList.add('fx-active');
   }
  }
  if (clickable) clickable.href = slide.url;
 }
 function nextSlide() {
  currentIndex = (currentIndex + 1) % heroData.length;
  showSlide(currentIndex, true);
 }
 showSlide(0, false);
 if (heroData.length > 1) {
  setInterval(nextSlide, 5000);
 }
}
function initEffectsCarousel() {
 const container = document.getElementById('fx-effects-nav-items');
 const leftArrow = document.getElementById('fx-effects-arrow-left');
 const rightArrow = document.getElementById('fx-effects-arrow-right');
if (!container || !leftArrow || !rightArrow) {
return;
 }
 container.scrollLeft = 0;
const scrollAmount = 300; // Pixel da scrollare per click
 function updateArrows() {
  const maxScroll = container.scrollWidth - container.clientWidth;
leftArrow.disabled = container.scrollLeft <= 10;
  rightArrow.disabled = container.scrollLeft >= maxScroll - 10;
 }
 leftArrow.addEventListener('click', () => {
  container.scrollBy({ left: -scrollAmount, behavior: 'smooth' });
 });
 rightArrow.addEventListener('click', () => {
  container.scrollBy({ left: scrollAmount, behavior: 'smooth' });
 });
 container.addEventListener('scroll', updateArrows, { passive: true });
 setTimeout(() => {
  container.scrollLeft = 0; // Forza reset
  updateArrows();
}, 500);
 window.addEventListener('resize', updateArrows);
 addDesktopDrag(container);
 forceHorizontalScrollOnGrid(container);
}
function initCollectionsCarousel() {
 const container = document.getElementById('fx-collections-nav-items');
 const leftArrow = document.getElementById('fx-coll-arrow-left');
 const rightArrow = document.getElementById('fx-coll-arrow-right');
 if (!container || !leftArrow || !rightArrow) return;
 container.scrollLeft = 0;
 const scrollAmount = 300;
 function updateArrows() {
  const maxScroll = container.scrollWidth - container.clientWidth;
  leftArrow.disabled = container.scrollLeft <= 10;
  rightArrow.disabled = container.scrollLeft >= maxScroll - 10;
 }
 leftArrow.addEventListener('click', () => {
  container.scrollBy({ left: -scrollAmount, behavior: 'smooth' });
 });
 rightArrow.addEventListener('click', () => {
  container.scrollBy({ left: scrollAmount, behavior: 'smooth' });
 });
 container.addEventListener('scroll', updateArrows, { passive: true });
 setTimeout(() => { container.scrollLeft = 0; updateArrows(); }, 500);
 window.addEventListener('resize', updateArrows);
 addDesktopDrag(container);
 forceHorizontalScrollOnGrid(container);
}
document.addEventListener('DOMContentLoaded', function() {
 initHeroBanner();
 calculateHeaderHeight();
 initMobileFloatingButtons();
 checkHashOnLoad();
 // Differisci lavoro pesante (caroselli, categorie, wishlist) dopo il primo paint
 setTimeout(function() {
  requestAnimationFrame(initCollectionsCarousel);
  requestAnimationFrame(initEffectsCarousel);
  const sectionSettings = document.querySelector('[data-section-type="collection"]')?.dataset?.sectionSettings;
  if (sectionSettings) {
   const settings = JSON.parse(sectionSettings);
   if (settings.isCategoriesPage) {
    initDynamicCategoriesSystem();
   }
  }
  initWishlistAndCenteringForAllPages();
 }, 100);
});
function initMobileFloatingButtons() {
 const filtersBtn = document.getElementById('fx-floating-filters-btn');
 const effectsBtn = document.getElementById('fx-floating-effects-btn');
 const filtersPanel = document.getElementById('fx-mobile-filters-panel');
 const effectsPanel = document.getElementById('fx-mobile-effects-panel');
 const overlay = document.getElementById('fx-mobile-overlay');
 const closeFiltersBtn = document.getElementById('fx-close-filters-panel');
 const closeEffectsBtn = document.getElementById('fx-close-effects-panel');
 const applyFiltersBtn = document.getElementById('fx-mobile-apply-filters');
 const resetFiltersBtn = document.getElementById('fx-mobile-reset-filters');
 const floatingContainer = document.getElementById('fx-mobile-floating-buttons');
 if (!filtersBtn || !effectsBtn) return;
 const hideOutsideCollection = () => {
  const categoryPage = document.getElementById('fx-category-page');
  if (!categoryPage || !floatingContainer) return;
  const rect = categoryPage.getBoundingClientRect();
  const windowHeight = window.innerHeight;
  if (rect.bottom < 100 || rect.top > windowHeight) {
   floatingContainer.style.opacity = '0';
   floatingContainer.style.pointerEvents = 'none';
  } else {
   floatingContainer.style.opacity = '1';
   floatingContainer.style.pointerEvents = 'auto';
  }
 };
 window.addEventListener('scroll', hideOutsideCollection, { passive: true });
 hideOutsideCollection(); // Check iniziale
 filtersBtn.addEventListener('click', () => {
  populateMobileFiltersPanel();
  filtersPanel.classList.add('open');
  overlay.classList.add('visible');
  filtersBtn.classList.add('active');
 });
 effectsBtn.addEventListener('click', () => {
  populateMobileEffectsPanel();
  effectsPanel.classList.add('open');
  overlay.classList.add('visible');
  effectsBtn.classList.add('active');
 });
 const closeAllPanels = () => {
  filtersPanel?.classList.remove('open');
  effectsPanel?.classList.remove('open');
  overlay?.classList.remove('visible');
  filtersBtn?.classList.remove('active');
  effectsBtn?.classList.remove('active');
 };
 closeFiltersBtn?.addEventListener('click', closeAllPanels);
 closeEffectsBtn?.addEventListener('click', closeAllPanels);
 overlay?.addEventListener('click', closeAllPanels);
 applyFiltersBtn?.addEventListener('click', () => {
  applyMobileFilters();
  closeAllPanels();
 });
 resetFiltersBtn?.addEventListener('click', () => {
  resetMobileFilters();
 });
}
function populateMobileFiltersPanel() {
 const content = document.getElementById('fx-mobile-filters-content');
 if (!content) return;
 const filters = ['formato', 'finitura', 'spessore', 'brand', 'colore', 'installazione', 'versione'];
 let html = '';
 filters.forEach(filterType => {
  const dropdown = document.getElementById(`fx-dropdown-${filterType}-main`);
  if (!dropdown) return;
  const options = dropdown.querySelectorAll('.fx-dropdown-option, .fx-checkbox-option');
  if (options.length === 0) return;
  html += `<div class="fx-mobile-filter-group">
   <div class="fx-mobile-filter-title">${filterType.charAt(0).toUpperCase() + filterType.slice(1)}</div>
   <div class="fx-mobile-filter-options">`;
  options.forEach(opt => {
   const checkbox = opt.querySelector('input[type="checkbox"]');
   const label = opt.querySelector('span:last-child')?.textContent || opt.querySelector('span')?.textContent || opt.textContent.trim();
   if (checkbox && label) {
    const value = checkbox.value;
    const isChecked = checkbox.checked;
    let swatch = '';
    if (filterType === 'colore') {
     const sw = (window.KH_SWATCH && window.KH_SWATCH[value]) || '#cccccc';
     const bg = (sw.indexOf('gradient') !== -1) ? ('background:' + sw + ';') : ('background-color:' + sw + ';');
     swatch = `<span class="kh-swatch" style="display:inline-block;width:14px;height:14px;border-radius:3px;border:1px solid rgba(0,0,0,.22);margin-right:6px;vertical-align:-2px;${bg}"></span>`;
    }
    html += `<button class="fx-mobile-filter-option ${isChecked ? 'selected' : ''}"
         data-filter="${filterType}" data-value="${value}">${swatch}${label}</button>`;
   }
  });
  html += `</div></div>`;
 });
 html += `<div class="fx-mobile-filter-group">
  <div class="fx-mobile-filter-title">Ordina</div>
  <div class="fx-mobile-filter-options">
   <button class="fx-mobile-filter-option selected" data-filter="ordina" data-value="recommended">Consigliati</button>
   <button class="fx-mobile-filter-option" data-filter="ordina" data-value="price-asc">Prezzo ↑</button>
   <button class="fx-mobile-filter-option" data-filter="ordina" data-value="price-desc">Prezzo ↓</button>
   <button class="fx-mobile-filter-option" data-filter="ordina" data-value="newest">Novità</button>
   <button class="fx-mobile-filter-option" data-filter="ordina" data-value="alphabetical">A-Z</button>
  </div>
 </div>`;
 content.innerHTML = html;
 content.querySelectorAll('.fx-mobile-filter-option').forEach(btn => {
  btn.addEventListener('click', () => {
   const filter = btn.dataset.filter;
   if (filter === 'ordina') {
    content.querySelectorAll(`[data-filter="ordina"]`).forEach(b => b.classList.remove('selected'));
    btn.classList.add('selected');
   } else {
    btn.classList.toggle('selected');
   }
   mobilePreviewCount(); // aggiorna il conteggio "Applica (N)" in tempo reale
  });
 });
 mobilePreviewCount(); // conteggio iniziale coerente con la selezione corrente
}
function populateMobileEffectsPanel() {
 const content = document.getElementById('fx-mobile-effects-content');
 if (!content || typeof EFFECTS_DEFINITIONS === 'undefined') return;
 let html = '<div class="fx-mobile-effects-grid">';
 html += `<div class="fx-mobile-effect-item selected" data-effect="all">
  <div class="fx-mobile-effect-icon">
   <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5">
    <rect x="3" y="3" width="7" height="7"/>
    <rect x="14" y="3" width="7" height="7"/>
    <rect x="3" y="14" width="7" height="7"/>
    <rect x="14" y="14" width="7" height="7"/>
   </svg>
  </div>
  <span class="fx-mobile-effect-name">Tutti</span>
 </div>`;
 Object.entries(EFFECTS_DEFINITIONS).forEach(([key, effect]) => {
  html += `<div class="fx-mobile-effect-item" data-effect="${key}">
   <div class="fx-mobile-effect-icon">${effect.icon}</div>
   <span class="fx-mobile-effect-name">${effect.name.replace('Effetto ', '')}</span>
  </div>`;
 });
 html += '</div>';
 content.innerHTML = html;
 content.querySelectorAll('.fx-mobile-effect-item').forEach(item => {
  item.addEventListener('click', () => {
   content.querySelectorAll('.fx-mobile-effect-item').forEach(i => i.classList.remove('selected'));
   item.classList.add('selected');
   const effect = item.dataset.effect;
   if (effect === 'all') {
    document.querySelectorAll('.fx-effect-section').forEach(section => {
     section.style.display = 'block';
    });
   } else {
    document.querySelectorAll('.fx-effect-section').forEach(section => {
     const sectionId = section.id.replace('effect-', '');
     section.style.display = sectionId === effect ? 'block' : 'none';
    });
   }
   document.getElementById('fx-mobile-effects-panel')?.classList.remove('open');
   document.getElementById('fx-mobile-overlay')?.classList.remove('visible');
   document.getElementById('fx-floating-effects-btn')?.classList.remove('active');
  });
 });
}
function applyMobileFilters() {
 const content = document.getElementById('fx-mobile-filters-content');
 if (!content) return;
 /* KH: mappa tipo-filtro -> chiave currentFilters.advanced */
 const MAP = { formato:'formati', finitura:'finiture', spessore:'spessori', brand:'brands', colore:'colori', installazione:'installazione', versione:'versione' };
 const sel = {};
 content.querySelectorAll('.fx-mobile-filter-option.selected').forEach(btn => {
  const filter = btn.dataset.filter;
  const value = btn.dataset.value;
  if (filter === 'ordina') {
   const ordinaRadio = document.querySelector(`#fx-dropdown-ordina-main input[value="${value}"]`);
   if (ordinaRadio) ordinaRadio.checked = true;
   currentFilters.sort = value;
   return;
  }
  (sel[filter] = sel[filter] || []).push(value);
 });
 let activeCount = 0;
 Object.keys(MAP).forEach(filter => {
  const vals = sel[filter] || [];
  currentFilters.advanced[MAP[filter]] = vals;
  /* sync checkbox desktop + badge conteggio */
  document.querySelectorAll(`#fx-dropdown-${filter}-main input[type="checkbox"], #fx-dropdown-${filter} input[type="checkbox"]`).forEach(cb => {
   cb.checked = vals.indexOf(cb.value) !== -1;
  });
  updateCompactFilterCount(filter, vals.length);
  activeCount += vals.length;
 });
 updateFiltersBadge(activeCount);
 updateActiveChips();
 checkResetButtonVisibility();
 if (typeof applyFiltersAndUpdate === 'function') {
  applyFiltersAndUpdate();
 }
}
function updateFiltersBadge(count) {
 const badge = document.getElementById('fx-filters-badge');
 if (!badge) return;
 if (count > 0) {
  badge.textContent = count;
  badge.classList.add('visible');
 } else {
  badge.classList.remove('visible');
 }
}
function resetMobileFilters() {
 const content = document.getElementById('fx-mobile-filters-content');
 if (!content) return;
 content.querySelectorAll('.fx-mobile-filter-option').forEach(btn => {
  if (btn.dataset.filter === 'ordina' && btn.dataset.value === 'recommended') {
   btn.classList.add('selected');
  } else if (btn.dataset.filter === 'ordina') {
   btn.classList.remove('selected');
  } else {
   btn.classList.remove('selected');
  }
 });
 updateFiltersBadge(0);
 if (typeof resetAllFilters === 'function') {
  resetAllFilters();
 }
}
function initDynamicCategoriesSystem() {
 // Differisci il lavoro pesante (parsing JSON + analisi prodotti) dopo il primo paint
 var _doCategoryWork = function() {
  loadAllProducts().then(function() {
   analyzeAllProductsAndCreateCategories();
   requestAnimationFrame(function() {
    initFiltersSystem();
    populateCompactDropdowns();
    // Re-render prodotti dopo il caricamento (fix race condition con checkHashOnLoad)
    checkHashOnLoad();
   });
  });
 };
 if (typeof requestIdleCallback === 'function') {
  requestIdleCallback(_doCategoryWork, { timeout: 300 });
 } else {
  setTimeout(_doCategoryWork, 50);
 }
 const backButtons = document.querySelectorAll('#fx-back-to-categories, #fx-back-to-categories-2');
 backButtons.forEach(button => {
  button.addEventListener('click', function(e) {
   e.preventDefault();
   showLanding();
  });
 });
 window.addEventListener('hashchange', function() {
  handleHashChange();
 });
 window.addEventListener('resize', function() {
  handleWindowResize();
 });
}
function initWishlistAndCenteringForAllPages() {
 requestAnimationFrame(() => {
  initWishlistButtons();
  updateWishlistHeaderCounter();
  applyCenteringToNormalCollections();
 });
 setTimeout(() => {
  applyCenteringToNormalCollections();
  maintainCenteringPersistent();
 }, 1000);
 let resizeTimeout;
 window.addEventListener('resize', function() {
  clearTimeout(resizeTimeout);
  resizeTimeout = setTimeout(() => {
   applyCenteringToNormalCollections();
   maintainCenteringPersistent();
  }, 500);
 });
 let loadTimeout;
 window.addEventListener('load', function() {
  clearTimeout(loadTimeout);
  loadTimeout = setTimeout(() => {
   applyCenteringToNormalCollections();
   maintainCenteringPersistent();
  }, 1000);
 });
 const observer = new MutationObserver(function(mutations) {
  let shouldReapplyCentering = false;
  mutations.forEach(function(mutation) {
   mutation.addedNodes.forEach(function(node) {
    if (node.nodeType === Node.ELEMENT_NODE) {
     const newWishlistButtons = node.querySelectorAll('.fx-wishlist-btn:not([data-wishlist-initialized])');
     if (newWishlistButtons.length > 0) {
      initWishlistButtons();
     }
     const newProductCards = node.querySelectorAll('.fx-normal-collection-grid .fx-product-standard-card, .fx-standard-search .fx-product-standard-card');
     if (newProductCards.length > 0) {
      shouldReapplyCentering = true;
     }
    }
   });
  });
  if (shouldReapplyCentering) {
   setTimeout(() => {
    applyCenteringToNormalCollections();
   }, 200);
  }
 });
 observer.observe(document.body, { childList: true, subtree: true });
}
function applyCenteringToNormalCollections() {
 const allGrids = document.querySelectorAll('.fx-product-standard-grid');
 allGrids.forEach(grid => {
  const productCards = grid.querySelectorAll('.fx-product-standard-card');
  const productCount = productCards.length;
  if (productCount > 0) {
   grid.setAttribute('data-product-count', productCount);
  }
 });
}
function maintainCenteringPersistent() {
 const checkInterval = setInterval(() => {
  applyCenteringToNormalCollections();
 }, 5000);
 setTimeout(() => {
  clearInterval(checkInterval);
 }, 120000);
}
function initWishlistButtons() {
 const wishlistButtons = document.querySelectorAll('.fx-wishlist-btn:not([data-wishlist-initialized])');
 wishlistButtons.forEach(button => {
  button.setAttribute('data-wishlist-initialized', 'true');
  if (_KH_TOUCH) { /* KH-CLEAN: su touch niente backdrop (stutter) e niente scale al long-press (inline !important batte ogni CSS) */
   button.style.setProperty('backdrop-filter', 'none', 'important');
   button.style.setProperty('-webkit-backdrop-filter', 'none', 'important');
   button.style.setProperty('transform', 'none', 'important');
   button.style.setProperty('transition', 'none', 'important');
  }
  const productHandle = button.dataset.productHandle;
  const isInWishlist = isProductInWishlist(productHandle);
  if (isInWishlist) {
   button.classList.add('active');
   button.setAttribute('aria-label', 'Rimuovi dalla wishlist');
  }
  button.addEventListener('click', function(e) {
   e.preventDefault();
   e.stopPropagation();
   handleWishlistToggle(this);
  });
 });
}
function handleWindowResize() {
 if (currentCategory) {
  if (window.innerWidth > 900) {
   initSidebarStopSystem();
   calculateHeaderHeight();
   const sidebar = document.getElementById('fx-filters-sidebar');
   const filtersTitle = document.querySelector('.fx-filters-title');
   if (sidebar && filtersTitle) {
    sidebar.classList.remove('fx-mobile-open');
    filtersTitle.classList.remove('fx-mobile-collapsed');
   }
  } else {
   removeSidebarStopSystem();
   setTimeout(() => {
    initMobileFiltersState();
   }, 100);
  }
 }
 setTimeout(() => {
  applyCenteringToNormalCollections();
 }, 100);
}
function initSidebarStopSystem() {
 if (window.innerWidth <= 900) return; // Solo su desktop
 const collectionSection = document.querySelector('[data-section-type="collection"]');
 const categoryLayout = document.getElementById('fx-category-results');
 if (!collectionSection || !categoryLayout) return;
 let endMarker = categoryLayout.querySelector('.fx-collection-end-marker');
 if (!endMarker) {
  endMarker = document.createElement('div');
  endMarker.className = 'fx-collection-end-marker';
  categoryLayout.appendChild(endMarker);
 }
 removeSidebarStopSystem();
 sidebarScrollHandler = function() {
  checkSidebarPosition();
 };
 window.addEventListener('scroll', sidebarScrollHandler, { passive: true });
 setTimeout(() => {
  checkSidebarPosition();
 }, 100);
}
function removeSidebarStopSystem() {
 if (sidebarScrollHandler) {
  window.removeEventListener('scroll', sidebarScrollHandler);
  sidebarScrollHandler = null;
 }
 const sidebar = document.getElementById('fx-filters-sidebar');
 if (sidebar) {
  sidebar.classList.remove('fx-stopped');
  sidebar.style.position = 'fixed';
  sidebar.style.top = '148px';
  sidebar.style.bottom = 'auto';
  sidebar.style.left = '0';
 }
}
function checkSidebarPosition() {
 const sidebar = document.getElementById('fx-filters-sidebar');
 const categoryLayout = document.getElementById('fx-category-results');
 const endMarker = categoryLayout?.querySelector('.fx-collection-end-marker');
 if (!sidebar || !categoryLayout || !endMarker) return;
 const endMarkerRect = endMarker.getBoundingClientRect();
 const categoryLayoutRect = categoryLayout.getBoundingClientRect();
 const sidebarHeight = sidebar.offsetHeight;
 const fixedTop = 148; // Posizione fissa normale
 const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
 const endMarkerTop = endMarkerRect.top + scrollTop;
 const sidebarBottom = scrollTop + fixedTop + sidebarHeight;
 const stopPoint = endMarkerTop - 50; // 50px di margine dalla fine
 if (sidebar.classList.contains('fx-stopped')) {
  const layoutTop = categoryLayoutRect.top + scrollTop;
  const currentSidebarTop = layoutTop + parseFloat(sidebar.style.top.replace('px', ''));
  const wouldBeFixedBottom = scrollTop + fixedTop + sidebarHeight;
  if (wouldBeFixedBottom < stopPoint) {
   sidebar.classList.remove('fx-stopped');
   sidebar.style.position = 'fixed';
   sidebar.style.top = '148px';
   sidebar.style.bottom = 'auto';
   sidebar.style.left = '0';
  }
  return;
 }
 if (sidebarBottom >= stopPoint && stopPoint > scrollTop + fixedTop) {
  sidebar.classList.add('fx-stopped');
  const layoutTop = categoryLayoutRect.top + scrollTop;
  const maxBottom = endMarkerTop - 50; // Punto di stop
  const newTop = maxBottom - sidebarHeight;
  sidebar.style.position = 'absolute';
  sidebar.style.top = (newTop - layoutTop) + 'px';
  sidebar.style.bottom = 'auto';
  sidebar.style.left = '0';
 }
}
function calculateHeaderHeight() {
 const possibleHeaders = [
  'header',
  '.Header',
  '.site-header',
  '.header',
  '.main-header',
  '.page-header:not(.fx-category-info)',
  '.top-bar',
  '.navigation',
  '.SiteHeader',
  '.site-nav',
  '#shopify-section-header',
  '[data-section-type="header"]'
 ];
 let headerHeight = 120; // Default più sicuro per evitare tagli
 let maxHeight = 0;
 for (const selector of possibleHeaders) {
  const headers = document.querySelectorAll(selector);
  headers.forEach(header => {
   if (header && window.getComputedStyle(header).display !== 'none') {
    const rect = header.getBoundingClientRect();
    if (rect.height > 0 && rect.top <= 100) {
     maxHeight = Math.max(maxHeight, rect.bottom);
    }
   }
  });
 }
 if (maxHeight > 0 && maxHeight < 250) {
  headerHeight = Math.ceil(maxHeight) + 20; // Margine più generoso
 }
 headerHeight = Math.max(100, Math.min(200, headerHeight));
 document.documentElement.style.setProperty('--header-height', `${headerHeight}px`);
 return headerHeight;
}
function initFiltersSystem() {
 const availabilityFilters = document.querySelectorAll('[data-filter="availability"]');
 availabilityFilters.forEach(filter => {
  filter.addEventListener('click', function() {
   setFilter('availability', this.dataset.value);
  });
 });
 initRobustDualSlider();
 const sortFilters = document.querySelectorAll('[data-filter="sort"]');
 sortFilters.forEach(filter => {
  filter.addEventListener('click', function() {
   setFilter('sort', this.dataset.value);
  });
 });
 const filterHeaders = document.querySelectorAll('.fx-filter-header');
 filterHeaders.forEach(header => {
  header.addEventListener('click', function() {
   if (this.id === 'fx-advanced-toggle') {
    toggleAdvancedFilters();
   } else {
    toggleFilterAccordion(this);
   }
  });
 });
 const resetButton = document.getElementById('fx-filters-reset');
 if (resetButton) {
  resetButton.addEventListener('click', function() {
   resetAllFilters();
  });
 }
 const applyButton = document.getElementById('fx-apply-filters');
 if (applyButton) {
  applyButton.addEventListener('click', function() {
   applyFiltersAndUpdate();
  });
 }
 const filtersTitle = document.querySelector('.fx-filters-title');
 if (filtersTitle) {
  filtersTitle.addEventListener('click', toggleMobileFilters);
  filtersTitle.addEventListener('touchstart', function(e) {
   e.preventDefault();
   toggleMobileFilters();
  }, { passive: false });
  if (filtersTitle.attachEvent) {
   filtersTitle.attachEvent('onclick', toggleMobileFilters);
  }
 }
 const effectsLabel = document.getElementById('fx-effects-nav-label');
 if (effectsLabel) {
  effectsLabel.addEventListener('click', toggleMobileEffects);
  effectsLabel.addEventListener('touchstart', function(e) {
   e.preventDefault();
   toggleMobileEffects();
  }, { passive: false });
  if (effectsLabel.attachEvent) {
   effectsLabel.attachEvent('onclick', toggleMobileEffects);
  }
 }
 initMobileFiltersState();
 let resizeTimer;
 window.addEventListener('resize', function() {
  clearTimeout(resizeTimer);
  resizeTimer = setTimeout(function() {
   initMobileFiltersState();
  }, 250);
 });
 initFilterAccordions();
 initCompactFilters();
}
function initCompactFilters() {
 const dropdowns = document.querySelectorAll('.fx-filter-dropdown');
 dropdowns.forEach(dropdown => {
  const trigger = dropdown.querySelector('.fx-dropdown-trigger');
  trigger.addEventListener('click', (e) => {
   e.stopPropagation();
   dropdowns.forEach(d => {
    if (d !== dropdown) d.classList.remove('open');
   });
   dropdown.classList.toggle('open');
  });
 });
 document.addEventListener('click', () => {
  dropdowns.forEach(d => d.classList.remove('open'));
 });
 const ordinaOptions = document.querySelectorAll('#fx-dropdown-ordina .fx-dropdown-option input, #fx-dropdown-ordina-main .fx-dropdown-option input');
 ordinaOptions.forEach(input => {
  input.addEventListener('change', () => {
   setFilter('sort', input.value);
   updateCompactFilterLabel('ordina', getOrdinalLabel(input.value));
   checkResetButtonVisibility();
   document.querySelectorAll('[data-filter="ordina"]').forEach(d => d.classList.remove('open'));
  });
 });
 const disponibilitaOptions = document.querySelectorAll('#fx-dropdown-disponibilita .fx-dropdown-option input, #fx-dropdown-disponibilita-main .fx-dropdown-option input');
 disponibilitaOptions.forEach(input => {
  input.addEventListener('change', () => {
   currentFilters.availability = input.value;
   updateCompactFilterLabel('disponibilita', getDisponibilitaLabel(input.value));
   checkResetButtonVisibility();
   applyFiltersAndUpdate();
   document.querySelectorAll('[data-filter="disponibilita"]').forEach(d => d.classList.remove('open'));
  });
 });
 /* KH: delegation sul contenitore (sopravvive al rebuild delle fasce) + parse generico (X-Y / X+) + label dal testo opzione */
 document.querySelectorAll('.fx-filter-dropdown[data-filter="prezzo"]').forEach(dd => {
  dd.addEventListener('change', (e) => {
   const input = e.target;
   if (!input || input.type !== 'radio') return;
   const value = input.value;
   if (value === 'all') {
    currentFilters.price.min = 0;
    currentFilters.price.max = 100000;
   } else if (value.charAt(value.length - 1) === '+') {
    currentFilters.price.min = parseFloat(value) || 0;
    currentFilters.price.max = 100000;
   } else {
    const parts = value.split('-');
    currentFilters.price.min = parseFloat(parts[0]) || 0;
    currentFilters.price.max = parseFloat(parts[1]) || 100000;
   }
   const opt = input.closest('.fx-dropdown-option');
   const lbl = (value === 'all' || !opt || !opt.querySelector('span')) ? 'Prezzo' : opt.querySelector('span').textContent.trim();
   updateCompactFilterLabel('prezzo', lbl);
   checkResetButtonVisibility();
   applyFiltersAndUpdate();
   dd.classList.remove('open');
  });
 });
 const brandOptions = document.querySelectorAll('#fx-dropdown-brand .fx-dropdown-option input, #fx-dropdown-brand-main .fx-dropdown-option input');
 brandOptions.forEach(input => {
  input.addEventListener('change', () => {
   const selectedBrands = Array.from(document.querySelectorAll('#fx-dropdown-brand-main input:checked, #fx-dropdown-brand input:checked'))
    .map(cb => cb.value);
   currentFilters.advanced.brands = selectedBrands;
   updateCompactFilterCount('brand', selectedBrands.length);
   updateActiveChips();
   checkResetButtonVisibility();
   applyFiltersAndUpdate();
  });
 });
 const resetBtn = document.getElementById('fx-compact-reset');
 const resetBtnMain = document.getElementById('fx-compact-reset-main');
 const handleReset = () => {
  resetAllFilters();
  updateAllCompactLabels();
  clearActiveChips();
  if (resetBtn) resetBtn.style.display = 'none';
  if (resetBtnMain) resetBtnMain.style.display = 'none';
 };
 if (resetBtn) {
  resetBtn.addEventListener('click', handleReset);
 }
 if (resetBtnMain) {
  resetBtnMain.addEventListener('click', handleReset);
 }
}
/* KH-FILTRI 2026-07-16: mappe canoniche condivise tra popolamento dropdown e match prodotti.
   Finiture: accorpa doppioni maschile/femminile + nomi commerciali (realup/strideup/fade->Naturale, grip/antislip->Antiscivolo).
   Spessore: normalizza a 4 bucket reali (6/9/10/20 mm), scarta la classe antiscivolo R9/R11 e i mezzi-mm delle lastre. */
window.KH_FINITURE = [
 { key:'naturale',    label:'Naturale',    kw:['naturale','naturali','matt','matte','opaco','opaca','fade','realup','strideup'] },
 { key:'lappato',     label:'Lappato',     kw:['lappato','lappata'] },
 { key:'satinato',    label:'Satinato',    kw:['satinato','satinata'] },
 { key:'lucido',      label:'Lucido',      kw:['lucido','lucida'] },
 { key:'strutturato', label:'Strutturato', kw:['strutturato','strutturata'] },
 { key:'bocciardato', label:'Bocciardato', kw:['bocciardato','bocciardata','bocciard'] },
 { key:'antiscivolo', label:'Antiscivolo', kw:['antiscivolo','grip','antislip','anti slip','anti-slip'] },
 { key:'levigato',    label:'Levigato',    kw:['levigato','levigata'] }
];
window.khFinitureOf = function(text){
 const t = (text||'').toLowerCase(); const out = [];
 window.KH_FINITURE.forEach(f => { if (f.kw.some(k => t.includes(k))) out.push(f); });
 return out;
};
window.khSpessoreBucket = function(mm){
 const b = [6,9,10,20]; let best = b[0], d = Math.abs(mm-b[0]);
 for (const x of b){ const dd = Math.abs(mm-x); if (dd < d){ d = dd; best = x; } }
 return best + ' mm';
};
window.khSpessoriOf = function(text){
 const out = new Set(); const re = /(\d+(?:[.,]\d+)?)\s*mm/gi; let m;
 while ((m = re.exec(text||'')) !== null){
  const mm = parseFloat(m[1].replace(',', '.'));
  if (mm > 0 && mm < 40) out.add(window.khSpessoreBucket(mm));
 }
 return out;
};
/* KH 2026-07-29: match formato UNICO (order-agnostic). searchText gia' lowercase. Usato da filtro, anteprima e potatura voci a zero. */
window.khFormatoMatches = function(searchText, formato){
 var pp = String(formato).split(/[x×]/i);
 if (pp.length !== 2) return searchText.indexOf(String(formato).toLowerCase()) !== -1;
 var a = pp[0].replace(/\./g,'\\.');
 var b = pp[1].replace(/\./g,'\\.');
 // il valore del filtro puo' essere in ordine "grande x piccolo", il testo prodotto nell'altro ordine
 var re = new RegExp('(^|[^0-9.])(?:' + a + '\\s*[x×]\\s*' + b + '|' + b + '\\s*[x×]\\s*' + a + ')($|[^0-9])', 'i');
 return re.test(searchText);
};
/* KH-FILTRI BAGNO 2026-07-17: colore/finitura (bucketizzato) + installazione. Stessa funzione per popolamento e match. */
window.KH_COLORI = [
 { key:'cromo',            label:'Cromo',            kw:['cromo','chrome'] },
 { key:'nichel/acciaio',   label:'Nichel/Acciaio',   kw:['nichel','nickel','acciaio','inox'] },
 { key:'oro/ottone',       label:'Oro/Ottone',       kw:['oro','gold','ottone','brass','champagne','bronzo','bronze'] },
 { key:'canna di fucile',  label:'Canna di fucile',  kw:['canna fucile','canna di fucile','gun metal','gunmetal'] },
 { key:'rame',             label:'Rame',             kw:['rame','copper'] },
 { key:'bianco',           label:'Bianco',           kw:['bianco','white','blanc'] },
 { key:'nero',             label:'Nero',             kw:['nero','black','noir'] },
 { key:'grigio/antracite', label:'Grigio/Antracite', kw:['grigio','grafite','graphite','antracite','anthracite','grey','gray','basalto','ardesia','cemento'] },
 { key:'beige/sabbia',     label:'Beige/Sabbia',     kw:['beige','sabbia','pergamon','bahama','crema','cream','tortora','avorio','ivory','nocciola'] },
 { key:'colorato',         label:'Colorato',         kw:['rosso','red','verde','green','blu','blue','giallo','yellow','rosa','pink','arancione','orange','celeste','azzurro','ruggine','rust','mattone','salvia','oceano','oliva','turchese','lilla','viola','purple','ocra','phard','foglia','londra','brina','manhattan'] }
];
window.khColoriOf = function(text){
 const t = (text||'').toLowerCase(); const out = [];
 window.KH_COLORI.forEach(c => { if (c.kw.some(k => t.includes(k))) out.push(c); });
 return out;
};
/* swatch quadrati per il filtro Colore (key bucket -> CSS colore/gradiente) */
window.KH_SWATCH = {
 'bianco':'#ffffff',
 'nero':'#1a1a1a',
 'grigio/antracite':'#6b6f73',
 'beige/sabbia':'#d9c7a3',
 'cromo':'linear-gradient(135deg,#f2f2f2,#a9adb1 55%,#dcdcdc)',
 'nichel/acciaio':'linear-gradient(135deg,#dcdedf,#9ba1a6)',
 'oro/ottone':'linear-gradient(135deg,#e9cd80,#b8912f)',
 'canna di fucile':'#383c40',
 'rame':'linear-gradient(135deg,#c9825d,#95542f)',
 'colorato':'conic-gradient(#e74c3c,#f1c40f,#2ecc71,#3498db,#9b59b6,#e74c3c)'
};
window.KH_INSTALL = [
 { key:'sospeso',     label:'Sospeso',     kw:['sospeso','sospesa','sospesi','sospese'] },
 { key:'a terra',     label:'A terra',     kw:['a terra','a-terra','filo pavimento','a pavimento'] },
 { key:'da appoggio', label:'Da appoggio', kw:['appoggio','soprapiano','sopra piano','soprapiano'] },
 { key:'incasso',     label:'Incasso',     kw:['incasso','semincasso','sottopiano','filo top','filo muro'] }
];
window.khInstallOf = function(text){
 const t = (text||'').toLowerCase(); const out = [];
 window.KH_INSTALL.forEach(i => { if (i.kw.some(k => t.includes(k))) out.push(i); });
 return out;
};
/* KH-FILTRI ARREDO OUTDOOR 2026-07-17: Versione (da opzione Struttura/Finitura VONDOM). key = label minuscolo. */
window.KH_VERSIONE = [
 { key:'basic',          label:'Basic',          kw:['basic'] },
 { key:'laccato',        label:'Laccato',        kw:['laccato'] },
 { key:'teak',           label:'Teak',           kw:['teak'] },
 { key:'luminoso',       label:'Luminoso',       kw:['led','rgbw'] },
 { key:'auto-irrigante', label:'Auto-irrigante', kw:['irrigante'] }
];
window.khVersioneOf = function(text){
 const t = (text||'').toLowerCase(); const out = [];
 window.KH_VERSIONE.forEach(v => { if (v.kw.some(k => t.includes(k))) out.push(v); });
 return out;
};
/* KH: se la collezione NON è piastrelle (nessun €/m²), le fasce Prezzo diventano € a PEZZO (senza /m²). Gira una volta. */
window.__khPrezzoBandsDone = window.__khPrezzoBandsDone || false;
function khSetupPrezzoBands() {
 if (window.__khPrezzoBandsDone) return;
 if (!Array.isArray(allProducts) || allProducts.length === 0) return; // dati non pronti: riprova al prossimo giro
 const isTile = allProducts.some(p => p.mqMin > 0);
 if (isTile) { window.__khPrezzoBandsDone = true; return; } // piastrelle: tieni le fasce €/m² dell'HTML
 const bands = [['all','Tutti i prezzi'],['0-50','Fino a €50'],['50-150','€50 - €150'],['150-400','€150 - €400'],['400-1000','€400 - €1000'],['1000+','Oltre €1000']];
 [['fx-dropdown-prezzo-main','prezzo-main'],['fx-dropdown-prezzo','prezzo']].forEach(function(pair){
  const menu = document.getElementById(pair[0]);
  if (!menu) return;
  menu.innerHTML = bands.map(function(b,i){ return '<label class="fx-dropdown-option"><input type="radio" name="'+pair[1]+'" value="'+b[0]+'"'+(i===0?' checked':'')+'><span>'+b[1]+'</span></label>'; }).join('');
 });
 window.__khPrezzoBandsDone = true;
}
function populateCompactDropdowns() {
 khSetupPrezzoBands();
 const formatoDropdown = document.getElementById('fx-dropdown-formato');
 const finituraDropdown = document.getElementById('fx-dropdown-finitura');
 const spessoreDropdown = document.getElementById('fx-dropdown-spessore');
 const brandDropdown = document.getElementById('fx-dropdown-brand');
 const formatoDropdownMain = document.getElementById('fx-dropdown-formato-main');
 const finituraDropdownMain = document.getElementById('fx-dropdown-finitura-main');
 const spessoreDropdownMain = document.getElementById('fx-dropdown-spessore-main');
 const brandDropdownMain = document.getElementById('fx-dropdown-brand-main');
 const coloreDropdownMain = document.getElementById('fx-dropdown-colore-main');
 const installDropdownMain = document.getElementById('fx-dropdown-installazione-main');
 const versioneDropdownMain = document.getElementById('fx-dropdown-versione-main');
 const formati = new Set();
 const finiture = new Set();
 const spessori = new Set();
 const brands = new Set();
 const colori = new Set();
 const installazione = new Set();
 const versione = new Set();
 const productsToUse = currentCategory && dynamicCategories[currentCategory]
  ? dynamicCategories[currentCategory].products
  : allProducts;
 productsToUse.forEach(product => {
  if (product.vendor && product.vendor.trim().length > 1) {
   brands.add(product.vendor.trim());
  }
  const options = product.options || '';
  const tags = Array.isArray(product.tags) ? product.tags.join(' ') : (product.tags || '');
  const title = product.title || '';
  const allText = `${options} ${tags} ${title}`;
  const formatoPattern = /\b(\d{2,3}(?:\.\d+)?)\s*[xX×]\s*(\d{2,3}(?:\.\d+)?)\b/i;
  options.split(',').forEach(function(optPart) {
   const fm = optPart.match(formatoPattern);
   if (fm) {
    // NIENTE arrotondamento: tiene il valore reale (es. 37.5x75) cosi' combacia col testo prodotto.
    // (prima Math.round faceva "37.5x75" -> "75x38" = voce fantasma a zero risultati)
    const w = parseFloat(fm[1]), h = parseFloat(fm[2]);
    const t1 = fm[1].trim(), t2 = fm[2].trim();
    // ordine naturale come si vende: lato PICCOLO per primo (es. 37.5x75, 120x280)
    formati.add((w <= h ? t1+'x'+t2 : t2+'x'+t1).toLowerCase());
   }
  });
  window.khFinitureOf(allText).forEach(f => finiture.add(f.label));
  window.khSpessoriOf(allText).forEach(s => spessori.add(s));
  window.khColoriOf(options).forEach(c => colori.add(c.label));
  window.khInstallOf(`${tags} ${title}`).forEach(i => installazione.add(i.label));
  window.khVersioneOf(options).forEach(v => versione.add(v.label));
 });
 function populateSingleDropdown(dropdown, values, filterType, inputType = 'checkbox') {
  if (!dropdown) return;
  dropdown.innerHTML = '';
  values.forEach(value => {
   let displayValue = value;
   if (filterType === 'finitura') {
    displayValue = value.charAt(0).toUpperCase() + value.slice(1);
   } else if (filterType === 'brand') {
    displayValue = value.split(' ').map(word =>
     word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()
    ).join(' ');
   }
   let swatchHtml = '';
   if (filterType === 'colore') {
    const kv = value.toLowerCase ? value.toLowerCase() : value;
    const sw = (window.KH_SWATCH && window.KH_SWATCH[kv]) || '#cccccc';
    const bg = (sw.indexOf('gradient') !== -1) ? ('background:' + sw + ';') : ('background-color:' + sw + ';');
    swatchHtml = '<span class="kh-swatch" style="display:inline-block;width:15px;height:15px;border-radius:3px;border:1px solid rgba(0,0,0,.22);margin-right:8px;vertical-align:-2px;flex:0 0 auto;' + bg + '"></span>';
   }
   dropdown.innerHTML += `
    <label class="fx-dropdown-option">
     <input type="${inputType}" name="${filterType}" value="${value.toLowerCase ? value.toLowerCase() : value}">
     ${swatchHtml}<span>${displayValue}</span>
    </label>
   `;
  });
  initDropdownCheckboxes(dropdown, filterType);
 }
 const formatiSorted = Array.from(formati).sort((a, b) => {
  const [w1, h1] = a.split('x').map(Number);
  const [w2, h2] = b.split('x').map(Number);
  return (w1 * h1) - (w2 * h2);
 });
 // Potatura: scarta le voci di formato che non trovano ALCUN prodotto (niente filtri fantasma a zero)
 const formatiValid = formatiSorted.filter(function(fmt){
  return productsToUse.some(function(product){
   const st = ((product.title||'') + ' ' + (Array.isArray(product.tags)?product.tags.join(' '):(product.tags||'')) + ' ' + (product.options||'')).toLowerCase();
   return window.khFormatoMatches(st, fmt);
  });
 });
 const finitureSorted = Array.from(finiture).sort();
 const spessoriSorted = Array.from(spessori).sort((a, b) => {
  const numA = parseFloat(a);
  const numB = parseFloat(b);
  return numA - numB;
 });
 populateSingleDropdown(formatoDropdown, formatiValid, 'formato');
 populateSingleDropdown(formatoDropdownMain, formatiValid, 'formato');
 populateSingleDropdown(finituraDropdown, finitureSorted, 'finitura');
 populateSingleDropdown(finituraDropdownMain, finitureSorted, 'finitura');
 populateSingleDropdown(spessoreDropdown, spessoriSorted, 'spessore');
 populateSingleDropdown(spessoreDropdownMain, spessoriSorted, 'spessore');
 const brandsSorted = Array.from(brands).sort((a, b) =>
  a.toLowerCase().localeCompare(b.toLowerCase(), 'it')
 );
 populateSingleDropdown(brandDropdown, brandsSorted, 'brand');
 populateSingleDropdown(brandDropdownMain, brandsSorted, 'brand');
 const coloriSorted = window.KH_COLORI.filter(c => colori.has(c.label)).map(c => c.label);
 const installSorted = window.KH_INSTALL.filter(i => installazione.has(i.label)).map(i => i.label);
 const versioneSorted = window.KH_VERSIONE.filter(v => versione.has(v.label)).map(v => v.label);
 populateSingleDropdown(coloreDropdownMain, coloriSorted, 'colore');
 populateSingleDropdown(installDropdownMain, installSorted, 'installazione');
 populateSingleDropdown(versioneDropdownMain, versioneSorted, 'versione');
}
function initDropdownCheckboxes(dropdown, filterType) {
 const checkboxes = dropdown.querySelectorAll('input[type="checkbox"]');
 checkboxes.forEach(checkbox => {
  checkbox.addEventListener('change', () => {
   const selectedValues = Array.from(dropdown.querySelectorAll('input:checked'))
    .map(input => input.value);
   if (filterType === 'formato') {
    currentFilters.advanced.formati = selectedValues;
   } else if (filterType === 'finitura') {
    currentFilters.advanced.finiture = selectedValues;
   } else if (filterType === 'spessore') {
    currentFilters.advanced.spessori = selectedValues;
   } else if (filterType === 'brand') {
    currentFilters.advanced.brands = selectedValues;
   } else if (filterType === 'colore') {
    currentFilters.advanced.colori = selectedValues;
   } else if (filterType === 'installazione') {
    currentFilters.advanced.installazione = selectedValues;
   } else if (filterType === 'versione') {
    currentFilters.advanced.versione = selectedValues;
   }
   updateCompactFilterCount(filterType, selectedValues.length);
   updateActiveChips();
   checkResetButtonVisibility();
   applyFiltersAndUpdate();
  });
 });
}
function updateCompactFilterCount(filterType, count) {
 const dropdown = document.querySelector(`[data-filter="${filterType}"]`);
 if (!dropdown) return;
 const label = dropdown.querySelector('.fx-dropdown-label');
 if (!label) return; // alcuni filtri (colore/installazione/versione) non hanno dropdown compatto su questa collezione
 let countBadge = label.querySelector('.fx-dropdown-count');
 const trigger = dropdown.querySelector('.fx-dropdown-trigger');
 if (count > 0) {
  if (!countBadge) {
   countBadge = document.createElement('span');
   countBadge.className = 'fx-dropdown-count';
   label.appendChild(countBadge);
  }
  countBadge.textContent = count;
  if (trigger) trigger.classList.add('active');
 } else {
  if (countBadge) countBadge.remove();
  if (trigger) trigger.classList.remove('active');
 }
}
function updateCompactFilterLabel(filterType, text) {
 const dropdown = document.querySelector(`[data-filter="${filterType}"]`);
 if (!dropdown) return;
 const label = dropdown.querySelector('.fx-dropdown-label');
 const baseText = filterType.charAt(0).toUpperCase() + filterType.slice(1);
 if (text && text !== baseText) {
  label.innerHTML = text;
  dropdown.querySelector('.fx-dropdown-trigger').classList.add('active');
 } else {
  label.innerHTML = baseText;
  dropdown.querySelector('.fx-dropdown-trigger').classList.remove('active');
 }
}
function getOrdinalLabel(value) {
 const labels = {
  'recommended': 'Consigliati',
  'price-asc': 'Prezzo ↑',
  'price-desc': 'Prezzo ↓',
  'newest': 'Novità',
  'alphabetical': 'A-Z'
 };
 return labels[value] || 'Ordina';
}
function getDisponibilitaLabel(value) {
 const labels = {
  'all': 'Disponibilità',
  'available': 'Disponibili',
  'on-sale': 'In Offerta'
 };
 return labels[value] || 'Disponibilità';
}
function getPrezzoLabel(value) {
 const labels = {
  'all': 'Prezzo',
  '0-25': 'Fino a €25/m²',
  '25-40': '€25-€40/m²',
  '40-60': '€40-€60/m²',
  '60-90': '€60-€90/m²',
  '90+': 'Oltre €90/m²'
 };
 return labels[value] || 'Prezzo';
}
function updateActiveChips() {
 const containers = [
  document.getElementById('fx-active-filters'),
  document.getElementById('fx-active-filters-main')
 ].filter(c => c !== null);
 containers.forEach(container => {
  container.innerHTML = '';
  currentFilters.advanced.formati.forEach(formato => {
   container.appendChild(createChip(formato, 'formato', formato));
  });
  currentFilters.advanced.finiture.forEach(finitura => {
   container.appendChild(createChip(finitura, 'finitura', finitura));
  });
  currentFilters.advanced.spessori.forEach(spessore => {
   container.appendChild(createChip(spessore, 'spessore', spessore));
  });
  currentFilters.advanced.brands.forEach(brand => {
   container.appendChild(createChip(brand, 'brand', brand));
  });
  (currentFilters.advanced.colori || []).forEach(colore => {
   const c = (window.KH_COLORI || []).find(x => x.key === colore);
   container.appendChild(createChip(c ? c.label : colore, 'colore', colore));
  });
  (currentFilters.advanced.installazione || []).forEach(inst => {
   const i = (window.KH_INSTALL || []).find(x => x.key === inst);
   container.appendChild(createChip(i ? i.label : inst, 'installazione', inst));
  });
  (currentFilters.advanced.versione || []).forEach(ver => {
   const v = (window.KH_VERSIONE || []).find(x => x.key === ver);
   container.appendChild(createChip(v ? v.label : ver, 'versione', ver));
  });
 });
}
function createChip(label, filterType, value) {
 const chip = document.createElement('div');
 chip.className = 'fx-active-chip';
 chip.innerHTML = `
  ${label}
  <button type="button" aria-label="Rimuovi filtro">
   <svg width="12" height="12" viewBox="0 0 24 24" fill="none">
    <path d="M18 6L6 18M6 6l12 12" stroke="currentColor" stroke-width="2"/>
   </svg>
  </button>
 `;
 chip.querySelector('button').addEventListener('click', () => {
  removeFilter(filterType, value);
 });
 return chip;
}
function removeFilter(filterType, value) {
 if (filterType === 'formato') {
  currentFilters.advanced.formati = currentFilters.advanced.formati.filter(v => v !== value);
  uncheckDropdownValue('fx-dropdown-formato', value);
  uncheckDropdownValue('fx-dropdown-formato-main', value);
  updateCompactFilterCount('formato', currentFilters.advanced.formati.length);
 } else if (filterType === 'finitura') {
  currentFilters.advanced.finiture = currentFilters.advanced.finiture.filter(v => v !== value);
  uncheckDropdownValue('fx-dropdown-finitura', value);
  uncheckDropdownValue('fx-dropdown-finitura-main', value);
  updateCompactFilterCount('finitura', currentFilters.advanced.finiture.length);
 } else if (filterType === 'spessore') {
  currentFilters.advanced.spessori = currentFilters.advanced.spessori.filter(v => v !== value);
  uncheckDropdownValue('fx-dropdown-spessore', value);
  uncheckDropdownValue('fx-dropdown-spessore-main', value);
  updateCompactFilterCount('spessore', currentFilters.advanced.spessori.length);
 } else if (filterType === 'brand') {
  currentFilters.advanced.brands = currentFilters.advanced.brands.filter(v => v !== value);
  uncheckDropdownValue('fx-dropdown-brand', value);
  uncheckDropdownValue('fx-dropdown-brand-main', value);
  updateCompactFilterCount('brand', currentFilters.advanced.brands.length);
 } else if (filterType === 'colore') {
  currentFilters.advanced.colori = (currentFilters.advanced.colori || []).filter(v => v !== value);
  uncheckDropdownValue('fx-dropdown-colore', value);
  uncheckDropdownValue('fx-dropdown-colore-main', value);
  updateCompactFilterCount('colore', currentFilters.advanced.colori.length);
 } else if (filterType === 'installazione') {
  currentFilters.advanced.installazione = (currentFilters.advanced.installazione || []).filter(v => v !== value);
  uncheckDropdownValue('fx-dropdown-installazione', value);
  uncheckDropdownValue('fx-dropdown-installazione-main', value);
  updateCompactFilterCount('installazione', currentFilters.advanced.installazione.length);
 } else if (filterType === 'versione') {
  currentFilters.advanced.versione = (currentFilters.advanced.versione || []).filter(v => v !== value);
  uncheckDropdownValue('fx-dropdown-versione', value);
  uncheckDropdownValue('fx-dropdown-versione-main', value);
  updateCompactFilterCount('versione', currentFilters.advanced.versione.length);
 }
 updateActiveChips();
 checkResetButtonVisibility();
 applyFiltersAndUpdate();
}
function uncheckDropdownValue(dropdownId, value) {
 const dropdown = document.getElementById(dropdownId);
 if (!dropdown) return;
 const checkbox = dropdown.querySelector(`input[value="${value}"]`);
 if (checkbox) checkbox.checked = false;
}
function clearActiveChips() {
 const container = document.getElementById('fx-active-filters');
 const containerMain = document.getElementById('fx-active-filters-main');
 if (container) container.innerHTML = '';
 if (containerMain) containerMain.innerHTML = '';
 document.querySelectorAll('.fx-dropdown-menu input[type="checkbox"]').forEach(cb => {
  cb.checked = false;
 });
 updateCompactFilterCount('formato', 0);
 updateCompactFilterCount('finitura', 0);
 updateCompactFilterCount('spessore', 0);
 updateCompactFilterCount('brand', 0);
 updateCompactFilterCount('colore', 0);
 updateCompactFilterCount('installazione', 0);
 updateCompactFilterCount('versione', 0);
 updateCompactFilterLabel('prezzo', 'Prezzo');
 updateCompactFilterLabel('ordina', 'Ordina');
 const recommendedRadio = document.querySelector('#fx-dropdown-ordina input[value="recommended"]');
 const recommendedRadioMain = document.querySelector('#fx-dropdown-ordina-main input[value="recommended"]');
 if (recommendedRadio) recommendedRadio.checked = true;
 if (recommendedRadioMain) recommendedRadioMain.checked = true;
}
function showResetButton() {
 const resetBtn = document.getElementById('fx-compact-reset');
 const resetBtnMain = document.getElementById('fx-compact-reset-main');
 if (resetBtn) resetBtn.style.display = 'flex';
 if (resetBtnMain) resetBtnMain.style.display = 'flex';
}
function checkResetButtonVisibility() {
 const hasFilters = currentFilters.advanced.formati.length > 0 ||
          currentFilters.advanced.finiture.length > 0 ||
          currentFilters.advanced.spessori.length > 0 ||
          currentFilters.advanced.brands.length > 0 ||
          (currentFilters.advanced.colori && currentFilters.advanced.colori.length > 0) ||
          (currentFilters.advanced.installazione && currentFilters.advanced.installazione.length > 0) ||
          (currentFilters.advanced.versione && currentFilters.advanced.versione.length > 0) ||
          currentFilters.sort !== 'recommended' ||
          currentFilters.availability !== 'all' ||
          currentFilters.price.min > 0 ||
          currentFilters.price.max < 10000;
 const resetBtn = document.getElementById('fx-compact-reset');
 const resetBtnMain = document.getElementById('fx-compact-reset-main');
 if (resetBtn) {
  resetBtn.style.display = hasFilters ? 'flex' : 'none';
 }
 if (resetBtnMain) {
  resetBtnMain.style.display = hasFilters ? 'flex' : 'none';
 }
}
function updateAllCompactLabels() {
 updateCompactFilterLabel('ordina', 'Ordina');
 updateCompactFilterLabel('disponibilita', 'Disponibilità');
 updateCompactFilterLabel('prezzo', 'Prezzo');
 updateCompactFilterCount('formato', 0);
 updateCompactFilterCount('finitura', 0);
 updateCompactFilterCount('spessore', 0);
 updateCompactFilterCount('brand', 0);
 document.querySelectorAll('#fx-dropdown-disponibilita input, #fx-dropdown-disponibilita-main input').forEach(input => {
  input.checked = input.value === 'all';
 });
 document.querySelectorAll('#fx-dropdown-prezzo input, #fx-dropdown-prezzo-main input').forEach(input => {
  input.checked = input.value === 'all';
 });
 document.querySelectorAll('#fx-dropdown-brand input, #fx-dropdown-brand-main input').forEach(input => {
  input.checked = false;
 });
}
function initRobustDualSlider() {
 const sliderMin = document.getElementById('fx-price-slider-min');
 const sliderMax = document.getElementById('fx-price-slider-max');
 const sliderContainer = document.querySelector('.fx-dual-slider');
 if (!sliderMin || !sliderMax || !sliderContainer) return;
 let isDragging = false;
 let activeSlider = null;
 let startX = 0;
 let startValue = 0;
 function getActiveSlider(clientX) {
  const rect = sliderContainer.getBoundingClientRect();
  const percentage = (clientX - rect.left) / rect.width;
  const mouseValue = percentage * 10000;
  const minValue = parseInt(sliderMin.value);
  const maxValue = parseInt(sliderMax.value);
  const distanceToMin = Math.abs(mouseValue - minValue);
  const distanceToMax = Math.abs(mouseValue - maxValue);
  if (Math.abs(minValue - maxValue) < 200) {
   return percentage < 0.5 ? sliderMin : sliderMax;
  }
  return distanceToMin < distanceToMax ? sliderMin : sliderMax;
 }
 function updateSliderValue(slider, clientX) {
  const rect = sliderContainer.getBoundingClientRect();
  const percentage = Math.max(0, Math.min(1, (clientX - rect.left) / rect.width));
  const value = Math.round(percentage * 10000);
  let minValue = parseInt(sliderMin.value);
  let maxValue = parseInt(sliderMax.value);
  if (slider === sliderMin) {
   minValue = Math.min(value, maxValue);
   sliderMin.value = minValue;
  } else {
   maxValue = Math.max(value, minValue);
   sliderMax.value = maxValue;
  }
  updatePriceRange();
 }
 sliderContainer.addEventListener('mousedown', function(e) {
  e.preventDefault();
  isDragging = true;
  activeSlider = getActiveSlider(e.clientX);
  startX = e.clientX;
  startValue = parseInt(activeSlider.value);
  document.body.style.userSelect = 'none';
  function handleMouseMove(e) {
   if (!isDragging || !activeSlider) return;
   e.preventDefault();
   updateSliderValue(activeSlider, e.clientX);
  }
  function handleMouseUp() {
   isDragging = false;
   activeSlider = null;
   document.body.style.userSelect = '';
   document.removeEventListener('mousemove', handleMouseMove);
   document.removeEventListener('mouseup', handleMouseUp);
  }
  document.addEventListener('mousemove', handleMouseMove);
  document.addEventListener('mouseup', handleMouseUp);
 });
 sliderContainer.addEventListener('touchstart', function(e) {
  e.preventDefault();
  const touch = e.touches[0];
  isDragging = true;
  activeSlider = getActiveSlider(touch.clientX);
  startX = touch.clientX;
  startValue = parseInt(activeSlider.value);
  function handleTouchMove(e) {
   if (!isDragging || !activeSlider) return;
   e.preventDefault();
   const touch = e.touches[0];
   updateSliderValue(activeSlider, touch.clientX);
  }
  function handleTouchEnd() {
   isDragging = false;
   activeSlider = null;
   document.removeEventListener('touchmove', handleTouchMove);
   document.removeEventListener('touchend', handleTouchEnd);
  }
  document.addEventListener('touchmove', handleTouchMove, { passive: false });
  document.addEventListener('touchend', handleTouchEnd);
 }, { passive: false });
 sliderMin.addEventListener('input', function(e) {
  e.stopPropagation();
  updatePriceRange();
 });
 sliderMax.addEventListener('input', function(e) {
  e.stopPropagation();
  updatePriceRange();
 });
 updatePriceRange();
}
function toggleMobileFilters() {
 if (window.innerWidth > 900) return;
 const sidebar = document.getElementById('fx-filters-sidebar');
 const filtersTitle = document.querySelector('.fx-filters-title');
 if (!sidebar || !filtersTitle) return;
 const isOpen = sidebar.classList ? 
  sidebar.classList.contains('fx-mobile-open') : 
  sidebar.className.indexOf('fx-mobile-open') !== -1;
 if (isOpen) {
  if (sidebar.classList) {
   sidebar.classList.remove('fx-mobile-open');
   filtersTitle.classList.add('fx-mobile-collapsed');
  } else {
   sidebar.className = sidebar.className.replace(' fx-mobile-open', '');
   filtersTitle.className += ' fx-mobile-collapsed';
  }
 } else {
  if (sidebar.classList) {
   sidebar.classList.add('fx-mobile-open');
   filtersTitle.classList.remove('fx-mobile-collapsed');
  } else {
   sidebar.className += ' fx-mobile-open';
   filtersTitle.className = filtersTitle.className.replace(' fx-mobile-collapsed', '');
  }
 }
 if (isOpen && window.scrollTo) {
  try {
   window.scrollTo({ top: 0, behavior: 'smooth' });
  } catch (e) {
   window.scrollTo(0, 0);
  }
 }
}
function toggleMobileEffects() {
 if (window.innerWidth > 768) return;
 const effectsLabel = document.getElementById('fx-effects-nav-label');
 if (!effectsLabel) return;
 const isCollapsed = effectsLabel.classList ?
  effectsLabel.classList.contains('fx-mobile-collapsed') :
  effectsLabel.className.indexOf('fx-mobile-collapsed') !== -1;
 if (isCollapsed) {
  if (effectsLabel.classList) {
   effectsLabel.classList.remove('fx-mobile-collapsed');
  } else {
   effectsLabel.className = effectsLabel.className.replace(' fx-mobile-collapsed', '');
  }
 } else {
  if (effectsLabel.classList) {
   effectsLabel.classList.add('fx-mobile-collapsed');
  } else {
   effectsLabel.className += ' fx-mobile-collapsed';
  }
 }
}
function initMobileFiltersState() {
 const isMobile = window.innerWidth <= 900 || 
  (window.screen && window.screen.width <= 900) ||
  /Android|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
 if (isMobile) {
  const sidebar = document.getElementById('fx-filters-sidebar');
  const filtersTitle = document.querySelector('.fx-filters-title');
  if (sidebar && filtersTitle) {
   if (!filtersTitle.querySelector('.fx-mobile-arrow')) {
    const arrow = document.createElement('span');
    arrow.className = 'fx-mobile-arrow';
    arrow.innerHTML = `<svg width="20" height="20" viewBox="0 0 24 24" fill="none">
     <path d="M6 9L12 15L18 9" stroke="currentColor" stroke-width="2"/>
    </svg>`;
    filtersTitle.appendChild(arrow);
   }
   if (sidebar.classList) {
    sidebar.classList.remove('fx-mobile-open');
    filtersTitle.classList.add('fx-mobile-collapsed');
   } else {
    sidebar.className = sidebar.className.replace(' fx-mobile-open', '');
    if (filtersTitle.className.indexOf('fx-mobile-collapsed') === -1) {
     filtersTitle.className += ' fx-mobile-collapsed';
    }
   }
  }
  const effectsLabel = document.getElementById('fx-effects-nav-label');
  if (effectsLabel) {
   if (effectsLabel.classList) {
    effectsLabel.classList.add('fx-mobile-collapsed');
   } else {
    if (effectsLabel.className.indexOf('fx-mobile-collapsed') === -1) {
     effectsLabel.className += ' fx-mobile-collapsed';
    }
   }
  }
 } else {
  const filtersTitle = document.querySelector('.fx-filters-title');
  const arrow = filtersTitle?.querySelector('.fx-mobile-arrow');
  if (arrow) {
   arrow.remove();
  }
  const effectsLabel = document.getElementById('fx-effects-nav-label');
  if (effectsLabel) {
   if (effectsLabel.classList) {
    effectsLabel.classList.remove('fx-mobile-collapsed');
   } else {
    effectsLabel.className = effectsLabel.className.replace(' fx-mobile-collapsed', '');
   }
  }
 }
}
function initFilterAccordions() {
 const filterGroups = document.querySelectorAll('.fx-filter-group');
 filterGroups.forEach((group, index) => {
  const header = group.querySelector('.fx-filter-header');
  const options = group.querySelector('.fx-filter-options');
  if (header && options) {
   header.classList.add('collapsed');
   options.style.display = 'none';
  }
 });
}
function toggleFilterAccordion(header) {
 const options = header.nextElementSibling;
 const isCollapsed = header.classList.contains('collapsed');
 if (isCollapsed) {
  header.classList.remove('collapsed');
  options.style.display = 'block';
  options.style.maxHeight = '0';
  options.style.overflow = 'hidden';
  setTimeout(() => {
   options.style.maxHeight = options.scrollHeight + 'px';
   options.style.transition = 'max-height 0.3s ease';
  }, 10);
  setTimeout(() => {
   options.style.maxHeight = '';
   options.style.overflow = '';
   options.style.transition = '';
  }, 350);
 } else {
  options.style.maxHeight = options.scrollHeight + 'px';
  options.style.overflow = 'hidden';
  options.style.transition = 'max-height 0.3s ease';
  setTimeout(() => {
   options.style.maxHeight = '0';
  }, 10);
  setTimeout(() => {
   header.classList.add('collapsed');
   options.style.display = 'none';
   options.style.maxHeight = '';
   options.style.overflow = '';
   options.style.transition = '';
  }, 350);
 }
}
function updatePriceRange() {
 const sliderMin = document.getElementById('fx-price-slider-min');
 const sliderMax = document.getElementById('fx-price-slider-max');
 const priceMinEl = document.getElementById('fx-price-min');
 const priceMaxEl = document.getElementById('fx-price-max');
 const sliderRange = document.getElementById('fx-slider-range');
 if (!sliderMin || !sliderMax || !priceMinEl || !priceMaxEl || !sliderRange) return;
 let minValue = parseInt(sliderMin.value);
 let maxValue = parseInt(sliderMax.value);
 if (minValue > maxValue) {
  const temp = minValue;
  minValue = maxValue;
  maxValue = temp;
  sliderMin.value = minValue;
  sliderMax.value = maxValue;
 }
 priceMinEl.textContent = minValue.toLocaleString('it-IT');
 priceMaxEl.textContent = maxValue.toLocaleString('it-IT');
 const percent1 = (minValue / 10000) * 100;
 const percent2 = (maxValue / 10000) * 100;
 sliderRange.style.left = percent1 + '%';
 sliderRange.style.width = (percent2 - percent1) + '%';
 currentFilters.price.min = minValue;
 currentFilters.price.max = maxValue;
 applyFiltersAndUpdate();
 updateResetButton();
}
function setFilter(type, value) {
 if (type !== 'price') {
  currentFilters[type] = value;
  updateFilterUI(type, value);
 }
 applyFiltersAndUpdate();
 updateResetButton();
}
function updateFilterUI(type, value) {
 const filterOptions = document.querySelectorAll(`[data-filter="${type}"]`);
 filterOptions.forEach(option => {
  if (option.dataset.value === value) {
   option.classList.add('active');
   option.querySelector('input').checked = true;
  } else {
   option.classList.remove('active');
   option.querySelector('input').checked = false;
  }
 });
}
function toggleAdvancedFilters() {
 const toggle = document.getElementById('fx-advanced-toggle');
 const content = document.getElementById('fx-advanced-content');
 if (!toggle || !content) return;
 toggleFilterAccordion(toggle);
 if (!toggle.classList.contains('collapsed') && !content.dataset.populated) {
  setTimeout(() => {
   populateAdvancedFilters();
   content.dataset.populated = 'true';
  }, 100);
 }
}
function populateBrands() {
 if (!currentCategory || !dynamicCategories[currentCategory]) return;
 const products = dynamicCategories[currentCategory].products;
 const brands = new Set();
 products.forEach(product => {
  if (product.vendor && product.vendor.length > 2) {
   brands.add(product.vendor);
  }
 });
 const brandTags = document.getElementById('fx-brand-tags');
 if (brandTags) {
  brandTags.innerHTML = '';
  if (brands.size === 0) {
   brandTags.innerHTML = '<span style="color: #999; font-size: 0.85rem; padding: 0.5rem;">Nessun brand disponibile</span>';
   return;
  }
  Array.from(brands)
   .sort((a, b) => a.toLowerCase().localeCompare(b.toLowerCase(), 'it'))
   .forEach(brand => {
    const tag = createAdvancedTag(brand, 'brands');
    brandTags.appendChild(tag);
   });
 }
}
function populateFormati() {
if (!currentCategory || !dynamicCategories[currentCategory]) {
return;
 }
 const products = dynamicCategories[currentCategory].products;
 const formati = new Set();
 if (products[0]) {
}
 const formatoPattern = /\b(\d{2,3})\s*x\s*(\d{2,3})\b/gi;
 products.forEach(product => {
  if (product.options) {
   const matches = product.options.matchAll(formatoPattern);
   for (const match of matches) {
    const formato = `${match[1]}x${match[2]}`;
    formati.add(formato);
   }
  }
  if (product.tags) {
   const matches = product.tags.matchAll(formatoPattern);
   for (const match of matches) {
    const formato = `${match[1]}x${match[2]}`;
    formati.add(formato);
   }
  }
  if (product.title) {
   const matches = product.title.matchAll(formatoPattern);
   for (const match of matches) {
    const formato = `${match[1]}x${match[2]}`;
    formati.add(formato);
   }
  }
 });
const formatoTags = document.getElementById('fx-formato-tags');
if (formatoTags) {
  formatoTags.innerHTML = '';
  if (formati.size === 0) {
formatoTags.innerHTML = '<span style="color: #999; font-size: 0.85rem; padding: 0.5rem; display: block; text-align: center;">Nessun formato disponibile</span>';
   return;
  }
  Array.from(formati)
   .sort((a, b) => {
    const [w1, h1] = a.split('x').map(Number);
    const [w2, h2] = b.split('x').map(Number);
    return (w1 * h1) - (w2 * h2); // Ordina per area
   })
   .forEach(formato => {
    const tag = createAdvancedTag(`${formato} cm`, 'formati', formato);
    formatoTags.appendChild(tag);
   });
 }
}
function populateFiniture() {
 if (!currentCategory || !dynamicCategories[currentCategory]) return;
 const products = dynamicCategories[currentCategory].products;
 const finitureDetected = new Set();
 const finitureKeywords = {
  'opaco': ['opaco', 'opaca', 'opachi', 'opache', 'matt', 'matte', 'opaca'],
  'lucido': ['lucido', 'lucida', 'lucidi', 'lucide', 'lux', 'glossy', 'polished', 'gloss'],
  'satinato': ['satinato', 'satinata', 'satinati', 'satinate', 'satin', 'semi-lucido', 'semilucido', 'semilucida'],
  'rettificato': ['rettificato', 'rettificata', 'rettificati', 'rettificate', 'rectified', 'rett'],
  'bocciardato': ['bocciardato', 'bocciardata', 'bocciardati', 'bocciardate', 'bush-hammered', 'bocciard'],
  'naturale': ['naturale', 'naturali', 'natural', 'nat'],
  'comfort': ['comfort', 'comfy', 'confort'],
  'strutturato': ['strutturato', 'strutturata', 'strutturati', 'strutturate', 'structured', 'texture', 'texturizzato'],
  'liscio': ['liscio', 'liscia', 'lisci', 'lisce', 'smooth', 'liscio'],
  'squadrato': ['squadrato', 'squadrata', 'squadrati', 'squadrate', 'squared']
 };
 products.forEach(product => {
  const searchText = `${product.options} ${product.title} ${product.tags} ${product.type}`.toLowerCase();
  for (const [finitura, keywords] of Object.entries(finitureKeywords)) {
   if (keywords.some(keyword => searchText.includes(keyword))) {
    finitureDetected.add(finitura);
   }
  }
 });
 const finituraTags = document.getElementById('fx-finitura-tags');
 if (finituraTags) {
  finituraTags.innerHTML = '';
  if (finitureDetected.size === 0) {
   finituraTags.innerHTML = '<span style="color: #999; font-size: 0.85rem; padding: 0.5rem;">Nessuna finitura disponibile</span>';
   return;
  }
  const ordineFiniture = ['opaco', 'lucido', 'satinato', 'rettificato', 'bocciardato', 'naturale', 'comfort', 'strutturato', 'liscio', 'squadrato'];
  ordineFiniture
   .filter(f => finitureDetected.has(f))
   .forEach(finitura => {
    const label = finitura.charAt(0).toUpperCase() + finitura.slice(1);
    const tag = createAdvancedTag(label, 'finiture', finitura);
    finituraTags.appendChild(tag);
   });
 }
}
function populateAmbienti() {
 if (!currentCategory || !dynamicCategories[currentCategory]) return;
 const products = dynamicCategories[currentCategory].products;
 const ambienti = new Set();
 const ambientiKeywords = {
  'interno': ['interno', 'interni', 'indoor', 'inside'],
  'esterno': ['esterno', 'outdoor', 'external', 'esterni', 'outside'],
  'parete': ['parete', 'pareti', 'wall', 'rivestimento', 'rivestimenti']
 };
 products.forEach(product => {
  const searchText = `${product.title} ${product.tags} ${product.type} ${product.options}`.toLowerCase();
  for (const [ambiente, keywords] of Object.entries(ambientiKeywords)) {
   if (keywords.some(keyword => searchText.includes(keyword))) {
    ambienti.add(ambiente);
   }
  }
 });
 const ambienteTags = document.getElementById('fx-ambiente-tags');
 if (ambienteTags) {
  ambienteTags.innerHTML = '';
  if (ambienti.size === 0) {
   ambienteTags.innerHTML = '<span style="color: #999; font-size: 0.85rem; padding: 0.5rem;">Nessun ambiente disponibile</span>';
   return;
  }
  const ordineAmbienti = ['interno', 'esterno', 'parete'];
  ordineAmbienti
   .filter(a => ambienti.has(a))
   .forEach(ambiente => {
    const label = ambiente.charAt(0).toUpperCase() + ambiente.slice(1);
    const tag = createAdvancedTag(label, 'ambienti', ambiente);
    ambienteTags.appendChild(tag);
   });
 }
}
function populateSpessori() {
 if (!currentCategory || !dynamicCategories[currentCategory]) return;
 const products = dynamicCategories[currentCategory].products;
 const spessori = new Set();
 const spessorePattern = /(\d+(?:\.\d+)?)\s*mm/gi;
 products.forEach(product => {
  const searchText = `${product.options} ${product.title} ${product.tags}`;
  let match;
  while ((match = spessorePattern.exec(searchText)) !== null) {
   const spessoreValue = parseFloat(match[1]);
   const spessoreLabel = `${spessoreValue} mm`;
   spessori.add(spessoreLabel);
  }
 });
 const spessoreTags = document.getElementById('fx-spessore-tags');
 if (spessoreTags) {
  spessoreTags.innerHTML = '';
  if (spessori.size === 0) {
   spessoreTags.innerHTML = '<span style="color: #999; font-size: 0.85rem; padding: 0.5rem;">Nessuno spessore disponibile</span>';
   return;
  }
  const spessoriArray = Array.from(spessori).sort((a, b) => {
   const aVal = parseFloat(a);
   const bVal = parseFloat(b);
   return aVal - bVal;
  });
  spessoriArray.forEach(spessore => {
   const tag = createAdvancedTag(spessore, 'spessori', spessore);
   spessoreTags.appendChild(tag);
  });
 }
}
function populateAllFilters() {
 populateBrands();
 populateFormati();
 populateFiniture();
 populateAmbienti();
 populateSpessori();
}
function populateAdvancedFilters() {
 populateAllFilters();
}
function capitalizeText(text) {
 if (!text) return text;
 const capitalized = text.toLowerCase().split(' ').map(word => {
  if (word.length === 0) return word;
  return word.charAt(0).toUpperCase() + word.slice(1);
 }).join(' ');
 return capitalized
  .replace(/\sCm(\s|$)/g, ' cm$1')
  .replace(/\sMm(\s|$)/g, ' mm$1')
  .replace(/^Cm(\s|$)/, 'cm$1')
  .replace(/^Mm(\s|$)/, 'mm$1');
}
function createAdvancedTag(text, type, customValue = null) {
 const tag = document.createElement('span');
 tag.className = 'fx-advanced-tag';
 tag.textContent = capitalizeText(text);
 tag.dataset.type = type;
 const value = customValue || text.toLowerCase();
 tag.dataset.value = value;
 tag.addEventListener('click', function() {
  toggleAdvancedTag(this, type, value);
 });
 return tag;
}
function toggleAdvancedTag(element, type, value) {
const isActive = element.classList.contains('active');
 if (isActive) {
  element.classList.remove('active');
  const index = currentFilters.advanced[type].indexOf(value);
  if (index > -1) {
   currentFilters.advanced[type].splice(index, 1);
  }
} else {
  element.classList.add('active');
  if (!currentFilters.advanced[type].includes(value)) {
   currentFilters.advanced[type].push(value);
  }
}
applyFiltersAndUpdate();
 updateResetButton();
}
function resetAllFilters() {
 currentFilters = {
  availability: 'all',
  price: {
   min: 0,
   max: 10000
  },
  sort: 'recommended',
  advanced: {
   categories: [],
   brands: [],
   formati: [],
   finiture: [],
   ambienti: [],
   spessori: [],
   colori: [],
   installazione: [],
   versione: []
  }
 };
 document.querySelectorAll('.fx-filter-option').forEach(option => {
  option.classList.remove('active');
  const input = option.querySelector('input');
  if (input) input.checked = false;
 });
 document.querySelectorAll('[data-value="all"], [data-value="recommended"]').forEach(option => {
  option.classList.add('active');
  const input = option.querySelector('input');
  if (input) input.checked = true;
 });
 const sliderMin = document.getElementById('fx-price-slider-min');
 const sliderMax = document.getElementById('fx-price-slider-max');
 if (sliderMin && sliderMax) {
  sliderMin.value = 0;
  sliderMax.value = 10000;
  updatePriceRange();
 }
 document.querySelectorAll('.fx-advanced-tag').forEach(tag => {
  tag.classList.remove('active');
 });
 applyFiltersAndUpdate();
 updateResetButton();
}
function updateResetButton() {
 const resetButton = document.getElementById('fx-filters-reset');
 if (!resetButton) return;
 const hasActiveFilters =
  currentFilters.availability !== 'all' ||
  currentFilters.price.min !== 0 ||
  currentFilters.price.max !== 10000 ||
  currentFilters.sort !== 'recommended' ||
  currentFilters.advanced.categories.length > 0 ||
  currentFilters.advanced.brands.length > 0 ||
  currentFilters.advanced.formati.length > 0 ||
  currentFilters.advanced.finiture.length > 0 ||
  currentFilters.advanced.ambienti.length > 0 ||
  currentFilters.advanced.spessori.length > 0 ||
  (currentFilters.advanced.colori && currentFilters.advanced.colori.length > 0) ||
  (currentFilters.advanced.installazione && currentFilters.advanced.installazione.length > 0) ||
  (currentFilters.advanced.versione && currentFilters.advanced.versione.length > 0);
 resetButton.style.display = hasActiveFilters ? 'flex' : 'none';
}
function applyFiltersAndUpdate(keepCurrentPage = false) {
 if (currentCategory === 'tutti' && !dynamicCategories['tutti']) {
dynamicCategories['tutti'] = {
   title: (document.querySelector('.fx-category-title') ? document.querySelector('.fx-category-title').textContent : (window._collectionTitle || 'Tutti i Prodotti')),
   products: allProducts,
   detectedKeywords: new Set(),
   confidence: 100
  };
 }
 if (!currentCategory || !dynamicCategories[currentCategory]) {
return;
 }
 let filteredProducts = [...dynamicCategories[currentCategory].products];
if (currentFilters.availability === 'available') {
  filteredProducts = filteredProducts.filter(product => product.available);
 } else if (currentFilters.availability === 'on-sale') {
  filteredProducts = filteredProducts.filter(product => 
   (product.comparePrice > product.price) || 
   (product.comparePriceMin > product.priceMin)
  );
 }
 if (currentFilters.price.min > 0 || currentFilters.price.max < 10000) {
  filteredProducts = filteredProducts.filter(product => {
   // Piastrelle: filtra sul prezzo €/m² (mqMin, in centesimi). Altri prodotti: prezzo al pezzo.
   const price = (product.mqMin > 0) ? product.mqMin : (product.priceVaries ? product.priceMin : product.price);
   const priceInEur = price / 100;
   return priceInEur >= currentFilters.price.min && priceInEur <= currentFilters.price.max;
  });
 }
 if (currentFilters.advanced.categories.length > 0) {
  filteredProducts = filteredProducts.filter(product => 
   currentFilters.advanced.categories.some(cat => 
    product.titleWords.includes(cat) ||
    product.typeWords.includes(cat) ||
    product.tagsArray.includes(cat) ||
    product.type.toLowerCase().includes(cat)
   )
  );
 }
 if (currentFilters.advanced.brands.length > 0) {
  filteredProducts = filteredProducts.filter(product =>
   currentFilters.advanced.brands.some(brand =>
    product.vendor.toLowerCase() === brand.toLowerCase() ||
    product.vendor.toLowerCase().includes(brand.toLowerCase())
   )
  );
 }
 if (currentFilters.advanced.formati.length > 0) {
  filteredProducts = filteredProducts.filter(product => {
   const searchText = `${product.title} ${product.tags} ${product.options}`.toLowerCase();
   return currentFilters.advanced.formati.some(function(formato) {
    return window.khFormatoMatches(searchText, formato);
   });
  });
}
 if (currentFilters.advanced.finiture.length > 0) {
  filteredProducts = filteredProducts.filter(product => {
   const txt = `${product.options} ${product.tags} ${product.title} ${product.type || ''}`.toLowerCase();
   const prodFin = window.khFinitureOf(txt).map(f => f.key);
   return currentFilters.advanced.finiture.some(sel => prodFin.includes(sel));
  });
 }
 if (currentFilters.advanced.ambienti.length > 0) {
  const ambientiKeywords = {
   'interno': ['interno', 'interni', 'indoor', 'inside'],
   'esterno': ['esterno', 'outdoor', 'external', 'esterni', 'outside'],
   'parete': ['parete', 'pareti', 'wall']
  };
  filteredProducts = filteredProducts.filter(product => {
   const searchText = `${product.title} ${product.tags} ${product.type} ${product.options}`.toLowerCase();
   return currentFilters.advanced.ambienti.some(ambiente => {
    const keywords = ambientiKeywords[ambiente] || [ambiente];
    if (ambiente === 'parete') {
     const hasParete = keywords.some(keyword => searchText.includes(keyword));
     return hasParete; // Basta che abbia parete/pareti/wall
    }
    return keywords.some(keyword => searchText.includes(keyword));
   });
  });
 }
 if (currentFilters.advanced.spessori.length > 0) {
  const sel = new Set(currentFilters.advanced.spessori.map(s => s.toLowerCase()));
  filteredProducts = filteredProducts.filter(product => {
   const prodSp = window.khSpessoriOf(`${product.options} ${product.title} ${product.tags}`);
   for (const s of prodSp) { if (sel.has(s.toLowerCase())) return true; }
   return false;
  });
 }
 if (currentFilters.advanced.colori && currentFilters.advanced.colori.length > 0) {
  filteredProducts = filteredProducts.filter(product => {
   const prodCol = window.khColoriOf(product.options).map(c => c.key);
   return currentFilters.advanced.colori.some(sel => prodCol.includes(sel));
  });
 }
 if (currentFilters.advanced.installazione && currentFilters.advanced.installazione.length > 0) {
  filteredProducts = filteredProducts.filter(product => {
   const tagstr = Array.isArray(product.tags) ? product.tags.join(' ') : (product.tags || '');
   const prodIns = window.khInstallOf(`${tagstr} ${product.title}`).map(i => i.key);
   return currentFilters.advanced.installazione.some(sel => prodIns.includes(sel));
  });
 }
 if (currentFilters.advanced.versione && currentFilters.advanced.versione.length > 0) {
  filteredProducts = filteredProducts.filter(product => {
   const prodVer = window.khVersioneOf(product.options).map(v => v.key);
   return currentFilters.advanced.versione.some(sel => prodVer.includes(sel));
  });
 }
 filteredProducts = sortProducts(filteredProducts, currentFilters.sort);
 updateFiltersCounters(filteredProducts);
 if (!keepCurrentPage) {
  currentPage = 1;
 }
displayProducts(filteredProducts);
}
/* KH 2026-07-29: filtro read-only riutilizzabile per l'ANTEPRIMA conteggio (rispecchia il blocco di applyFiltersAndUpdate, senza sort/render) */
function filterProductsBy(baseProducts, f) {
 let out = [...baseProducts];
 if (f.availability === 'available') {
  out = out.filter(product => product.available);
 } else if (f.availability === 'on-sale') {
  out = out.filter(product => (product.comparePrice > product.price) || (product.comparePriceMin > product.priceMin));
 }
 if (f.price && (f.price.min > 0 || f.price.max < 10000)) {
  out = out.filter(product => {
   const price = (product.mqMin > 0) ? product.mqMin : (product.priceVaries ? product.priceMin : product.price);
   const priceInEur = price / 100;
   return priceInEur >= f.price.min && priceInEur <= f.price.max;
  });
 }
 const A = f.advanced || {};
 if (A.categories && A.categories.length > 0) {
  out = out.filter(product => A.categories.some(cat =>
   product.titleWords.includes(cat) || product.typeWords.includes(cat) ||
   product.tagsArray.includes(cat) || product.type.toLowerCase().includes(cat)));
 }
 if (A.brands && A.brands.length > 0) {
  out = out.filter(product => A.brands.some(brand =>
   product.vendor.toLowerCase() === brand.toLowerCase() || product.vendor.toLowerCase().includes(brand.toLowerCase())));
 }
 if (A.formati && A.formati.length > 0) {
  out = out.filter(product => {
   const searchText = `${product.title} ${product.tags} ${product.options}`.toLowerCase();
   return A.formati.some(function(formato) { return window.khFormatoMatches(searchText, formato); });
  });
 }
 if (A.finiture && A.finiture.length > 0) {
  out = out.filter(product => {
   const txt = `${product.options} ${product.tags} ${product.title} ${product.type || ''}`.toLowerCase();
   const prodFin = window.khFinitureOf(txt).map(x => x.key);
   return A.finiture.some(sel => prodFin.includes(sel));
  });
 }
 if (A.ambienti && A.ambienti.length > 0) {
  const ambientiKeywords = {
   'interno': ['interno','interni','indoor','inside'],
   'esterno': ['esterno','outdoor','external','esterni','outside'],
   'parete': ['parete','pareti','wall']
  };
  out = out.filter(product => {
   const searchText = `${product.title} ${product.tags} ${product.type} ${product.options}`.toLowerCase();
   return A.ambienti.some(ambiente => {
    const keywords = ambientiKeywords[ambiente] || [ambiente];
    return keywords.some(keyword => searchText.includes(keyword));
   });
  });
 }
 if (A.spessori && A.spessori.length > 0) {
  const sel = new Set(A.spessori.map(s => s.toLowerCase()));
  out = out.filter(product => {
   const prodSp = window.khSpessoriOf(`${product.options} ${product.title} ${product.tags}`);
   for (const s of prodSp) { if (sel.has(s.toLowerCase())) return true; }
   return false;
  });
 }
 if (A.colori && A.colori.length > 0) {
  out = out.filter(product => {
   const prodCol = window.khColoriOf(product.options).map(c => c.key);
   return A.colori.some(sel => prodCol.includes(sel));
  });
 }
 if (A.installazione && A.installazione.length > 0) {
  out = out.filter(product => {
   const tagstr = Array.isArray(product.tags) ? product.tags.join(' ') : (product.tags || '');
   const prodIns = window.khInstallOf(`${tagstr} ${product.title}`).map(i => i.key);
   return A.installazione.some(sel => prodIns.includes(sel));
  });
 }
 if (A.versione && A.versione.length > 0) {
  out = out.filter(product => {
   const prodVer = window.khVersioneOf(product.options).map(v => v.key);
   return A.versione.some(sel => prodVer.includes(sel));
  });
 }
 return out;
}
/* KH 2026-07-29: anteprima LIVE del conteggio sul bottone "Applica" del pannello mobile (senza applicare/renderizzare) */
function mobilePreviewCount() {
 const content = document.getElementById('fx-mobile-filters-content');
 if (!content || !currentCategory || !dynamicCategories[currentCategory]) return;
 const MAP = { formato:'formati', finitura:'finiture', spessore:'spessori', brand:'brands', colore:'colori', installazione:'installazione', versione:'versione' };
 const cand = { availability: currentFilters.availability, price: currentFilters.price, sort: currentFilters.sort, advanced: {} };
 Object.keys(currentFilters.advanced).forEach(k => { cand.advanced[k] = currentFilters.advanced[k]; });
 Object.values(MAP).forEach(k => { cand.advanced[k] = []; });
 content.querySelectorAll('.fx-mobile-filter-option.selected').forEach(btn => {
  const filter = btn.dataset.filter, value = btn.dataset.value;
  if (filter === 'ordina') { cand.sort = value; return; }
  if (MAP[filter]) (cand.advanced[MAP[filter]] = cand.advanced[MAP[filter]] || []).push(value);
 });
 const n = filterProductsBy(dynamicCategories[currentCategory].products, cand).length;
 const el = document.getElementById('fx-apply-count');
 if (el) el.textContent = `(${n})`;
}
function sortProducts(products, sortType) {
 const sorted = [...products];
 switch (sortType) {
  case 'price-asc':
   return sorted.sort((a, b) => {
    // Piastrelle: ordina sul prezzo €/m² (mqMin). Altri prodotti: prezzo al pezzo.
    const priceA = (a.mqMin > 0) ? a.mqMin : (a.priceVaries ? a.priceMin : a.price);
    const priceB = (b.mqMin > 0) ? b.mqMin : (b.priceVaries ? b.priceMin : b.price);
    return priceA - priceB;
   });
  case 'price-desc':
   return sorted.sort((a, b) => {
    const priceA = (a.mqMin > 0) ? a.mqMin : (a.priceVaries ? a.priceMax : a.price);
    const priceB = (b.mqMin > 0) ? b.mqMin : (b.priceVaries ? b.priceMax : b.price);
    return priceB - priceA;
   });
  case 'best-selling':
   return sorted.sort((a, b) => {
    const scoreA = (a.available ? 2 : 0) + (a.comparePrice > a.price ? 1 : 0);
    const scoreB = (b.available ? 2 : 0) + (b.comparePrice > b.price ? 1 : 0);
    return scoreB - scoreA;
   });
  case 'alphabetical':
   return sorted.sort((a, b) => {
    return a.title.localeCompare(b.title, 'it', { 
     sensitivity: 'base',
     numeric: true,
     ignorePunctuation: true
    });
   });
  case 'newest':
   return sorted.sort((a, b) => a.handle.localeCompare(b.handle));
  case 'recommended':
  default:
   return sorted.sort((a, b) => {
    if (a.available !== b.available) {
     return a.available ? -1 : 1;
    }
    const priceA = (a.mqMin > 0) ? a.mqMin : (a.priceVaries ? a.priceMin : a.price);
    const priceB = (b.mqMin > 0) ? b.mqMin : (b.priceVaries ? b.priceMin : b.price);
    return priceA - priceB;
   });
 }
}
function updateFiltersCounters(filteredProducts) {
 if (!currentCategory || !dynamicCategories[currentCategory]) return;
 const allProducts = dynamicCategories[currentCategory].products;
 const totalProductsEl = document.getElementById('fx-total-products');
 const filteredProductsEl = document.getElementById('fx-filtered-products');
 if (totalProductsEl) totalProductsEl.textContent = allProducts.length;
 if (filteredProductsEl) filteredProductsEl.textContent = filteredProducts.length;
 updateCounterElement('fx-count-all', allProducts.length);
 updateCounterElement('fx-count-available', allProducts.filter(p => p.available).length);
 updateCounterElement('fx-count-on-sale', allProducts.filter(p => 
  (p.comparePrice > p.price) || (p.comparePriceMin > p.priceMin)
 ).length);
 const applyCountEl = document.getElementById('fx-apply-count');
 if (applyCountEl) {
  applyCountEl.textContent = `(${filteredProducts.length})`;
 }
}
function updateCounterElement(id, count) {
 const element = document.getElementById(id);
 if (element) {
  element.textContent = count;
 }
}
var cacheKey = 'fx-products-cache-v2-' + window.location.pathname.replace(/\//g, '_');
var cacheTsKey = cacheKey + '-ts';
/* KH-CARDFIX 2026-10-01: mapping UNICO di una riga del feed khdata (con bpmin/mqmin/boxmin
   gia' calcolati lato server). Usato sia per il feed inline/pag.1 sia per le pagine
   successive (?view=khdata&page=N), cosi' OGNI prodotto -anche oltre il 250- ha il
   prezzo €/mq e €/scatola corretti. Prima le pagine >250 passavano da products.json
   -che NON espone unit_price ne' metafield- e la card cadeva sulla variante piu' economica. */
function _mapFeedRow(r) {
 return {
  title: r.t, type: r.tp, vendor: r.v, tags: r.tg, options: r.o,
  handle: r.h, url: r.u,
  price: r.p || 0, priceMin: r.pm || 0, priceMax: r.px || 0, priceVaries: !!r.pv,
  comparePrice: r.cp || 0, comparePriceMin: r.cm || 0, comparePriceMax: r.cx || 0,
  available: !!r.a, image: r.i || '', imageAlt: r.t, secondImage: r.i2 || '',
  tagsArray: (r.tg || '').split(',').map(function(s){return s.trim()}).filter(function(s){return s}),
  optionsArray: (r.o || '').split(',').map(function(s){return s.trim()}).filter(function(s){return s}),
  titleWords: (r.t || '').toLowerCase().split(/[\s\-_,\.]+/).filter(function(w){return w.length>2}),
  typeWords: (r.tp || '').toLowerCase().split(/[\s\-_,\.]+/).filter(function(w){return w.length>2}),
  vendorWords: (r.v || '').toLowerCase().split(/[\s\-_,\.]+/).filter(function(w){return w.length>2}),
  boxPriceMin: r.bpmin || 0, mqMin: r.mqmin || 0, boxMin: r.boxmin || 0
 };
}
async function loadAllProducts() {
 try {
  var cached = sessionStorage.getItem(cacheKey);
  var cacheTs = sessionStorage.getItem(cacheTsKey);
  if (cached && cacheTs && (Date.now() - parseInt(cacheTs)) < 300000) {
   allProducts = JSON.parse(cached);
   if (allProducts.length > 0) { loadAdditionalPages(); return; }
  }
 } catch(e) {}
 var raw = null;
 try {
  /* KH-KHDATA-PRELOAD 2026-10-06: se theme.liquid ha gia' avviato il fetch in <head>, consumalo (dati pronti prima). Altrimenti fetch normale. */
  if (window.__khDataPromise) {
   raw = await window.__khDataPromise;
  } else {
   var _collUrl = window.location.pathname.replace(/\/$/, '');
   var _resp = await fetch(_collUrl + '?view=khdata');
   if (_resp.ok) { raw = await _resp.json(); }
  }
 } catch(e) { raw = null; }
 if (!raw || !raw.length) {
  var _jsonEl = document.getElementById('fx-products-json');
  if (_jsonEl) { try { raw = JSON.parse(_jsonEl.textContent); } catch(e) { raw = null; } }
 }
 if (raw && raw.length) {
  allProducts = [];
  for (var i = 0; i < raw.length; i++) {
   var r = raw[i];
   if (!r.t || !r.u) continue;
   allProducts.push(_mapFeedRow(r));
  }
  raw = null;
 } else {
  allProducts = [];
  document.querySelectorAll('.fx-product-data').forEach(function(el) {
   var d = el.dataset;
   if (!d.productTitle || !d.productUrl) return;
   allProducts.push({
    title: d.productTitle||'', type: d.productType||'', vendor: d.productVendor||'',
    tags: d.productTags||'', options: d.productOptions||'', handle: d.productHandle||'',
    url: d.productUrl||'', price: parseFloat(d.productPrice)||0,
    priceMin: parseFloat(d.productPriceMin)||0, priceMax: parseFloat(d.productPriceMax)||0,
    priceVaries: d.productPriceVaries==='true',
    comparePrice: parseFloat(d.productComparePrice)||0,
    comparePriceMin: parseFloat(d.productComparePriceMin)||0,
    comparePriceMax: parseFloat(d.productComparePriceMax)||0,
    available: d.productAvailable==='true', image: d.productImage||'',
    imageAlt: d.productImageAlt||'', secondImage: d.productSecondImage||'',
    tagsArray: (d.productTags||'').split(',').map(function(s){return s.trim().toLowerCase()}).filter(function(s){return s}),
    optionsArray: (d.productOptions||'').split(',').map(function(s){return s.trim().toLowerCase()}).filter(function(s){return s}),
    titleWords: (d.productTitle||'').toLowerCase().split(/[\s\-_,\.]+/).filter(function(w){return w.length>2}),
    typeWords: (d.productType||'').toLowerCase().split(/[\s\-_,\.]+/).filter(function(w){return w.length>2}),
    vendorWords: (d.productVendor||'').toLowerCase().split(/[\s\-_,\.]+/).filter(function(w){return w.length>2})
   });
  });
 }
 try { sessionStorage.setItem(cacheKey, JSON.stringify(allProducts)); sessionStorage.setItem(cacheTsKey, Date.now().toString()); } catch(e) {}
 loadAdditionalPages();
}
function _fxResizeImg(url, w) {
 if (!url) return '';
 url = url.replace(/^https?:/, '');
 return url + (url.includes('?') ? '&' : '?') + 'width=' + w;
}
function _fxTransformAjaxProduct(p, collectionUrl) {
 var prices = [], compares = [];
 var opts = '';
 (p.variants || []).forEach(function(v) {
  prices.push(Math.round(parseFloat(v.price || 0) * 100));
  if (v.compare_at_price) compares.push(Math.round(parseFloat(v.compare_at_price) * 100));
  if (v.option1) opts += v.option1 + ',';
  if (v.option2) opts += v.option2 + ',';
  if (v.option3) opts += v.option3 + ',';
 });
 if (prices.length === 0) prices = [0];
 var pm = Math.min.apply(null, prices);
 var px = Math.max.apply(null, prices);
 var cm = compares.length > 0 ? Math.min.apply(null, compares) : 0;
 var cx = compares.length > 0 ? Math.max.apply(null, compares) : 0;
 var avail = (p.variants || []).some(function(v) { return v.available; });
 var tags = Array.isArray(p.tags) ? p.tags.join(',').toLowerCase() : (p.tags || '').toLowerCase();
 var img = '', img2 = '';
 if (p.images && p.images.length > 0) {
  img = _fxResizeImg(p.images[0].src || '', 600);
  if (p.images.length > 1) img2 = _fxResizeImg(p.images[1].src || '', 600);
 }
 var title = p.title || '';
 var type = (p.product_type || '').toLowerCase();
 var vendor = (p.vendor || '').toLowerCase();
 return {
  title: title, type: type, vendor: vendor, tags: tags, options: opts.toLowerCase(),
  handle: p.handle || '', url: collectionUrl + '/products/' + (p.handle || ''),
  price: pm, priceMin: pm, priceMax: px, priceVaries: pm !== px,
  comparePrice: cx, comparePriceMin: cm, comparePriceMax: cx,
  available: avail, image: img, imageAlt: title, secondImage: img2,
  tagsArray: tags.split(',').map(function(s){return s.trim()}).filter(function(s){return s}),
  optionsArray: opts.toLowerCase().split(',').map(function(s){return s.trim()}).filter(function(s){return s}),
  titleWords: title.toLowerCase().split(/[\s\-_,\.]+/).filter(function(w){return w.length>2}),
  typeWords: type.split(/[\s\-_,\.]+/).filter(function(w){return w.length>2}),
  vendorWords: vendor.split(/[\s\-_,\.]+/).filter(function(w){return w.length>2}),
  boxPriceMin: 0
 };
}
async function loadAdditionalPages() {
 analyzeAllProductsAndCreateCategories();
 try {
  const collectionUrl = window.location.pathname.replace(/\/$/, '');
  const existingHandles = new Set(allProducts.map(p => p.handle));
  const totalBefore = allProducts.length;
  /* KH-CARDFIX 2026-10-01: le pagine oltre la 1 (il feed inline/pag.1 copre max 250
     prodotti, cap di Shopify) si leggono dallo STESSO feed khdata, non da products.json.
     Cosi' ogni prodotto porta bpmin/mqmin/boxmin corretti e la card mostra la scatola
     che corrisponde al €/mq, non la variante piu' economica. */
  let startPage = Math.max(2, Math.ceil(allProducts.length / 250) + 1);
  let done = false;
  while (!done && startPage <= 100) {
   const batch = [];
   for (let p = startPage; p < startPage + 4 && p <= 100; p++) {
    batch.push(fetch(collectionUrl + '?view=khdata&page=' + p).then(function(r) { return r.ok ? r.json() : null; }).catch(function() { return null; }));
   }
   const results = await Promise.all(batch);
   let batchHadProducts = false, reachedEnd = false;
   for (const data of results) {
    if (!Array.isArray(data)) continue;
    if (data.length === 0) { reachedEnd = true; continue; }
    batchHadProducts = true;
    data.forEach(function(r) {
     if (!r.t || !r.u || existingHandles.has(r.h)) return;
     existingHandles.add(r.h);
     allProducts.push(_mapFeedRow(r));
    });
   }
   if (reachedEnd || !batchHadProducts) done = true;
   startPage += 4;
  }
  if (allProducts.length > totalBefore) {
   displayedProductsCount = 0;
   analyzeAllProductsAndCreateCategories();
   applyFiltersAndUpdate();
  }
  try { sessionStorage.setItem(cacheKey, JSON.stringify(allProducts)); sessionStorage.setItem(cacheTsKey, Date.now().toString()); } catch(e) {}
 } catch (error) {}
}
function analyzeAllProductsAndCreateCategories() {
 dynamicCategories = {};
 Object.keys(baseCategoryTemplates).forEach(categoryKey => {
  dynamicCategories[categoryKey] = {
   ...baseCategoryTemplates[categoryKey],
   products: [],
   detectedKeywords: new Set(),
   confidence: 0
  };
 });
 allProducts.forEach(product => {
  const productAnalysis = analyzeProductForCategories(product);
  let assigned = false;
  /* PRIORITA' categoria primaria (da product_type/parole forti) - evita match errati per keyword generiche tipo 'bagno' */
  var _pc = productAnalysis.primaryCategory;
  if (_pc && dynamicCategories[_pc]) {
   dynamicCategories[_pc].products.push(product);
   productAnalysis.allWords.forEach(function(word){ dynamicCategories[_pc].detectedKeywords.add(word); });
   assigned = true;
  }
  if (!assigned) for (const categoryKey in dynamicCategories) {
   if (productMatchesCategory(product, productAnalysis, categoryKey)) {
    dynamicCategories[categoryKey].products.push(product);
    productAnalysis.allWords.forEach(word => {
     dynamicCategories[categoryKey].detectedKeywords.add(word);
    });
    assigned = true;
    break;
   }
  }
  if (!assigned) {
   const newCategory = createDynamicCategory(product, productAnalysis);
   if (newCategory) {
    const categoryKey = newCategory.key;
    dynamicCategories[categoryKey] = newCategory.data;
   }
  }
 });
 Object.keys(dynamicCategories).forEach(categoryKey => {
  if (dynamicCategories[categoryKey].products.length === 0) {
   delete dynamicCategories[categoryKey];
  }
 });
 Object.keys(dynamicCategories).forEach(categoryKey => {
  const category = dynamicCategories[categoryKey];
  category.confidence = calculateCategoryConfidence(category);
 });
 updateLandingWithDynamicCategories();
}
function analyzeProductForCategories(product) {
 const allWords = [
  ...product.titleWords,
  ...product.typeWords,
  ...product.vendorWords,
  ...product.tagsArray
 ].filter(word => word.length > 2);
 const uniqueWords = [...new Set(allWords)];
 const mainKeywords = identifyMainKeywords(uniqueWords, product.title);
 return {
  allWords: uniqueWords,
  mainKeywords: mainKeywords,
  primaryCategory: detectPrimaryCategory(uniqueWords, product.title),
  productType: product.type || 'unknown'
 };
}
function identifyMainKeywords(words, title) {
 const titleLower = title.toLowerCase();
 const titleWords = words.filter(word => titleLower.includes(word));
 const significantWords = words.filter(word => 
  word.length > 4 && 
  !isCommonWord(word)
 );
 return [...new Set([...titleWords, ...significantWords])].slice(0, 10);
}
function isCommonWord(word) {
 const commonWords = [
  'con', 'per', 'and', 'the', 'una', 'uno', 'del', 'della', 'con', 'nero', 'bianco', 
  'rosso', 'blu', 'verde', 'grande', 'piccolo', 'nuovo', 'usato', 'cm', 'mm', 'kg',
  'set', 'pack', 'kit', 'pezzo', 'pezzi', 'made', 'italy', 'design', 'style',
  'modern', 'classic', 'vintage', 'luxury', 'premium', 'standard', 'basic'
 ];
 return commonWords.includes(word.toLowerCase());
}
function detectPrimaryCategory(words, title) {
 const titleLower = title.toLowerCase();
 if (words.some(word => ['piastrella', 'piastrelle', 'tile', 'tiles', 'mattonella', 'mattonelle', 'ceramica', 'gres', 'porcellanato'].includes(word)) ||
   titleLower.includes('piastrella') || titleLower.includes('piastrelle') || 
   titleLower.includes('tile') || titleLower.includes('tiles') || 
   titleLower.includes('mattonella') || titleLower.includes('mattonelle') ||
   titleLower.includes('gres') || titleLower.includes('porcellanato')) {
  return 'piastrelle';
 }
 if (words.some(word => ['wc', 'bidet', 'lavabo', 'lavandino', 'toilet', 'sanitario', 'sanitari', 'water', 'vaso'].includes(word)) ||
   titleLower.includes('wc') || titleLower.includes('bidet') || 
   titleLower.includes('lavabo') || titleLower.includes('lavandino') ||
   titleLower.includes('toilet') || titleLower.includes('sanitario') ||
   titleLower.includes('water') || titleLower.includes('vaso')) {
  return 'sanitari';
 }
 if (words.some(word => ['vasca', 'bath', 'bathtub', 'jacuzzi', 'idromassaggio', 'whirlpool'].includes(word)) ||
   (titleLower.includes('vasca') && !titleLower.includes('lavabo')) || 
   titleLower.includes('bath') || titleLower.includes('jacuzzi') ||
   titleLower.includes('idromassaggio') || titleLower.includes('whirlpool')) {
  return 'vasche';
 }
 if (words.some(word => ['rubinetto', 'rubinetti', 'miscelatore', 'miscelatori', 'faucet', 'tap'].includes(word)) ||
   titleLower.includes('rubinetto') || titleLower.includes('rubinetti') || 
   titleLower.includes('miscelatore') || titleLower.includes('miscelatori') ||
   titleLower.includes('faucet') || titleLower.includes('tap')) {
  return 'rubinetti';
 }
 if (words.some(word => ['scrivania', 'scrivanie', 'desk', 'bureau'].includes(word)) ||
   (titleLower.includes('scrivania') || titleLower.includes('scrivanie') || titleLower.includes('desk')) &&
   !titleLower.includes('tavolo') && !titleLower.includes('table')) {
  return 'scrivanie';
 }
 if ((words.some(word => ['sedia', 'chair'].includes(word)) && 
   words.some(word => ['girevole', 'girevoli', 'ufficio', 'gaming', 'ergonomica', 'office', 'operativa'].includes(word))) ||
   (titleLower.includes('sedia') && (titleLower.includes('ufficio') || titleLower.includes('gaming') || 
   titleLower.includes('girevole') || titleLower.includes('ergonomica') || titleLower.includes('operativa')))) {
  return 'sedie-girevoli';
 }
 if (words.some(word => ['sedia', 'sedie', 'poltrona', 'poltrone', 'chair', 'armchair'].includes(word)) ||
   titleLower.includes('sedia') || titleLower.includes('sedie') || 
   titleLower.includes('poltrona') || titleLower.includes('poltrone')) {
  return 'sedie-poltrone';
 }
 if (words.some(word => ['divano', 'divani', 'sofa', 'sofà', 'couch'].includes(word)) ||
   titleLower.includes('divano') || titleLower.includes('divani') || 
   titleLower.includes('sofa') || titleLower.includes('sofà')) {
  return 'divani';
 }
 if (words.some(word => ['tavolo', 'tavoli', 'table', 'tavolino', 'tavolini'].includes(word)) ||
   titleLower.includes('tavolo') || titleLower.includes('tavoli') || 
   titleLower.includes('table') || titleLower.includes('tavolino') || titleLower.includes('tavolini')) {
  return 'tavoli';
 }
 if ((words.some(word => ['mobile', 'mobili', 'arredo', 'specchio', 'specchi', 'mobiletto', 'mobiletti'].includes(word)) && 
   words.some(word => ['bagno', 'bathroom'].includes(word))) ||
   (titleLower.includes('mobile') && titleLower.includes('bagno')) ||
   (titleLower.includes('specchio') && titleLower.includes('bagno')) ||
   (titleLower.includes('arredo') && titleLower.includes('bagno'))) {
  return 'arredo-bagno';
 }
 if (words.some(word => ['lampada', 'lampade', 'lampadario', 'lampadari', 'luce', 'luci', 'light', 'illuminazione', 'applique', 'faretto', 'faretti'].includes(word)) ||
   titleLower.includes('lampada') || titleLower.includes('lampade') || 
   titleLower.includes('lampadario') || titleLower.includes('lampadari') ||
   titleLower.includes('luce') || titleLower.includes('luci') ||
   titleLower.includes('faretto') || titleLower.includes('faretti')) {
  return 'illuminazione';
 }
 if (words.some(word => ['materasso', 'materassi', 'mattress', 'memory', 'foam', 'latex', 'lattice'].includes(word)) ||
   titleLower.includes('materasso') || titleLower.includes('materassi') || 
   titleLower.includes('mattress') || titleLower.includes('memory')) {
  return 'materassi';
 }
 if (words.some(word => ['frigorifero', 'forno', 'lavastoviglie', 'lavatrice', 'microonde', 'congelatore', 'freezer'].includes(word)) ||
   titleLower.includes('frigorifero') || titleLower.includes('forno') || 
   titleLower.includes('lavastoviglie') || titleLower.includes('lavatrice') ||
   titleLower.includes('microonde') || titleLower.includes('congelatore')) {
  return 'elettrodomestici';
 }
 if (words.some(word => ['cucina', 'cucine', 'kitchen', 'componibile', 'ante', 'pensili'].includes(word)) ||
   (titleLower.includes('cucina') && !titleLower.includes('rubinetto') && !titleLower.includes('lavello'))) {
  return 'cucine';
 }
 return null;
}
function productMatchesCategory(product, analysis, categoryKey) {
 const category = dynamicCategories[categoryKey];
 if (analysis.primaryCategory === categoryKey) {
  return true;
 }
 const categoryKeywords = category.keywords || [];
 const matchingKeywords = analysis.allWords.filter(word => 
  categoryKeywords.some(keyword => 
   word.includes(keyword) || keyword.includes(word)
  )
 );
 const threshold = Math.max(1, Math.ceil(categoryKeywords.length * 0.1));
 return matchingKeywords.length >= threshold;
}
function createDynamicCategory(product, analysis) {
 const mainKeyword = analysis.mainKeywords[0] || analysis.allWords[0];
 if (!mainKeyword || mainKeyword.length < 3) {
  return null;
 }
 const categoryName = generateCategoryName(mainKeyword, analysis);
 const categoryKey = categoryName.toLowerCase()
  .replace(/[àáâãäå]/g, 'a')
  .replace(/[èéêë]/g, 'e')
  .replace(/[ìíîï]/g, 'i')
  .replace(/[òóôõö]/g, 'o')
  .replace(/[ùúûü]/g, 'u')
  .replace(/[ç]/g, 'c')
  .replace(/[ñ]/g, 'n')
  .replace(/[^a-z0-9]/g, '-')
  .replace(/-+/g, '-')
  .replace(/^-|-$/g, '');
 if (dynamicCategories[categoryKey]) {
  return null;
 }
 const description = generateCategoryDescription(categoryName, analysis);
 const icon = generateCategoryIcon(categoryName, mainKeyword);
 return {
  key: categoryKey,
  data: {
   keywords: analysis.mainKeywords,
   icon: icon,
   title: categoryName,
   desc: description,
   products: [product],
   detectedKeywords: new Set(analysis.allWords),
   confidence: 0.5,
   isDynamic: true
  }
 };
}
function generateCategoryName(mainKeyword, analysis) {
 const name = mainKeyword.charAt(0).toUpperCase() + mainKeyword.slice(1);
 const pluralMap = {
  'armadio': 'Armadi',
  'letto': 'Letti',
  'mobile': 'Mobili',
  'libreria': 'Librerie',
  'vetrina': 'Vetrine',
  'cassettiera': 'Cassettiere',
  'comodino': 'Comodini',
  'guardaroba': 'Guardaroba',
  'mensola': 'Mensole',
  'scaffale': 'Scaffali',
  'quadro': 'Quadri',
  'specchio': 'Specchi',
  'tappeto': 'Tappeti',
  'tenda': 'Tende',
  'cuscino': 'Cuscini',
  'vaso': 'Vasi',
  'pianta': 'Piante',
  'decorazione': 'Decorazioni',
  'gioiello': 'Gioielli',
  'orologio': 'Orologi',
  'borsa': 'Borse',
  'scarpa': 'Scarpe',
  'abbigliamento': 'Abbigliamento',
  'giocattolo': 'Giocattoli',
  'libro': 'Libri',
  'strumento': 'Strumenti',
  'attrezzo': 'Attrezzi',
  'utensile': 'Utensili'
 };
 return pluralMap[mainKeyword] || name;
}
function generateCategoryDescription(categoryName, analysis) {
 const templates = [
  `${categoryName} di alta qualità per la tua casa`,
  `Scopri la nostra collezione di ${categoryName.toLowerCase()}`,
  `${categoryName} moderni e di design`,
  `Ampia selezione di ${categoryName.toLowerCase()}`,
  `${categoryName} per ogni esigenza e stile`,
  `I migliori ${categoryName.toLowerCase()} per te`,
  `${categoryName} eleganti e funzionali`,
  `Trova i ${categoryName.toLowerCase()} perfetti`
 ];
 return templates[Math.floor(Math.random() * templates.length)];
}
function generateCategoryIcon(categoryName, mainKeyword) {
 const iconMap = {
  'armadi': `<svg width="48" height="48" viewBox="0 0 24 24" fill="none">
   <rect x="5" y="4" width="14" height="16" rx="1" stroke="currentColor" stroke-width="2" fill="none"/>
   <line x1="12" y1="4" x2="12" y2="20" stroke="currentColor" stroke-width="2"/>
   <circle cx="9" cy="10" r="1" fill="currentColor"/>
   <circle cx="15" cy="10" r="1" fill="currentColor"/>
  </svg>`,
  'letti': `<svg width="48" height="48" viewBox="0 0 24 24" fill="none">
   <rect x="3" y="10" width="18" height="6" rx="1" stroke="currentColor" stroke-width="2" fill="none"/>
   <line x1="3" y1="13" x2="21" y2="13" stroke="currentColor" stroke-width="2"/>
   <rect x="6" y="6" width="12" height="4" rx="1" stroke="currentColor" stroke-width="2" fill="none"/>
   <line x1="6" y1="16" x2="6" y2="18" stroke="currentColor" stroke-width="2"/>
   <line x1="18" y1="16" x2="18" y2="18" stroke="currentColor" stroke-width="2"/>
  </svg>`,
  'mobili': `<svg width="48" height="48" viewBox="0 0 24 24" fill="none">
   <rect x="4" y="6" width="16" height="12" rx="1" stroke="currentColor" stroke-width="2" fill="none"/>
   <line x1="4" y1="12" x2="20" y2="12" stroke="currentColor" stroke-width="2"/>
   <circle cx="7" cy="9" r="1" fill="currentColor"/>
   <circle cx="17" cy="15" r="1" fill="currentColor"/>
   <line x1="10" y1="18" x2="10" y2="20" stroke="currentColor" stroke-width="2"/>
   <line x1="14" y1="18" x2="14" y2="20" stroke="currentColor" stroke-width="2"/>
  </svg>`,
  'librerie': `<svg width="48" height="48" viewBox="0 0 24 24" fill="none">
   <rect x="5" y="3" width="14" height="18" rx="1" stroke="currentColor" stroke-width="2" fill="none"/>
   <line x1="5" y1="8" x2="19" y2="8" stroke="currentColor" stroke-width="2"/>
   <line x1="5" y1="13" x2="19" y2="13" stroke="currentColor" stroke-width="2"/>
   <line x1="5" y1="18" x2="19" y2="18" stroke="currentColor" stroke-width="2"/>
   <line x1="9" y1="3" x2="9" y2="8" stroke="currentColor" stroke-width="2"/>
   <line x1="15" y1="3" x2="15" y2="8" stroke="currentColor" stroke-width="2"/>
  </svg>`,
  'specchi': `<svg width="48" height="48" viewBox="0 0 24 24" fill="none">
   <circle cx="12" cy="12" r="8" stroke="currentColor" stroke-width="2" fill="none"/>
   <circle cx="12" cy="12" r="5" stroke="currentColor" stroke-width="2" fill="none"/>
   <circle cx="12" cy="12" r="2" stroke="currentColor" stroke-width="2" fill="none"/>
   <circle cx="12" cy="12" r="0.5" fill="currentColor"/>
  </svg>`,
  'quadri': `<svg width="48" height="48" viewBox="0 0 24 24" fill="none">
   <rect x="4" y="5" width="16" height="12" rx="1" stroke="currentColor" stroke-width="2" fill="none"/>
   <path d="M8 13L10 11L14 15L16 13" stroke="currentColor" stroke-width="2" fill="none"/>
   <circle cx="9" cy="9" r="1" fill="currentColor"/>
   <line x1="12" y1="17" x2="12" y2="19" stroke="currentColor" stroke-width="2"/>
  </svg>`,
  'default': `<svg width="48" height="48" viewBox="0 0 24 24" fill="none">
   <rect x="4" y="4" width="16" height="16" rx="2" stroke="currentColor" stroke-width="2" fill="none"/>
   <circle cx="12" cy="12" r="3" stroke="currentColor" stroke-width="2" fill="none"/>
   <circle cx="12" cy="12" r="1" fill="currentColor"/>
  </svg>`
 };
 const key = categoryName.toLowerCase();
 return iconMap[key] || iconMap['default'];
}
function calculateCategoryConfidence(category) {
 const productCount = category.products.length;
 const keywordCount = category.detectedKeywords.size;
 const isBaseCategory = !category.isDynamic;
 let confidence = 0;
 confidence += Math.min(productCount / 10, 1) * 0.5;
 confidence += Math.min(keywordCount / 5, 1) * 0.3;
 if (isBaseCategory) {
  confidence += 0.2;
 }
 return Math.min(confidence, 1);
}
function updateLandingWithDynamicCategories() {
 const categoriesGrid = document.getElementById('fx-dynamic-categories-grid');
 if (!categoriesGrid) return;
 categoriesGrid.innerHTML = '';
 const sortedCategories = Object.entries(dynamicCategories)
  .sort(([,a], [,b]) => {
   if (a.confidence !== b.confidence) {
    return b.confidence - a.confidence;
   }
   return b.products.length - a.products.length;
  });
 sortedCategories.forEach(([categoryKey, category]) => {
  const card = document.createElement('a');
  card.href = `#${categoryKey}`;
  card.className = 'fx-category-landing-card';
  card.dataset.category = categoryKey;
  card.innerHTML = `
   <div class="fx-category-landing-icon">
    ${category.icon}
   </div>
   <h3 class="fx-category-landing-title">${category.title}</h3>
   <p class="fx-category-landing-desc">${category.desc}</p>
   <div class="fx-category-landing-arrow">→</div>
  `;
  categoriesGrid.appendChild(card);
 });
 initCategoryCardListeners();
}
function initCategoryCardListeners() {
 const categoryCards = document.querySelectorAll('.fx-category-landing-card');
 categoryCards.forEach(card => {
  card.addEventListener('click', function(e) {
   e.preventDefault();
   const category = this.dataset.category;
   if (category && dynamicCategories[category] && dynamicCategories[category].products.length > 0) {
    showCategory(category);
   }
  });
 });
}
function showCategory(category) {
 if (!dynamicCategories[category] || dynamicCategories[category].products.length === 0) {
  showNoProducts();
  return;
 }
 currentCategory = category;
 currentPage = 1;
 resetAllFilters();
 populateAllFilters();
 populateCompactDropdowns();
 if (window.innerWidth > 900) {
  setTimeout(() => {
   initSidebarStopSystem();
  }, 100);
 } else {
  setTimeout(() => {
   initMobileFiltersState();
  }, 100);
 }
 const landing = document.getElementById('fx-categories-landing');
 const categoryPage = document.getElementById('fx-category-page');
 if (landing) landing.style.display = 'none';
 if (categoryPage) categoryPage.style.display = 'block';
 updateCategoryInfo(category);
 requestAnimationFrame(() => {
  updateFiltersCounters(dynamicCategories[category].products);
  applyFiltersAndUpdate();
 });
 window.location.hash = category;
}
function showLanding() {
 showAllProducts();
}
function showAllProducts() {
 currentCategory = 'tutti';
 currentPage = 1;
 if (!dynamicCategories['tutti']) {
  dynamicCategories['tutti'] = {
   title: (document.querySelector('.fx-category-title') ? document.querySelector('.fx-category-title').textContent : (window._collectionTitle || 'Tutti i Prodotti')),
   products: allProducts,
   detectedKeywords: new Set(),
   confidence: 100
  };
 } else {
  dynamicCategories['tutti'].products = allProducts;
 }
 resetAllFilters();
 populateAllFilters();
 if (window.innerWidth > 900) {
  setTimeout(() => {
   initSidebarStopSystem();
  }, 100);
 } else {
  setTimeout(() => {
   initMobileFiltersState();
  }, 100);
 }
 const landing = document.getElementById('fx-categories-landing');
 const categoryPage = document.getElementById('fx-category-page');
 if (landing) landing.style.display = 'none';
 if (categoryPage) categoryPage.style.display = 'block';
 const categoryTitleEl = document.getElementById('fx-category-title');
 if (categoryTitleEl) categoryTitleEl.textContent = (window._collectionTitle || 'Tutti i Prodotti');
 requestAnimationFrame(() => {
  updateFiltersCounters(allProducts);
  applyFiltersAndUpdate();
 });
 window.location.hash = '';
}
function updateCategoryInfo(category) {
 const categoryData = dynamicCategories[category];
 const categoryName = categoryData?.title || category;
 const categoryTitleEl = document.getElementById('fx-category-title');
 if (categoryTitleEl) categoryTitleEl.textContent = categoryName;
}
function updatePagination(totalProducts) {
 const paginationContainer = document.getElementById('fx-pagination-container');
 const paginationNumbers = document.getElementById('fx-pagination-numbers');
 const prevButton = document.getElementById('fx-prev-page');
 const nextButton = document.getElementById('fx-next-page');
 if (!paginationContainer || !paginationNumbers || !prevButton || !nextButton) {
  return;
 }
 totalPages = Math.ceil(totalProducts / productsPerPage);
 if (totalPages <= 1) {
  paginationContainer.style.display = 'none';
  return;
 }
 paginationContainer.style.display = 'block';
 if (currentPage > 1) {
  prevButton.style.display = 'flex';
  prevButton.onclick = function(e) {
   e.preventDefault();
   e.stopPropagation();
   changePage(currentPage - 1);
   return false;
  };
 } else {
  prevButton.style.display = 'none';
 }
 if (currentPage < totalPages) {
  nextButton.style.display = 'flex';
  nextButton.onclick = function(e) {
   e.preventDefault();
   e.stopPropagation();
   changePage(currentPage + 1);
   return false;
  };
 } else {
  nextButton.style.display = 'none';
 }
 paginationNumbers.innerHTML = '';
 let startPage = Math.max(1, currentPage - 2);
 let endPage = Math.min(totalPages, currentPage + 2);
 if (endPage - startPage < 4) {
  if (startPage === 1) {
   endPage = Math.min(totalPages, startPage + 4);
  } else if (endPage === totalPages) {
   startPage = Math.max(1, endPage - 4);
  }
 }
 for (let i = startPage; i <= endPage; i++) {
  addPageNumber(i);
 }
}
function addPageNumber(pageNum) {
 const paginationNumbers = document.getElementById('fx-pagination-numbers');
 if (!paginationNumbers) {
  return;
 }
 const pageButton = document.createElement('button');
 pageButton.type = 'button';
 pageButton.className = `Pagination__NavItem ${pageNum === currentPage ? 'is-active' : ''}`;
 pageButton.textContent = pageNum;
 pageButton.onclick = function(e) {
  e.preventDefault();
  e.stopPropagation();
  changePage(pageNum);
  return false;
 };
 paginationNumbers.appendChild(pageButton);
}
function changePage(newPage) {
 if (newPage < 1 || newPage > totalPages) {
  return;
 }
 if (newPage === currentPage) {
  return;
 }
 currentPage = newPage;
 window.scrollTo({ top: 0, behavior: 'smooth' });
 applyFiltersAndUpdate(true);
}
let allFilteredProducts = [];
let displayedProductsCount = 0;
const PRODUCTS_PER_LOAD = 24; // Carica 24 prodotti alla volta
let isLoadingMore = false;
function displayProducts(products) {
 hideLoading();
 const resultsContainer = document.getElementById('fx-category-results');
 const grid = document.getElementById('fx-products-grid');
 const countElement = document.getElementById('fx-products-count');
 const paginationContainer = document.getElementById('fx-pagination-container');
 if (!resultsContainer || !grid || !countElement) {
  return;
 }
 allFilteredProducts = products;
 displayedProductsCount = 0;
 countElement.textContent = products.length;
 if (paginationContainer) {
  paginationContainer.style.display = 'none';
 }
 if (products.length === 0) {
  // Mostra "nessun prodotto" SOLO se i prodotti sono gia' caricati ma il filtro non trova nulla.
  // Se allProducts e' ancora vuoto siamo in fase di caricamento -> non mostrare il messaggio (evita il flash).
  if (typeof allProducts !== 'undefined' && allProducts.length > 0) {
   if (grid) grid.innerHTML = '';
   showNoProducts();
  }
  return;
 }
 loadMoreProducts();
 resultsContainer.style.display = 'block';
 /* Assicurati che tutta la catena di parent sia visibile */
 var categoryPage = document.getElementById('fx-category-page');
 if (categoryPage) categoryPage.style.display = 'block';
 var categoryMain = document.querySelector('.fx-category-main');
 if (categoryMain) categoryMain.style.display = 'block';
 const noProducts = document.getElementById('fx-no-products');
 if (noProducts) noProducts.style.display = 'none';
 if (window.innerWidth > 900 && currentCategory) {
  setTimeout(() => {
   checkSidebarPosition();
  }, 200);
 }
 initInfiniteScroll();
}
function _renderEffectCards(effectKey, effectProducts) {
 const effectGrid = document.getElementById(`effect-grid-${effectKey}`);
 if (!effectGrid || effectGrid.childElementCount > 0) return;
 /* KH-LAZYCAROUSEL 2026-10-07: NON renderizzo TUTTE le card (es. bagno 228) -> solo le prime, poi
    AGGIUNGO man mano che scorri verso la fine (lazy-append orizzontale). Il DOM resta leggero SEMPRE,
    con 50 o 5000 prodotti -> caroselli fluidi su OGNI pagina a prescindere dal numero di prodotti.
    (prima: tutte le card nel DOM -> jank proporzionale al totale prodotti). */
 const INITIAL = 12, STEP = 8, AHEAD = 1.5; /* carica il prossimo blocco entro 1.5 schermate dalla fine */
 let rendered = 0;
 function appendBatch(n) {
  const slice = effectProducts.slice(rendered, rendered + n);
  if (slice.length === 0) return;
  const f = document.createDocumentFragment();
  slice.forEach((p) => { f.appendChild(createProductCard(p, effectKey)); });
  effectGrid.appendChild(f);
  rendered += slice.length;
 }
 appendBatch(INITIAL);
 initEffectCarousel(effectKey);
 initWishlistButtons();
 if (rendered < effectProducts.length) {
  let busy = false;
  const onScroll = function() {
   if (rendered >= effectProducts.length) { effectGrid.removeEventListener('scroll', onScroll); return; }
   if (busy) return;
   if (effectGrid.scrollLeft + effectGrid.clientWidth >= effectGrid.scrollWidth - effectGrid.clientWidth * AHEAD) {
    busy = true;
    requestAnimationFrame(function() { appendBatch(STEP); initWishlistButtons(); busy = false; });
   }
  };
  effectGrid.addEventListener('scroll', onScroll, { passive: true });
 }
}
function loadMoreProducts() {
 if (isLoadingMore || displayedProductsCount >= allFilteredProducts.length) {
  return;
 }
 isLoadingMore = true;
 const grid = document.getElementById('fx-products-grid');
 if (!grid) return;
 const startIndex = displayedProductsCount;
 const endIndex = Math.min(startIndex + PRODUCTS_PER_LOAD, allFilteredProducts.length);
 const productsToShow = allFilteredProducts.slice(startIndex, endIndex);
 if (displayedProductsCount === 0) {
  grid.innerHTML = '';
  grid.removeAttribute('data-ssr'); grid.style.opacity = ''; grid.style.height = ''; grid.style.overflow = '';
  const _groupResult = groupProductsByEffect(allFilteredProducts);
  const allGrouped = _groupResult.grouped;
  const allNoEffect = _groupResult.noEffect;
  /* Se non ci sono effetti, mostra i prodotti direttamente senza sezioni */
  if (Object.keys(allGrouped).length === 0 && allNoEffect.length > 0) {
   allNoEffect.forEach(function(product) { grid.appendChild(createProductCard(product)); });
   displayedProductsCount = allNoEffect.length;
   isLoadingMore = false;
   return;
  }
  populateEffectsNavBar(allGrouped);
  const allSortedEffects = Object.entries(allGrouped).sort((a, b) => b[1].length - a[1].length);
  const _sectionsFragment = document.createDocumentFragment();
  allSortedEffects.forEach(([effectKey, effectProducts]) => {
   const effectData = EFFECTS_DEFINITIONS[effectKey];
   if (!effectData) return;
   const section = document.createElement('div');
   section.className = 'fx-effect-section';
   section.id = `effect-${effectKey}`;
   const hasEffettoPrefix = /^Effetto\s/i.test(effectData.name);
   const effectNameOnly = effectData.name.replace(/^Effetto\s*/i, '');
   const productCount = effectProducts.length;
   section.innerHTML = `
    <div class="fx-effect-section-header">
     <h3 class="fx-effect-section-title">
      ${hasEffettoPrefix ? '<span class="fx-effect-title-prefix">Effetto</span>' : ''}
      <span class="fx-effect-title-name">${effectNameOnly}</span>
     </h3>
     <div class="fx-effect-section-actions">
      <span class="fx-effect-section-count">${productCount} ${productCount === 1 ? 'prodotto' : 'prodotti'}</span>
      <div class="fx-effect-nav-arrows">
       <button class="fx-nav-arrow fx-nav-arrow-prev" aria-label="Precedente" type="button">
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
         <path d="M15 18l-6-6 6-6"/>
        </svg>
       </button>
       <button class="fx-nav-arrow fx-nav-arrow-next" aria-label="Successivo" type="button">
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
         <path d="M9 18l6-6-6-6"/>
        </svg>
       </button>
      </div>
     </div>
    </div>
    <div class="fx-effect-carousel-wrapper">
     <div class="fx-effect-products-grid" id="effect-grid-${effectKey}"></div>
    </div>
   `;
   _sectionsFragment.appendChild(section);
  });
  /* Sezione "Altri Prodotti" */
  if (allNoEffect.length > 0) {
   const altriSection = document.createElement('div');
   altriSection.className = 'fx-effect-section';
   altriSection.id = 'effect-altri';
   const altriCount = allNoEffect.length;
   altriSection.innerHTML = `
    <div class="fx-effect-section-header">
     <h3 class="fx-effect-section-title">
      <span class="fx-effect-title-prefix">Altri</span>
      <span class="fx-effect-title-name">Prodotti</span>
     </h3>
     <div class="fx-effect-section-actions">
      <span class="fx-effect-section-count">${altriCount} prodotti</span>
      <div class="fx-effect-nav-arrows">
       <button class="fx-nav-arrow fx-nav-arrow-prev" aria-label="Precedente" type="button">
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
         <path d="M15 18l-6-6 6-6"/>
        </svg>
       </button>
       <button class="fx-nav-arrow fx-nav-arrow-next" aria-label="Successivo" type="button">
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
         <path d="M9 18l6-6-6-6"/>
        </svg>
       </button>
      </div>
     </div>
    </div>
    <div class="fx-effect-carousel-wrapper">
     <div class="fx-effect-products-grid" id="effect-grid-altri"></div>
    </div>
   `;
   _sectionsFragment.appendChild(altriSection);
   allSortedEffects.push(['altri', allNoEffect]);
  }
  grid.appendChild(_sectionsFragment);
  /* Lazy rendering: primo effetto subito, il resto con IntersectionObserver */
  const EAGER_COUNT = 1;
  const _lazyEffectsData = {};
  allSortedEffects.forEach(([effectKey, effectProducts], idx) => {
   if (idx < EAGER_COUNT) {
    _renderEffectCards(effectKey, effectProducts);
   } else {
    _lazyEffectsData[effectKey] = effectProducts;
   }
  });
  /* IntersectionObserver per lazy rendering */
  if (Object.keys(_lazyEffectsData).length > 0 && 'IntersectionObserver' in window) {
   /* KH-CLEAN 2026-10-07: coda + rAF -> rendo UNA sezione per frame. Prima, scrollando veloce, piu'
      sezioni entravano nel margine insieme e venivano create nello STESSO task (long task 1s+ = freeze
      verticale). Ora la creazione card e' distribuita sui frame -> scroll fluido. */
   const _renderQueue = [];
   let _draining = false;
   function _drainQueue() {
    const effectKey = _renderQueue.shift();
    if (effectKey && _lazyEffectsData[effectKey]) {
     _renderEffectCards(effectKey, _lazyEffectsData[effectKey]);
     delete _lazyEffectsData[effectKey];
     initWishlistButtons();
    }
    if (_renderQueue.length > 0) { requestAnimationFrame(_drainQueue); }
    else { _draining = false; }
   }
   const _lazyObserver = new IntersectionObserver((entries) => {
    let queued = false;
    entries.forEach(entry => {
     if (!entry.isIntersecting) return;
     const section = entry.target;
     const effectKey = section.id.replace('effect-', '');
     if (_lazyEffectsData[effectKey] && _renderQueue.indexOf(effectKey) === -1) {
      _renderQueue.push(effectKey);
      _lazyObserver.unobserve(section);
      queued = true;
     }
    });
    if (queued && !_draining) { _draining = true; requestAnimationFrame(_drainQueue); }
   }, { rootMargin: '600px 0px' });
   allSortedEffects.forEach(([effectKey], idx) => {
    if (idx >= EAGER_COUNT) {
     const sec = document.getElementById(`effect-${effectKey}`);
     if (sec) _lazyObserver.observe(sec);
    }
   });
  } else {
   /* Fallback: render tutto se IntersectionObserver non supportato */
   Object.entries(_lazyEffectsData).forEach(([effectKey, effectProducts]) => {
    _renderEffectCards(effectKey, effectProducts);
   });
  }
  displayedProductsCount = allFilteredProducts.length;
 }
 initWishlistButtons();
 isLoadingMore = false;
}
function initInfiniteScroll() {
 window.removeEventListener('scroll', handleInfiniteScroll);
 window.addEventListener('scroll', handleInfiniteScroll, { passive: true });
}
function handleInfiniteScroll() {
 if (isLoadingMore || displayedProductsCount >= allFilteredProducts.length) {
  return;
 }
 const scrollPosition = window.scrollY + window.innerHeight;
 const pageHeight = document.documentElement.scrollHeight;
 if (scrollPosition >= pageHeight - 300) {
  loadMoreProducts();
 }
}
const EFFECT_IMAGE_OVERRIDES = {"arkistyle": {"pietra": "https://cdn.shopify.com/s/files/1/0949/7713/0845/files/ARKISTYLE_CLAY_96450efc-1bfc-408d-9771-9d1c3f23eb1d.jpg", "graniglia": "https://cdn.shopify.com/s/files/1/0949/7713/0845/files/ARKISTYLE_SHADE_WARM_a35faccf-a8d3-4a9f-9d65-a72dc3421e9b.jpg"}, "brera": {"cemento": "https://cdn.shopify.com/s/files/1/0949/7713/0845/files/AVORIO_487662d3-ce90-4abe-ad4c-73810ca37b19.jpg", "graniglia": "https://cdn.shopify.com/s/files/1/0949/7713/0845/files/KALEIDO_AVORIO_62aa4239-a83d-4151-9b8e-3ebf4d125fba.jpg"}, "earthtech": {"cemento": "https://cdn.shopify.com/s/files/1/0949/7713/0845/files/PUMICE_GROUND.webp", "melange": "https://cdn.shopify.com/s/files/1/0949/7713/0845/files/CARBON_FLAKES.webp"}, "stone-lab": {"pietra": "https://cdn.shopify.com/s/files/1/0949/7713/0845/files/LUSERNA_0dc0e1fb-50fd-43d1-b205-4ddd7aab6431.jpg", "travertino": "https://cdn.shopify.com/s/files/1/0949/7713/0845/files/NAVONA_df7b1b31-f235-438b-b0e5-3181f229b673.jpg"}, "art": {"cemento": "https://cdn.shopify.com/s/files/1/0949/7713/0845/files/CEMENTO_ARTISTICO.jpg", "resina": "https://cdn.shopify.com/s/files/1/0949/7713/0845/files/ARGILLA_ARTISTICA.jpg"}, "select": {"marmo": "https://cdn.shopify.com/s/files/1/0949/7713/0845/files/Statuario_f55f9345-0dcd-4e19-82ad-3f8af1dcf3d6.jpg", "decoro": "https://cdn.shopify.com/s/files/1/0949/7713/0845/files/Peonie_9647de56-5db3-4a9c-87b8-e19096ff8439.jpg"}, "cotti-ditalia": {"cotto": "https://cdn.shopify.com/s/files/1/0949/7713/0845/files/Pienza_3213681c-cc03-40a9-9295-bfb467dca8ed.jpg", "decoro": "https://cdn.shopify.com/s/files/1/0949/7713/0845/files/ba9ca089fc32aeb9854b9355654976af.jpg"}, "inx-wall": {"resina": "https://cdn.shopify.com/s/files/1/0949/7713/0845/files/inx_Dune.jpg", "decoro": "https://cdn.shopify.com/s/files/1/0949/7713/0845/files/inx_Cold_Mix.jpg"}, "vibes": {"resina": "https://cdn.shopify.com/s/files/1/0949/7713/0845/files/BEIGE_b1309fdf-6d38-4a8d-b249-1bf075ba08af.jpg", "decoro": "https://cdn.shopify.com/s/files/1/0949/7713/0845/files/JUNGLE_493bd04c-4b4f-4e31-adef-6da94f8a6cd8.jpg"}, "ilcottotagina": {"cotto": "https://cdn.shopify.com/s/files/1/0949/7713/0845/files/NATURAL.jpg", "decoro": "https://cdn.shopify.com/s/files/1/0949/7713/0845/files/NATURAL-DECOSTENCIL.jpg"}, "calcis": {"pietra": "https://cdn.shopify.com/s/files/1/0949/7713/0845/files/VISONE_1862c387-0209-4f1f-96b7-5b1346326c86.jpg", "decoro": "https://cdn.shopify.com/s/files/1/0949/7713/0845/files/AVORIO_STRIPE_b3c858c5-583d-4acf-a364-76986c243cea.jpg"}, "habita": {"pietra": "https://cdn.shopify.com/s/files/1/0949/7713/0845/files/GREY_e93b90db-873a-405f-bf34-453269554fe4.jpg", "decoro": "https://cdn.shopify.com/s/files/1/0949/7713/0845/files/QUADRI_BEIGE_ac3c2f9a-4a81-409a-bca3-ae70eff452b9.jpg"}, "overcome": {"cemento": "https://cdn.shopify.com/s/files/1/0949/7713/0845/files/GRIGIO_f90274ab-f58c-46e6-8019-32849ec3df7f.jpg", "graniglia": "https://cdn.shopify.com/s/files/1/0949/7713/0845/files/BIANCO_6e24601d-2cc7-461e-a5aa-df36adce0d0c.jpg"}, "shale": {"pietra": "https://cdn.shopify.com/s/files/1/0949/7713/0845/files/Moon_f618ab3c-ec30-4296-9caa-821e61ada8e9.jpg", "decoro": "https://cdn.shopify.com/s/files/1/0949/7713/0845/files/Moon_Ribbed_eb3fe8a5-d886-4f76-8e3a-8daa4760a64f.jpg"}, "alchemy-30x90": {"pietra": "https://cdn.shopify.com/s/files/1/0949/7713/0845/files/Alchemy_BEIGE_30x90_1c278ec4-2992-41ce-b089-b3d2e5131f42.jpg", "decoro": "https://cdn.shopify.com/s/files/1/0949/7713/0845/files/Alchemy_BOCCIOLO_30x90_8280f565-31b1-44cd-9eef-ec243c8e135e.jpg"}, "couture": {"marmo": "https://cdn.shopify.com/s/files/1/0949/7713/0845/files/ALMOND_ZEUS6_LPM_88b99981-1662-4ac8-870a-57d1b0caab49.jpg", "pietra": "https://cdn.shopify.com/s/files/1/0949/7713/0845/files/BEIGE_LOIRA6_B_LPM_d44d16d3-15d4-4439-8cd9-f3bc2ad18f2f.jpg"}, "nature-mood": {"legno": "https://cdn.shopify.com/s/files/1/0949/7713/0845/files/TAVOLA01.webp", "marmo": "https://cdn.shopify.com/s/files/1/0949/7713/0845/files/GHIACCIAIO.webp"}, "palette": {"colore": "https://cdn.shopify.com/s/files/1/0949/7713/0845/files/VERDE.jpg", "decoro": "https://cdn.shopify.com/s/files/1/0949/7713/0845/files/DECORFLOREALE.jpg"}, "rebel": {"cemento": "https://cdn.shopify.com/s/files/1/0949/7713/0845/files/REBEL_GRIGIO_4af17c5d-66fe-43ee-b65b-3564120c26a5.png", "decoro": "https://cdn.shopify.com/s/files/1/0949/7713/0845/files/POLVERE_DI_STELLE_CALDA.png"}, "marble-touch": {"marmo": "https://cdn.shopify.com/s/files/1/0949/7713/0845/files/CALACATTA_EXTRA_701284a0-9edd-4a87-ba52-70696bfa4f68.jpg", "decoro": "https://cdn.shopify.com/s/files/1/0949/7713/0845/files/resized_STRIPE_CALACATTA_EXTRA_58ad6c42-52e3-4b32-9061-41b44a961390.jpg"}, "mirabilia": {"colore": "https://cdn.shopify.com/s/files/1/0949/7713/0845/files/MIRABILIA_Bianco_Dulcis.jpg", "decoro": "https://cdn.shopify.com/s/files/1/0949/7713/0845/files/MIRABILIA_Floral_Bay.jpg"}, "marmi-imperiali": {"marmo": "https://cdn.shopify.com/s/files/1/0949/7713/0845/files/AURELIA.jpg", "decoro": "https://cdn.shopify.com/s/files/1/0949/7713/0845/files/RHOMBUS.jpg"}, "montalcino": {"legno": "https://cdn.shopify.com/s/files/1/0949/7713/0845/files/ROVEREPAGLIERINO.jpg", "decoro": "https://cdn.shopify.com/s/files/1/0949/7713/0845/files/DECOPAGLIERINO.jpg"}, "party": {"pietra": "https://cdn.shopify.com/s/files/1/0949/7713/0845/files/GRIGIO_SCURO_ALGAR6_DG_07d17ffa-cc41-4eb6-a36a-98c1f619d11e.jpg", "colore": "https://cdn.shopify.com/s/files/1/0949/7713/0845/files/VERDE_MAJO6_VER_bd490782-94d4-407b-a01e-b26529a6d73f.jpg"}, "rinascenza": {"pietra": "https://cdn.shopify.com/s/files/1/0949/7713/0845/files/RINASCENZA_Arena_Bianco.jpg", "tessuto": "https://cdn.shopify.com/s/files/1/0949/7713/0845/files/RINASCENZA_Mod_Lichene.jpg"}, "sogno": {"cemento": "https://cdn.shopify.com/s/files/1/0949/7713/0845/files/BIANCO_a21b0907-4721-4db5-b928-38ca62772f3f.jpg", "decoro": "https://cdn.shopify.com/s/files/1/0949/7713/0845/files/DECOROBEIGE.jpg"}, "whisper": {"pietra": "https://cdn.shopify.com/s/files/1/0949/7713/0845/files/WHISPER_EARTH_120x120_1-crop-c0-5__0-5-400x400-70.jpg", "decoro": "https://cdn.shopify.com/s/files/1/0949/7713/0845/files/whisper_WHM6.jpg"}, "i-cementi": {"cemento": "https://cdn.shopify.com/s/files/1/0949/7713/0845/files/BEIGE_2bbc32fc-34cf-447d-ac7c-55d762adcaa3.jpg", "graniglia": "https://cdn.shopify.com/s/files/1/0949/7713/0845/files/White_Ciottolo_28f6d6c0-4330-4ad3-9cdf-220e8334804d.jpg"}, "le-crete": {"cemento": "https://cdn.shopify.com/s/files/1/0949/7713/0845/files/Panna_df321400-820f-4b3a-a64b-a186451342fa.jpg", "decoro": "https://cdn.shopify.com/s/files/1/0949/7713/0845/files/Paper_4272e8c0-88c1-45d3-a83d-a862b245f62c.jpg"}, "moon": {"cemento": "https://cdn.shopify.com/s/files/1/0949/7713/0845/files/ARGENTO_15970591-70a6-4e99-8ef9-db18fa7dd428.jpg", "decoro": "https://cdn.shopify.com/s/files/1/0949/7713/0845/files/BIANCOV2.jpg"}, "clay": {"resina": "https://cdn.shopify.com/s/files/1/0949/7713/0845/files/BEIGE_fc157aa4-1289-4bfd-9137-6c42629c7943.jpg", "decoro": "https://cdn.shopify.com/s/files/1/0949/7713/0845/files/Ginko_1c6163cc-e144-4f8e-9193-29d49287b3c9.jpg"}, "spatula": {"resina": "https://cdn.shopify.com/s/files/1/0949/7713/0845/files/BIANCO_c6db0e6c-421c-40c3-861b-cba1c7f0271a.jpg", "decoro": "https://cdn.shopify.com/s/files/1/0949/7713/0845/files/VITTORIANOARANCIONE.jpg"}, "terre": {"creta": "https://cdn.shopify.com/s/files/1/0949/7713/0845/files/Cotto_297c4202-cab7-4a96-b0af-8d2c7edb0834.jpg", "decoro": "https://cdn.shopify.com/s/files/1/0949/7713/0845/files/Bianco_Bricco_3d5eab1b-973e-4049-b503-424895caebc4.jpg"}, "authentic-luxe": {"marmo": "https://cdn.shopify.com/s/files/1/0949/7713/0845/files/MARBLEAUBISQUE.webp", "pietra": "https://cdn.shopify.com/s/files/1/0949/7713/0845/files/STONECHABLIS.webp", "travertino": "https://cdn.shopify.com/s/files/1/0949/7713/0845/files/GOLDTRAVERTINE.webp"}, "docks": {"pietra": "https://cdn.shopify.com/s/files/1/0949/7713/0845/files/sq_78837426028893.png?v=1784211456", "decoro": "https://cdn.shopify.com/s/files/1/0949/7713/0845/files/sq_78837426454877.png?v=1784211440"}, "match-up": {"cemento": "https://cdn.shopify.com/s/files/1/0949/7713/0845/files/COFEE.webp", "graniglia": "https://cdn.shopify.com/s/files/1/0949/7713/0845/files/SUGARMIX.webp"}, "roma-wall": {"cemento": "https://cdn.shopify.com/s/files/1/0949/7713/0845/files/Grigio_456bb014-5bed-4fba-9829-8a54b0dc8215.jpg", "decoro": "https://cdn.shopify.com/s/files/1/0949/7713/0845/files/Maioliche_da21e366-1130-437b-ba57-cb24aac174c0.jpg"}, "spatula-30x90": {"resina": "https://cdn.shopify.com/s/files/1/0949/7713/0845/files/SPATULA_GRIGIO_30X90_b3dd07fe-92e5-4d30-8970-81316a9eed65.jpg", "decoro": "https://cdn.shopify.com/s/files/1/0949/7713/0845/files/SPATULA_PEONIE_CALDE_30X90_F2.jpg"}, "woodslate-life": {"legno": "https://cdn.shopify.com/s/files/1/0949/7713/0845/files/WOODCHUNK.webp", "pietra": "https://cdn.shopify.com/s/files/1/0949/7713/0845/files/BARK.webp"}, "cocoon": {"resina": "https://cdn.shopify.com/s/files/1/0949/7713/0845/files/BIEGE_FVNT6_B_3d19df39-25be-4ce1-88a7-439b7561cabf.jpg", "travertino": "https://cdn.shopify.com/s/files/1/0949/7713/0845/files/BEIGE_TRA_SG6_LPM_b9df0d82-3829-428e-b52d-bb09d9e24bdb.jpg"}, "dolomia": {"pietra": "https://cdn.shopify.com/s/files/1/0949/7713/0845/files/IVORY_67e9b8e9-cc34-4f4f-bdf1-912ee5abd81c.jpg", "decoro": "https://cdn.shopify.com/s/files/1/0949/7713/0845/files/GROOVE_IVORY_71e06237-4811-4928-9764-e8a57f93e744.jpg"}, "i-travertini": {"travertino": "https://cdn.shopify.com/s/files/1/0949/7713/0845/files/Bianco_Vein_Cut_4c31903d-b599-416e-9898-2d90cfe63278.jpg", "decoro": "https://cdn.shopify.com/s/files/1/0949/7713/0845/files/Bianco_Vein_Cut_Ribbed_a01e24e8-66c6-453c-83e2-27da5b659045.jpg"}, "materia": {"cemento": "https://cdn.shopify.com/s/files/1/0949/7713/0845/files/Grigio_7dace13f-5f91-4388-9a0f-394d649a5374.jpg", "metallico": "https://cdn.shopify.com/s/files/1/0949/7713/0845/files/Bronzo_cdb87105-59ea-4b37-97b4-eaed6852a779.jpg"}, "morgana": {"cemento": "https://cdn.shopify.com/s/files/1/0949/7713/0845/files/BIANCO_760b971d-4983-43ce-8494-32f591a2283c.jpg", "decoro": "https://cdn.shopify.com/s/files/1/0949/7713/0845/files/GRIGIOSCURO_7abf4e87-0384-49e2-886e-ac160eb32207.jpg"}, "pierre-d-avignon": {"pietra": "https://cdn.shopify.com/s/files/1/0949/7713/0845/files/BLANC_c9cef300-3bf6-4ec2-b190-00c7027b6046.jpg", "decoro": "https://cdn.shopify.com/s/files/1/0949/7713/0845/files/ARLESBLANC_63b52013-7225-40f6-98b7-6b0c7b531984.jpg"}, "timeless": {"marmo": "https://cdn.shopify.com/s/files/1/0949/7713/0845/files/CALACATTA.webp", "travertino": "https://cdn.shopify.com/s/files/1/0949/7713/0845/files/TRAVERTINO.webp", "graniglia": "https://cdn.shopify.com/s/files/1/0949/7713/0845/files/CEPPODIGRE.webp"}, "bianco": {"marmo": "https://cdn.shopify.com/s/files/1/0949/7713/0845/files/BIANCO_CAL_BO_00607583-ef73-4584-bcc5-6b3c3db8abb9.jpg", "travertino": "https://cdn.shopify.com/s/files/1/0949/7713/0845/files/BIANCO_TRA_ON_b5cfffa0-073a-416e-a708-035e2203f14e.jpg"}, "dorset": {"pietra": "https://cdn.shopify.com/s/files/1/0949/7713/0845/files/Bianco_Cross_Cut_2_fadc9644-519b-461c-87c2-a63fd09ceec5.jpg", "travertino": "https://cdn.shopify.com/s/files/1/0949/7713/0845/files/Bianco_Vein_Cut_2_b9000a35-ce73-4fbd-8a9f-701926db6993.jpg"}, "lilysuite": {"tessuto": "https://cdn.shopify.com/s/files/1/0949/7713/0845/files/I360_LIS_Green_50x120-crop-c0-5__0-5-360x360-70.jpg", "decoro": "https://cdn.shopify.com/s/files/1/0949/7713/0845/files/LILYSUITE_Villa_A.jpg"}, "materia-wall": {"cemento": "https://cdn.shopify.com/s/files/1/0949/7713/0845/files/BIANCO_e87cda7f-77d9-4b6c-9a89-c95ae516bd4d.png", "decoro": "https://cdn.shopify.com/s/files/1/0949/7713/0845/files/TROPICAL_dd5a0cca-3560-4b58-92a2-7a7adea18c77.jpg"}, "start": {"cemento": "https://cdn.shopify.com/s/files/1/0949/7713/0845/files/GRIGIO_d1e65494-7b11-4715-9d66-3a9a36f69600.jpg", "decoro": "https://cdn.shopify.com/s/files/1/0949/7713/0845/files/DECOROGRIGIO_bda0efb3-bdb7-49ef-b781-cd7ba58ec417.jpg"}, "arkiquartz": {"pietra": "https://cdn.shopify.com/s/files/1/0949/7713/0845/files/ARKIQUARTZ_ARCTIC_3b349830-c70d-4b63-9732-00be68290a28.jpg", "decoro": "https://cdn.shopify.com/s/files/1/0949/7713/0845/files/J032_Arkiquartz_Block-proportional_relative_resize-360x0-70.jpg"}, "dust": {"cemento": "https://cdn.shopify.com/s/files/1/0949/7713/0845/files/Bianco_cdd5bb8f-a705-4145-81ca-31533dfe1e12.jpg", "decoro": "https://cdn.shopify.com/s/files/1/0949/7713/0845/files/MASTER_def900d2-cbf3-4e5b-aed0-023a66b179e8.jpg"}, "lime": {"cemento": "https://cdn.shopify.com/s/files/1/0949/7713/0845/files/SAND_2f9d082d-6129-4af0-8902-d782effae0c5.jpg", "decoro": "https://cdn.shopify.com/s/files/1/0949/7713/0845/files/LACY_LAND_3c9fbb66-6c96-45d6-b522-597877e7d0ae.jpg"}, "multiforme-mc": {"cemento": "https://cdn.shopify.com/s/files/1/0949/7713/0845/files/MULTIFORME_Carbone_602c4a55-4fe9-4385-afd8-35f4dc4d9c5f.jpg", "resina": "https://cdn.shopify.com/s/files/1/0949/7713/0845/files/MULTIFORME_Calce_7880b165-f192-47a6-82c0-977c74ba9b61.jpg"}, "onici-wall": {"marmo": "https://cdn.shopify.com/s/files/1/0949/7713/0845/files/SMERALDO_43dd18e7-b1bf-473f-afd5-d9c3a50b6bc1.jpg", "decoro": "https://cdn.shopify.com/s/files/1/0949/7713/0845/files/Petali_perla_d29c61f0-0f64-4888-bb28-81adec246507.jpg"}, "scultorea-delicata": {"marmo": "https://cdn.shopify.com/s/files/1/0949/7713/0845/files/SCULTOREA_DELICATA_Calacatta_Velato.jpg", "travertino": "https://cdn.shopify.com/s/files/1/0949/7713/0845/files/SCULTOREA_DELICATA_Travertino_Bianco.jpg"}, "your-match": {"cemento": "https://cdn.shopify.com/s/files/1/0949/7713/0845/files/GHIAGGIO.jpg", "decoro": "https://cdn.shopify.com/s/files/1/0949/7713/0845/files/GIUNGLA.jpg"}, "boiserie": {"decoro": "https://cdn.shopify.com/s/files/1/0949/7713/0845/files/Cipria_a6ef2b00-1882-4528-9e36-84f8b6f29ad3.jpg", "legno": "https://cdn.shopify.com/s/files/1/0949/7713/0845/files/Rovere_332af7e4-d941-48f2-89cc-f0fb01803257.jpg"}, "formatech": {"cemento": "https://cdn.shopify.com/s/files/1/0949/7713/0845/files/FORMATECH_Cure_05.jpg", "graniglia": "https://cdn.shopify.com/s/files/1/0949/7713/0845/files/FORMATECH_Cast_02.jpg"}, "industrial": {"cemento": "https://cdn.shopify.com/s/files/1/0949/7713/0845/files/STEEL.webp", "resina": "https://cdn.shopify.com/s/files/1/0949/7713/0845/files/IVORY.webp"}, "multiforme-dune": {"resina": "https://cdn.shopify.com/s/files/1/0949/7713/0845/files/MULTIFORME_DUNE_Caolino.jpg", "decoro": "https://cdn.shopify.com/s/files/1/0949/7713/0845/files/MULTIFORME_DUNE_Bosco.jpg"}, "your-match-palette-n2": {"resina": "https://cdn.shopify.com/s/files/1/0949/7713/0845/files/DESERTO.jpg", "decoro": "https://cdn.shopify.com/s/files/1/0949/7713/0845/files/PALMA.jpg"}};
function createProductCard(product, _effectKey) {
 var _ovMap = (_effectKey && typeof EFFECT_IMAGE_OVERRIDES !== 'undefined') ? EFFECT_IMAGE_OVERRIDES[product.handle] : null;
 var _cardImg = (_ovMap && _ovMap[_effectKey]) ? _fxResizeImg(_ovMap[_effectKey], 600) : product.image;
 const card = document.createElement('div');
 card.className = 'fx-product-standard-card' + ((product.secondImage && !_KH_TOUCH) ? ' fx-has-second-image' : '');
 card.dataset.productHandle = product.handle;
 const extractFormatAndColor = (product) => {
  if (!product) return { format: null, color: null };
  let format = null;
  let color = null;
  const formatRegex = /(\d+(?:\.\d+)?)\s*[x×]\s*(\d+(?:\.\d+)?)/i;
  if (product.variants && product.variants.length > 0) {
   const cheapestVariant = product.variants.reduce((min, v) =>
    (v.price < min.price) ? v : min
   , product.variants[0]);
   const firstVariant = cheapestVariant;
   ['option1', 'option2', 'option3'].forEach(optKey => {
    if (firstVariant[optKey]) {
     const optValue = firstVariant[optKey];
     const formatMatch = optValue.match(formatRegex);
     if (formatMatch && !format) {
      let formatBase = formatMatch[0].replace(/\s+/g, '');
      const optLower = optValue.toLowerCase();
      if (optLower.includes('liscio') || optLower.includes('smooth')) {
       formatBase += '-liscio';
      } else if (optLower.includes('lucido') || optLower.includes('glossy')) {
       formatBase += '-lucido';
      } else if (optLower.includes('satinato') || optLower.includes('satin')) {
       formatBase += '-satinato';
      } else if (optLower.includes('strutturato')) {
       formatBase += '-strutturato';
      } else if (optLower.includes('bocciardato')) {
       formatBase += '-bocciardato';
      } else if (optLower.includes('comfort')) {
       formatBase += '-comfort';
      } else if (optLower.includes('ptv') || optLower.includes('p.t.v')) {
       formatBase += '-ptv';
      }
      format = formatBase;
     }
     if (!formatMatch && !color) {
      color = optValue;
     }
    }
   });
   if (!format && firstVariant.title) {
    const formatMatch = firstVariant.title.match(formatRegex);
    if (formatMatch) {
     format = formatMatch[0].replace(/\s+/g, '');
    }
   }
  }
  if (!format && product.title) {
   const formatMatch = product.title.match(formatRegex);
   if (formatMatch) {
    format = formatMatch[0].replace(/\s+/g, '');
   }
  }
  return { format, color };
 };
 const getFixedPrices = (product) => {
  /* Solo per piastrelle — NON sovrascrivere prezzi HomeUp, Arcadia, VONDOM, Forma Acquae */
  var v = (product.vendor || '').toLowerCase();
  if (v === 'homeup' || v === 'ceramiche arcadia' || v === 'vondom' || v === 'forma acquae' || v === 'imex') return null;
  if (window.getPrezzoMinimoM2) {
   try {
    const minPrices = window.getPrezzoMinimoM2(product.title);
    if (minPrices) {
     return minPrices;
    }
   } catch (e) {}
  }
  if (!window.getPrezzoFissoM2) return null;
  const { format, color } = extractFormatAndColor(product);
  if (!format) return null;
  try {
   const fixedPrices = window.getPrezzoFissoM2(format, product.title, color);
   return fixedPrices;
  } catch (e) {
   return null;
  }
 };
 const fixedPrices = getFixedPrices(product);
 let displayPrice = product.price;
 let displayPriceMin = product.priceMin;
 let displayComparePrice = product.comparePrice;
 let displayComparePriceMin = product.comparePriceMin;
 if (fixedPrices) {
  displayPrice = fixedPrices.prezzo;
  displayPriceMin = fixedPrices.prezzo;
  /* KH 07/08: barrato-da-listino rimosso (barrato solo da compare_at reale) */
 }
 // Box price = metafield precomputed (variante con €/mq più basso)
 let boxPriceMin = product.boxPriceMin > 0 ? product.boxPriceMin : product.priceMin;
 /* KH-FEEDPRICE: prezzo gia' corretto dal server (scatola piu economica + suo euro/mq) -> niente fetch, niente salto */
 var _khServer = false;
 if (product.mqMin > 0) { displayPrice = product.mqMin; displayPriceMin = product.mqMin; _khServer = true; }
 if (product.boxMin > 0) { boxPriceMin = product.boxMin; }
 /* KH-GRID rimosso 16/07: era un enricher card €/mq ridondante con KH-UNIV (kh-prezzi-shopify.js), ora inutile perche' il prezzo (mqMin/boxMin) e' precalcolato lato server. Codice morto eliminato. */

const formatPrice = (price, product) => {
  const formattedPrice = _fmtEur(price);
  let isTile = false;
  if (product) {
   if (product.vendor && product.vendor.toLowerCase().includes('ceramiche arcadia')) return formattedPrice;
   if (product.tags) {
    const tags = product.tags.toLowerCase();
    isTile = tags.includes('piastrelle') ||
        tags.includes('ceramica') ||
        tags.includes('gres') ||
        tags.includes('tiles');
   }
   if (!isTile && product.type) {
    const productType = product.type.toLowerCase();
    isTile = productType.includes('piastrelle') ||
        productType.includes('ceramica') ||
        productType.includes('tiles') ||
        productType.includes('gres');
   }
   if (!isTile && product.vendor) {
    const vendor = product.vendor.toLowerCase();
    isTile = vendor.includes('ceramicaeuro') ||
        vendor.includes('formaaquae') ||
        vendor.includes('ceramica euro') ||
        vendor.includes('forma aquae');
   }
   if (!isTile && product.title) {
    const title = product.title.toLowerCase();
    isTile = (title.includes('piastrelle') || title.includes('gres porcellanato')) &&
        !title.includes('accessori') &&
        !title.includes('colla');
   }
  }
  if (isTile) {
   return formattedPrice + '<span style="font-size: 1em; color: inherit; font-weight: inherit;">/</span><span style="font-size: 0.9em; color: inherit;">mq</span>';
  }
  return formattedPrice;
 };
 const _isTile = (function() {
  if (product.vendor && product.vendor.toLowerCase().includes('ceramiche arcadia')) return false;
  if (product.tags) { const t = (Array.isArray(product.tags) ? product.tags.join(' ') : product.tags).toLowerCase(); if (t.includes('piastrelle') || t.includes('ceramica') || t.includes('gres') || t.includes('tiles')) return true; }
  if (product.type) { const pt = product.type.toLowerCase(); if (pt.includes('piastrelle') || pt.includes('ceramica') || pt.includes('tiles') || pt.includes('gres')) return true; }
  if (product.vendor) { const v = product.vendor.toLowerCase(); if (v.includes('ceramica euro') || v.includes('forma aquae')) return true; }
  return false;
 })();
 const isInWishlist = isProductInWishlist(product.handle);
 card.innerHTML = `
  <!-- CUORE WISHLIST IN ALTO A DESTRA -->
  <div class="fx-product-wishlist-container">
   <button class="fx-wishlist-btn ${isInWishlist ? 'active' : ''}"
       data-product-handle="${product.handle}"
       data-product-title="${product.title.replace(/"/g, '&quot;')}"
       data-product-url="${product.url}"
       data-product-image="${product.image || ''}"
       data-product-price="${displayPrice}"
       aria-label="${isInWishlist ? 'Rimuovi dalla wishlist' : 'Aggiungi alla wishlist'}">
    <svg class="fx-wishlist-icon" width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
     <path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>
   </button>
  </div>
  <a href="${product.url}" class="fx-product-link">
   <div class="CardImageContainer fx-card-image-container">
    ${product.image ? `
     <img class="CardImage--primary fx-card-image-primary" src="${_cardImg}" alt="${product.title}" loading="lazy" decoding="async">
     ${(product.secondImage && !_KH_TOUCH) ? `
      <img class="CardImage--secondary fx-card-image-secondary" src="${product.secondImage}" alt="${product.title}" loading="lazy" decoding="async">
     ` : ''}
    ` : ''}
   </div>
   <div class="ProductCard__Content fx-product-card-content">
    <h5>${product.title}</h5>
    <div class="ProductCard__PriceContainer fx-price-container">
     ${product.priceVaries ? `
      <span class="ProductCard__StartingFrom fx-starting-from">A PARTIRE DA</span>
      <div class="ProductCard__PriceRow fx-price-row">
       <span class="ProductCard__Price fx-price" data-price-cents="${displayPriceMin}" data-mq-url="${product.url}" data-kh-server="${_khServer?'1':''}">${formatPrice(displayPriceMin, product)}</span>
       
      </div>
     ` : `
      <div class="ProductCard__PriceRow fx-price-row">
       <span class="ProductCard__Price fx-price" data-price-cents="${displayPrice}" data-mq-url="${product.url}" data-kh-server="${_khServer?'1':''}">${formatPrice(displayPrice, product)}</span>
       
      </div>
     `}
     <div class="ProductCard__BoxPrice fx-box-price">${_isTile ? _fmtEur(boxPriceMin) + '/scatola <span class="fx-box-separator">&middot;</span> ' : ''}IVA incl.</div>
    </div>
    <div class="fx-card-avail">${(Array.isArray(product.tags)?product.tags.join(","):(product.tags||"")).toLowerCase().indexOf("outlet")>-1?'<span class="kh-avail kh-avail-in"><span class="kh-dot"></span>Disponibile</span>':'<span class="kh-avail kh-avail-order"><span class="kh-dot"></span>Su ordinazione</span>'}</div>
    ${!product.available ? `
     <span class="ProductCard__Badge fx-soldout-badge">Esaurito</span>
    ` : ''}
   </div>
  </a>
 `;
 return card;
}
function showLoading() {
 const loading = document.getElementById('fx-loading');
 const results = document.getElementById('fx-category-results');
 const noProducts = document.getElementById('fx-no-products');
 const pagination = document.getElementById('fx-pagination-container');
 if (results) results.style.display = 'none';
 if (noProducts) noProducts.style.display = 'none';
 if (pagination) pagination.style.display = 'none';
}
function hideLoading() {
 const loading = document.getElementById('fx-loading');
 if (loading) loading.style.display = 'none';
}
function showNoProducts() {
 hideLoading();
 const noProducts = document.getElementById('fx-no-products');
 const results = document.getElementById('fx-category-results');
 const pagination = document.getElementById('fx-pagination-container');
 if (noProducts) noProducts.style.display = 'block';
 if (results) results.style.display = 'none';
 if (pagination) pagination.style.display = 'none';
}
/* KH-EFFECTLINK 2026-10-01: deep-link effetto dalla home (es. /collections/piastrelle#effect-legno).
   Le sezioni effetto si renderizzano in modo asincrono -> retry finche' esistono, poi scroll. */
function _khScrollToEffect(id, tries) {
 tries = tries || 0;
 var section = document.getElementById(id);
 if (!section) { if (tries < 40) setTimeout(function(){ _khScrollToEffect(id, tries + 1); }, 150); return; }
 if (window.innerWidth <= 768) { section.scrollIntoView({ behavior: 'instant', block: 'start' }); return; }
 var totalOffset = 0;
 var siteHeader = document.querySelector('.Header'); if (siteHeader) totalOffset += siteHeader.offsetHeight;
 var navBar = document.getElementById('fx-effects-nav-bar'); if (navBar) totalOffset += navBar.offsetHeight;
 totalOffset -= 200;
 var absoluteTop = section.getBoundingClientRect().top + window.pageYOffset;
 window.scrollTo({ top: absoluteTop - totalOffset, behavior: 'smooth' });
}
function checkHashOnLoad() {
 const hash = window.location.hash.replace('#', '');
 if (hash && hash.indexOf('effect-') === 0) { showLanding(); _khScrollToEffect(hash); return; }
 if (hash && dynamicCategories[hash]) {
  if (dynamicCategories[hash].products.length > 0) {
   showCategory(hash);
  } else {
   showLanding();
  }
 } else {
  showLanding();
 }
}
function handleHashChange() {
 const hash = window.location.hash.replace('#', '');
 if (hash && hash.indexOf('effect-') === 0) { showLanding(); _khScrollToEffect(hash); return; }
 if (!hash) {
  showLanding();
 } else if (dynamicCategories[hash]) {
  if (dynamicCategories[hash].products.length > 0) {
   showCategory(hash);
  } else {
   showLanding();
  }
 } else {
  showLanding();
 }
}
function getWishlist() {
 try {
  const wishlist = localStorage.getItem('fx-wishlist');
  return wishlist ? JSON.parse(wishlist) : [];
 } catch (error) {
  return [];
 }
}
function saveWishlist(wishlist) {
 try {
  localStorage.setItem('fx-wishlist', JSON.stringify(wishlist));
  return true;
 } catch (error) {
  return false;
 }
}
function isProductInWishlist(productHandle) {
 const wishlist = getWishlist();
 return wishlist.some(item => item.handle === productHandle);
}
function addToWishlist(productData) {
 const wishlist = getWishlist();
 if (wishlist.some(item => item.handle === productData.handle)) {
  return false;
 }
 wishlist.push({
  handle: productData.handle,
  title: productData.title,
  url: productData.url,
  image: productData.image,
  price: productData.price,
  addedAt: new Date().toISOString()
 });
 const saved = saveWishlist(wishlist);
 if (saved) {
  window.dispatchEvent(new CustomEvent('fx-wishlist-updated', {
   detail: { wishlist, action: 'add', handle: productData.handle }
  }));
 }
 return saved;
}
function removeFromWishlist(productHandle) {
 const wishlist = getWishlist();
 const filteredWishlist = wishlist.filter(item => item.handle !== productHandle);
 const saved = saveWishlist(filteredWishlist);
 if (saved) {
  window.dispatchEvent(new CustomEvent('fx-wishlist-updated', {
   detail: { wishlist: filteredWishlist, action: 'remove', handle: productHandle }
  }));
 }
 return saved;
}
function getWishlistCount() {
 return getWishlist().length;
}
function handleWishlistToggle(button) {
 const productHandle = button.dataset.productHandle;
 const productTitle = button.dataset.productTitle;
 const productUrl = button.dataset.productUrl;
 const productImage = button.dataset.productImage;
 const productPrice = button.dataset.productPrice;
 const isCurrentlyInWishlist = button.classList.contains('active');
 if (isCurrentlyInWishlist) {
  if (removeFromWishlist(productHandle)) {
   button.classList.remove('active');
   button.setAttribute('aria-label', 'Aggiungi alla wishlist');
   button.classList.add('fx-wishlist-removing');
   setTimeout(() => {
    button.classList.remove('fx-wishlist-removing');
   }, 600);
   showWishlistNotification(`${productTitle} rimosso dalla wishlist`, 'removed');
  }
 } else {
  const productData = {
   handle: productHandle,
   title: productTitle,
   url: productUrl,
   image: productImage,
   price: productPrice
  };
  if (addToWishlist(productData)) {
   button.classList.add('active');
   button.setAttribute('aria-label', 'Rimuovi dalla wishlist');
   button.classList.add('fx-wishlist-adding');
   setTimeout(() => {
    button.classList.remove('fx-wishlist-adding');
   }, 600);
   showWishlistNotification(`${productTitle} aggiunto alla wishlist`, 'added');
  }
 }
 updateWishlistHeaderCounter();
}
function showWishlistNotification(message, type = 'added') {
 const existingNotifications = document.querySelectorAll('.fx-notification');
 existingNotifications.forEach(notif => {
  notif.style.transform = 'translateX(100%)';
  notif.style.opacity = '0';
  setTimeout(() => notif.remove(), 400);
 });
 const notification = document.createElement('div');
 notification.className = `fx-notification ${type === 'added' ? 'success' : 'remove'}`;
 const icons = {
  success: '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z" fill="#2D5A3D" stroke="#2D5A3D" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>',
  error: '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><circle cx="12" cy="12" r="10" fill="#E12D2D" stroke="#E12D2D" stroke-width="2"/><path d="M15 9l-6 6" stroke="white" stroke-width="2"/><path d="M9 9l6 6" stroke="white" stroke-width="2"/></svg>',
  warning: '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M12 9v4" stroke="#ffaa00" stroke-width="2" stroke-linecap="round"/><circle cx="12" cy="17" r="1" fill="#ffaa00"/><path d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z" stroke="#ffaa00" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>',
  info: '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><circle cx="12" cy="12" r="10" stroke="#2D5A3D" stroke-width="2" fill="none"/><path d="M12 16v-4" stroke="#2D5A3D" stroke-width="2" stroke-linecap="round"/><circle cx="12" cy="8" r="1" fill="#2D5A3D"/></svg>',
  remove: '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z" fill="none" stroke="#999" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/></svg>'
 };
 const iconType = type === 'added' ? 'success' : 'remove';
 notification.style.cssText = `
  position: fixed; top: 100px; right: 20px; transform: translateX(100%);
  z-index: 10000; background: rgba(255, 255, 255, 0.95);
  color: #2d3436; padding: 16px 20px; border-radius: 12px;
  font-family: 'Jost', sans-serif; font-weight: 500; font-size: 1rem;
  box-shadow: 0 8px 25px rgba(0, 0, 0, 0.1);
  transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
  max-width: 350px; min-width: 280px;
  border: 1px solid rgba(45, 90, 61, 0.2);
  backdrop-filter: blur(15px);
  -webkit-backdrop-filter: blur(15px);
 `;
 notification.innerHTML = `
  <div style="display: flex; align-items: center; gap: 1rem;">
   <div style="flex-shrink: 0;">
    ${icons[iconType]}
   </div>
   <span style="flex: 1; line-height: 1.5;">${message}</span>
  </div>
 `;
 document.body.appendChild(notification);
 setTimeout(() => {
  notification.style.transform = 'translateX(0)';
 }, 100);
 setTimeout(() => {
  if (notification && notification.parentElement) {
   notification.style.transform = 'translateX(100%)';
   notification.style.opacity = '0';
   setTimeout(() => {
    if (notification && notification.parentElement) {
     notification.remove();
    }
   }, 400);
  }
 }, 4000);
}
function updateWishlistHeaderCounter() {
 const wishlistLinks = document.querySelectorAll('a[href="/pages/wishlist"]');
 const count = getWishlistCount();
 wishlistLinks.forEach(link => {
  const existingBadge = link.querySelector('.wishlist-badge');
  if (existingBadge) {
   existingBadge.remove();
  }
  if (count > 0) {
   const badge = document.createElement('span');
   badge.className = 'wishlist-badge';
   badge.textContent = count;
   link.appendChild(badge);
  }
 });
}
function updateAllWishlistButtons() {
 const wishlistButtons = document.querySelectorAll('.fx-wishlist-btn');
 wishlistButtons.forEach(button => {
  const productHandle = button.dataset.productHandle;
  const isInWishlist = isProductInWishlist(productHandle);
  if (isInWishlist) {
   button.classList.add('active');
   button.setAttribute('aria-label', 'Rimuovi dalla wishlist');
  } else {
   button.classList.remove('active');
   button.setAttribute('aria-label', 'Aggiungi alla wishlist');
  }
 });
 updateWishlistHeaderCounter();
}
function generateEffectTileSVG(format, topColor = '#faf7f3', textureUrl = null) {
 const width = 60;
 const height = 60;
 const scale = 1;
 const scaledWidth = width * scale;
 const scaledHeight = height * scale;
 const skewAngle = 30;
 const depth = 4;
 const cos = Math.cos(skewAngle * Math.PI / 180);
 const sin = Math.sin(skewAngle * Math.PI / 180);
 const x1 = 0;
 const y1 = scaledHeight/2 * sin;
 const x2 = scaledWidth * cos;
 const y2 = 0;
 const x3 = scaledWidth * cos + scaledHeight/2 * cos;
 const y3 = scaledHeight/2 * sin;
 const x4 = scaledHeight/2 * cos;
 const y4 = scaledHeight * sin;
 const minX = -8;
 const minY = -4;
 const maxX = x3 + 8;
 const maxY = y4 + depth + 12;
 const viewBoxWidth = maxX - minX;
 const viewBoxHeight = maxY - minY;
 const offsetX = -minX;
 const offsetY = -minY;
 const sideColorRight = '#e8d7c6';
 const sideColorLeft = '#d4bfaa';
 const bottomColor = '#b39d88';
 return `<svg width="60" height="60" viewBox="${minX} ${minY} ${viewBoxWidth} ${viewBoxHeight}" xmlns="http://www.w3.org/2000/svg" style="display: block;">
  <defs>
   <filter id="shadow_${format}" x="-50%" y="-50%" width="200%" height="200%">
    <feGaussianBlur in="SourceAlpha" stdDeviation="2"/>
    <feOffset dx="0" dy="4" result="offsetblur"/>
    <feFlood flood-color="#000000" flood-opacity="0.2"/>
    <feComposite in2="offsetblur" operator="in"/>
    <feMerge><feMergeNode/><feMergeNode in="SourceGraphic"/></feMerge>
   </filter>
   ${textureUrl ? `
   <pattern id="texture_${format}" x="0" y="0" width="100" height="100" patternUnits="userSpaceOnUse">
    <image href="${textureUrl}" x="0" y="0" width="100" height="100" preserveAspectRatio="xMidYMid slice"/>
   </pattern>
   ` : `
   <radialGradient id="topGrad_${format}" cx="40%" cy="30%">
    <stop offset="0%" style="stop-color:${topColor};stop-opacity:1" />
    <stop offset="100%" style="stop-color:${topColor};stop-opacity:1" />
   </radialGradient>
   `}
   <linearGradient id="edgeGrad_${format}" x1="0%" y1="0%" x2="100%" y2="100%">
    <stop offset="0%" style="stop-color:#ffffff;stop-opacity:0.6" />
    <stop offset="50%" style="stop-color:#f0e6dc;stop-opacity:0.3" />
    <stop offset="100%" style="stop-color:#d4bfaa;stop-opacity:0.5" />
   </linearGradient>
   <pattern id="ceramic_${format}" x="0" y="0" width="20" height="20" patternUnits="userSpaceOnUse">
    <circle cx="2" cy="2" r="0.5" fill="rgba(255,255,255,0.3)"/>
    <circle cx="10" cy="10" r="0.5" fill="rgba(255,255,255,0.2)"/>
    <circle cx="18" cy="6" r="0.5" fill="rgba(255,255,255,0.25)"/>
   </pattern>
   <linearGradient id="rightGrad_${format}" x1="0%" y1="0%" x2="100%" y2="100%">
    <stop offset="0%" style="stop-color:${sideColorRight};stop-opacity:1" />
    <stop offset="100%" style="stop-color:#c7b099;stop-opacity:1" />
   </linearGradient>
   <linearGradient id="leftGrad_${format}" x1="0%" y1="0%" x2="100%" y2="100%">
    <stop offset="0%" style="stop-color:${sideColorLeft};stop-opacity:1" />
    <stop offset="100%" style="stop-color:#a89177;stop-opacity:1" />
   </linearGradient>
  </defs>
  <g transform="translate(2, 4)">
   <!-- Ombra -->
   <g transform="translate(4, 8)">
    <path d="M ${x1} ${y1 + depth} L ${x2} ${y2 + depth} L ${x3} ${y3 + depth} L ${x4} ${y4 + depth} Z" fill="rgba(0,0,0,0.08)" filter="url(#shadow_${format})"/>
   </g>
   <!-- Piastrella 3D -->
   <g>
   <!-- Lato destro -->
   <path d="M ${x2} ${y2} L ${x2} ${y2 + depth} L ${x3} ${y3 + depth} L ${x3} ${y3} Z" fill="url(#rightGrad_${format})" stroke="${bottomColor}" stroke-width="0.5" opacity="0.95"/>
   <!-- Lato sinistro -->
   <path d="M ${x3} ${y3} L ${x3} ${y3 + depth} L ${x4} ${y4 + depth} L ${x4} ${y4} Z" fill="url(#leftGrad_${format})" stroke="${bottomColor}" stroke-width="0.5" opacity="0.95"/>
   <!-- Superficie superiore -->
   <path d="M ${x1} ${y1} L ${x2} ${y2} L ${x3} ${y3} L ${x4} ${y4} Z" fill="url(#${textureUrl ? 'texture' : 'topGrad'}_${format})" stroke="url(#edgeGrad_${format})" stroke-width="1.5" stroke-linejoin="round"/>
   ${!textureUrl ? `<!-- Texture ceramica -->
   <path d="M ${x1} ${y1} L ${x2} ${y2} L ${x3} ${y3} L ${x4} ${y4} Z" fill="url(#ceramic_${format})" opacity="0.4"/>` : ''}
   <!-- Bordi luminosi -->
   <line x1="${x1}" y1="${y1}" x2="${x2}" y2="${y2}" stroke="rgba(255,255,255,0.6)" stroke-width="1"/>
   <line x1="${x2}" y1="${y2}" x2="${x3}" y2="${y3}" stroke="rgba(255,255,255,0.4)" stroke-width="1"/>
   </g>
  </g>
 </svg>`;
}
const EFFECTS_DEFINITIONS = {
 'legno': {
  name: 'Effetto Legno',
  icon: '<img src="https://cdn.shopify.com/s/files/1/0949/7713/0845/t/21/assets/eff-legno.png?v=1782910948&width=144" style="width:72px;height:72px;object-fit:contain;display:block;transform:scale(1.32)" alt="Effetto Legno">',
  tags: ['effetto legno', 'legno', 'wood']
 },
 'marmo': {
  name: 'Effetto Marmo',
  icon: '<img src="https://cdn.shopify.com/s/files/1/0949/7713/0845/t/21/assets/eff-marmo.png?v=1782911021&width=144" style="width:72px;height:72px;object-fit:contain;display:block;transform:scale(1.32)" alt="Effetto Marmo">',
  tags: ['effetto marmo', 'marmo', 'marble']
 },
 'pietra': {
  name: 'Effetto Pietra',
  icon: '<img src="https://cdn.shopify.com/s/files/1/0949/7713/0845/t/21/assets/eff-pietra.png?v=1782911945&width=144" style="width:72px;height:72px;object-fit:contain;display:block;transform:scale(1.32)" alt="Effetto Pietra">',
  tags: ['effetto pietra']
 },
 'cemento': {
  name: 'Effetto Cemento',
  icon: '<img src="https://cdn.shopify.com/s/files/1/0949/7713/0845/t/21/assets/eff-cemento.png?v=1782911101&width=144" style="width:72px;height:72px;object-fit:contain;display:block;transform:scale(1.32)" alt="Effetto Cemento">',
  tags: ['effetto cemento', 'cemento', 'concrete', 'cement']
 },
 'metallico': {
  name: 'Effetto Metallo',
  icon: '<img src="https://cdn.shopify.com/s/files/1/0949/7713/0845/t/21/assets/eff-metallo.png?v=1782910487&width=144" style="width:72px;height:72px;object-fit:contain;display:block;transform:scale(1.32)" alt="Effetto Metallo">',
  tags: ['effetto metallo', 'metallo', 'effetto metallico', 'metallico', 'metal']
 },
 'resina': {
  name: 'Effetto Resina',
  icon: '<img src="https://cdn.shopify.com/s/files/1/0949/7713/0845/t/21/assets/eff-resina.png?v=1782911341&width=144" style="width:72px;height:72px;object-fit:contain;display:block;transform:scale(1.32)" alt="Effetto Resina">',
  tags: ['effetto resina', 'resina', 'resin']
 },
 'tessuto': {
  name: 'Effetto Carta da Parati',
  icon: '<img src="https://cdn.shopify.com/s/files/1/0949/7713/0845/t/21/assets/eff-cartadaparati.png?v=1782909577&width=144" style="width:72px;height:72px;object-fit:contain;display:block;transform:scale(1.32)" alt="Effetto Carta da Parati">',
  tags: ['effetto carta da parati', 'carta da parati', 'wallpaper']
 },
 'colore': {
  name: 'Effetto Colore',
  icon: '<img src="https://cdn.shopify.com/s/files/1/0949/7713/0845/t/21/assets/eff-colore.png?v=1782911604&width=144" style="width:72px;height:72px;object-fit:contain;display:block;transform:scale(1.32)" alt="Effetto Colore">',
  tags: ['effetto colore', 'tinta unita', 'solid color']
 },
 'decoro': {
  name: 'Effetto Decoro',
  icon: '<img src="https://cdn.shopify.com/s/files/1/0949/7713/0845/t/21/assets/eff-decoro.png?v=1782911210&width=144" style="width:72px;height:72px;object-fit:contain;display:block;transform:scale(1.32)" alt="Effetto Decoro">',
  tags: ['effetto decoro', 'decoro', 'decorative']
 },
 'cotto': {
  name: 'Effetto Cotto',
  icon: '<img src="https://cdn.shopify.com/s/files/1/0949/7713/0845/t/21/assets/eff-cotto.png?v=1782911435&width=144" style="width:72px;height:72px;object-fit:contain;display:block;transform:scale(1.32)" alt="Effetto Cotto">',
  tags: ['effetto cotto', 'cotto', 'terracotta']
 },
 'melange': {
  name: 'Effetto Mélange',
  icon: '<img src="https://cdn.shopify.com/s/files/1/0949/7713/0845/t/21/assets/eff-melange.png?v=1782909962&width=144" style="width:72px;height:72px;object-fit:contain;display:block;transform:scale(1.32)" alt="Effetto Melange">',
  tags: ['effetto mélange', 'melange', 'mélange', 'flakes', 'terrazzo']
 },
 'cuoio': {
  name: 'Effetto Cuoio',
  icon: '<img src="https://cdn.shopify.com/s/files/1/0949/7713/0845/t/21/assets/eff-cuoio.png?v=1782910225&width=144" style="width:72px;height:72px;object-fit:contain;display:block;transform:scale(1.32)" alt="Effetto Cuoio">',
  tags: ['effetto cuoio', 'cuoio', 'leather', 'pelle']
 },
 'graniglia': {
  name: 'Effetto Graniglia',
  icon: '<img src="https://cdn.shopify.com/s/files/1/0949/7713/0845/t/21/assets/eff-graniglia.png?v=1782909896&width=144" style="width:72px;height:72px;object-fit:contain;display:block;transform:scale(1.32)" alt="Effetto Graniglia">',
  tags: ['effetto graniglia', 'graniglia', 'granigliato']
 },
 'fabric': {
  name: 'Effetto Tessuto',
  icon: '<img src="https://cdn.shopify.com/s/files/1/0949/7713/0845/t/21/assets/eff-tessuto.png?v=1782909296&width=144" style="width:72px;height:72px;object-fit:contain;display:block;transform:scale(1.32)" alt="Effetto Tessuto">',
  tags: ['effetto tessuto', 'tessuto', 'fabric', 'textile']
 },
 'calce': {
  name: 'Effetto Calce',
  icon: '<img src="https://cdn.shopify.com/s/files/1/0949/7713/0845/t/21/assets/eff-calce.png?v=1782900460&width=144" style="width:72px;height:72px;object-fit:contain;display:block;transform:scale(1.32)" alt="Effetto Calce">',
  tags: ['effetto calce', 'calcecreta']
 },
 'cera': {
  name: 'Effetto Cera',
  icon: '<img src="https://cdn.shopify.com/s/files/1/0949/7713/0845/t/21/assets/eff-cera.png?v=1782910295&width=144" style="width:72px;height:72px;object-fit:contain;display:block;transform:scale(1.32)" alt="Effetto Cera">',
  tags: ['effetto cera']
 },
 'mattone': {
  name: 'Effetto Mattone',
  icon: '<img src="https://cdn.shopify.com/s/files/1/0949/7713/0845/t/21/assets/eff-mattone.png?v=1782910581&width=144" style="width:72px;height:72px;object-fit:contain;display:block;transform:scale(1.32)" alt="Effetto Mattone">',
  tags: ['effetto mattone']
 },
 'fessurato': {
  name: 'Effetto Fessurato',
  icon: '<img src="https://cdn.shopify.com/s/files/1/0949/7713/0845/t/21/assets/eff-fessurato.png?v=1782908824&width=144" style="width:72px;height:72px;object-fit:contain;display:block;transform:scale(1.32)" alt="Effetto Fessurato">',
  tags: ['effetto fessurato']
 },
 'creta': {
  name: 'Effetto Creta',
  icon: '<img src="https://cdn.shopify.com/s/files/1/0949/7713/0845/t/21/assets/eff-creta.png?v=1782908576&width=144" style="width:72px;height:72px;object-fit:contain;display:block;transform:scale(1.32)" alt="Effetto Creta">',
  tags: ['effetto creta']
 },
 'travertino': {
  name: 'Effetto Travertino',
  icon: '<img src="https://cdn.shopify.com/s/files/1/0949/7713/0845/t/21/assets/eff-travertino.png?v=1782901125&width=144" style="width:72px;height:72px;object-fit:contain;display:block;transform:scale(1.32)" alt="Effetto Travertino">',
  tags: ['effetto travertino']
 },
 'wc': {
  name: 'WC',
  icon: '<img src="//home-up.shop/cdn/shop/t/21/assets/icon-wc.png?v=24217367767304891951790690768" style="width:80px;height:80px;object-fit:contain;border-radius:8px" alt="WC">',
  tags: ['sanitari wc']
 },
 'bidet': {
  name: 'Bidet',
  icon: '<img src="//home-up.shop/cdn/shop/t/21/assets/icon-bidet.png?v=103810770228769733501790690687" style="width:80px;height:80px;object-fit:contain;border-radius:8px" alt="Bidet">',
  tags: ['sanitari bidet']
 },
 'coprivaso': {
  name: 'Coprivaso',
  icon: '<img src="//home-up.shop/cdn/shop/t/21/assets/icon-coprivaso.png?v=95355290737979908291790690700" style="width:80px;height:80px;object-fit:contain;border-radius:8px" alt="Coprivaso">',
  tags: ['sanitari coprivaso']
 },
 'lavabo': {
  name: 'Lavabi',
  icon: '<img src="//home-up.shop/cdn/shop/t/21/assets/icon-lavabi.png?v=65579636122905462271790690713" style="width:80px;height:80px;object-fit:contain;border-radius:8px" alt="Lavabi">',
  tags: ['sanitari lavabo']
 },
 'vasca': {
  name: 'Vasche',
  icon: '<img src="//home-up.shop/cdn/shop/t/21/assets/icon-vasche.png?v=154943950579291886401790690760" style="width:80px;height:80px;object-fit:contain;border-radius:8px" alt="Vasche">',
  tags: ['sanitari vasca']
 },
 'piattodoccia': {
  name: 'Piatti Doccia',
  icon: '<img src="//home-up.shop/cdn/shop/t/21/assets/icon-piatti-doccia.png?v=144588721724004575251790690732" style="width:80px;height:80px;object-fit:contain;border-radius:8px" alt="Piatti Doccia">',
  tags: ['sanitari piatto doccia', 'piatti doccia']
 },
 'specchio': {
  name: 'Specchi',
  icon: '<img src="//home-up.shop/cdn/shop/t/21/assets/icon-specchi.png?v=29230668476720441261790690755" style="width:80px;height:80px;object-fit:contain;border-radius:8px" alt="Specchi">',
  tags: ['sanitari specchio']
 },
 'rubinetteria': {
  name: 'Rubinetteria',
  icon: '<img src="//home-up.shop/cdn/shop/t/21/assets/icon-rubinetteria.png?v=112121218767592530861790690738" style="width:80px;height:80px;object-fit:contain;border-radius:8px" alt="Rubinetteria">',
  tags: ['sanitari rubinetteria']
 },
 'accessoribagno': {
  name: 'Accessori Bagno',
  icon: '<img src="https://cdn.shopify.com/s/files/1/0949/7713/0845/collections/icon-accessori-bagno.png" style="width:80px;height:80px;object-fit:contain;border-radius:8px" alt="Accessori Bagno">',
  tags: ['sanitari accessori', 'accessorio bagno']
 },
 'lavanderia': {
  name: 'Lavanderia',
  icon: '<img src="//home-up.shop/cdn/shop/t/21/assets/icon-lavanderia.png?v=145100891549461966831790690717" style="width:80px;height:80px;object-fit:contain;border-radius:8px" alt="Lavanderia">',
  tags: ['sanitari lavanderia']
 },
 'boxdocciabattente': {
  name: 'Box Doccia Battente',
  icon: '<img src="//home-up.shop/cdn/shop/t/21/assets/icon-box-doccia-battente.png?v=74662136648687850591790690690" style="width:80px;height:80px;object-fit:contain;border-radius:8px" alt="Box Doccia Battente">',
  tags: ['box-doccia-battente']
 },
 'boxdocciascorrevole': {
  name: 'Box Doccia Scorrevole',
  icon: '<img src="//home-up.shop/cdn/shop/t/21/assets/icon-box-doccia-scorrevole.png?v=118564146158155732031790690694" style="width:80px;height:80px;object-fit:contain;border-radius:8px" alt="Box Doccia Scorrevole">',
  tags: ['box-doccia-scorrevole']
 },
 'walkin': {
  name: 'Walk-in',
  icon: '<img src="//home-up.shop/cdn/shop/t/21/assets/icon-walk-in.png?v=140586965320531441251790690766" style="width:80px;height:80px;object-fit:contain;border-radius:8px" alt="Walk-in">',
  tags: ['walk-in']
 },
 'sopravasca': {
  name: 'Sopra Vasca',
  icon: '<img src="//home-up.shop/cdn/shop/t/21/assets/icon-sopra-vasca.png?v=7855969732450557631790690752" style="width:80px;height:80px;object-fit:contain;border-radius:8px" alt="Sopra Vasca">',
  tags: ['sopra-vasca']
 },
 'colonnadoccia': {
  name: 'Colonne Doccia',
  icon: '<img src="//home-up.shop/cdn/shop/t/21/assets/icon-colonne-doccia.png?v=76144124920527831471790690698" style="width:80px;height:80px;object-fit:contain;border-radius:8px" alt="Colonne Doccia">',
  tags: ['colonna-doccia']
 },
 'soffionedoccia': {
  name: 'Soffioni',
  icon: '<img src="//home-up.shop/cdn/shop/t/21/assets/icon-soffioni.png?v=103999623591139169211790690749" style="width:80px;height:80px;object-fit:contain;border-radius:8px" alt="Soffioni">',
  tags: ['soffione']
 },
 'cassettewc': {
  name: 'Cassette WC',
  icon: '<img src="https://cdn.shopify.com/s/files/1/0949/7713/0845/collections/icon-cassette-wc.png" style="width:80px;height:80px;object-fit:contain;border-radius:8px" alt="Cassette WC">',
  tags: ['sanitari cassetta']
 },
 'illuminazione': {
  name: 'Illuminazione',
  icon: '<img src="//home-up.shop/cdn/shop/t/21/assets/icon-illuminazione.png?v=17083512001537192481790690708" style="width:80px;height:80px;object-fit:contain;border-radius:8px" alt="Illuminazione">',
  tags: ['sanitari illuminazione']
 },
 'maniglioni': {
  name: 'Maniglioni',
  icon: '<img src="//home-up.shop/cdn/shop/t/21/assets/icon-maniglioni.png?v=31428756151750305041790690722" style="width:80px;height:80px;object-fit:contain;border-radius:8px" alt="Maniglioni">',
  tags: ['sanitari maniglioni']
 },
 'sgabelli': {
  name: 'Sgabelli e Portabiancheria',
  icon: '<img src="//home-up.shop/cdn/shop/t/21/assets/icon-sgabelli-portabiancheria.png?v=19141955819409152581790690746" style="width:80px;height:80px;object-fit:contain;border-radius:8px" alt="Sgabelli e Portabiancheria">',
  tags: ['sanitari sgabelli']
 },
 'placcescarico': {
  name: 'Placche Scarico',
  icon: '<img src="https://cdn.shopify.com/s/files/1/0949/7713/0845/collections/icon-accessori_a049d9a2-9e84-456b-affb-79338735058d.png" style="width:80px;height:80px;object-fit:contain;border-radius:8px" alt="Placche Scarico">',
  tags: ['sanitari placca']
 },
 'nicchiedoccia': {
  name: 'Nicchie Doccia',
  icon: '<img src="https://cdn.shopify.com/s/files/1/0949/7713/0845/collections/icon-nicchie-doccia.png" style="width:80px;height:80px;object-fit:contain;border-radius:8px;transform:scale(1.5)" alt="Nicchie Doccia">',
  tags: ['sanitari nicchia']
 },
 'setdoccia': {
  name: 'Set Doccia',
  icon: '<img src="https://cdn.shopify.com/s/files/1/0949/7713/0845/collections/icon-set-doccia.png" style="width:80px;height:80px;object-fit:contain;border-radius:8px;transform:scale(1.3)" alt="Set Doccia">',
  tags: ['set-doccia']
 },
 'doccetteigieniche': {
  name: 'Doccette Igieniche',
  icon: '<img src="//home-up.shop/cdn/shop/t/21/assets/icon-doccette-igieniche.png?v=160153095157633825261790690705" style="width:80px;height:80px;object-fit:contain;border-radius:8px" alt="Doccette Igieniche">',
  tags: ['doccetta igienica']
 },
 'poltronedivani': {
  name: 'Poltrone e Divani',
  icon: '<img src="//home-up.shop/cdn/shop/t/21/assets/icon-poltrone-divani.png?v=175121772176205038131790690735" style="width:80px;height:80px;object-fit:contain;border-radius:8px;transform:scale(1.2)" alt="Poltrone e Divani">',
  tags: ['poltrona lounge', 'poltrona', 'divano', 'divano modulare', 'pouf']
 },
 'sediesgabelli': {
  name: 'Sedie e Sgabelli',
  icon: '<img src="//home-up.shop/cdn/shop/t/21/assets/icon-sedie-sgabelli.png?v=41219355301119318331790690741" style="width:80px;height:80px;object-fit:contain;border-radius:8px" alt="Sedie e Sgabelli">',
  tags: ['sedia', 'sgabello alto', 'sgabello', 'panchina']
 },
 'tavoli': {
  name: 'Tavoli e Tavolini',
  icon: '<img src="//home-up.shop/cdn/shop/t/21/assets/icon-tavoli.png?v=34112952423013485951790690757" style="width:80px;height:80px;object-fit:contain;border-radius:8px" alt="Tavoli e Tavolini">',
  tags: ['tavolo', 'tavolino', 'tavolo alto', 'bancone']
 },
 'lettinidaybed': {
  name: 'Lettini e Daybed',
  icon: '<img src="//home-up.shop/cdn/shop/t/21/assets/icon-lettini-daybed.png?v=172474542794473604981790690719" style="width:80px;height:80px;object-fit:contain;border-radius:8px;transform:scale(1.2)" alt="Lettini e Daybed">',
  tags: ['lettino', 'daybed', 'sdraio']
 },
 'fioriere': {
  name: 'Vasi e Fioriere',
  icon: '<img src="//home-up.shop/cdn/shop/t/21/assets/icon-vasi-fioriere.png?v=169675359706946384631790690762" style="width:80px;height:80px;object-fit:contain;border-radius:8px" alt="Vasi e Fioriere">',
  tags: ['fioriera', 'nano fioriera', 'vaso']
 },
 'lampade': {
  name: 'Lampade',
  icon: '<img src="//home-up.shop/cdn/shop/t/21/assets/icon-lampade.png?v=71556246998840498511790690710" style="width:80px;height:80px;object-fit:contain;border-radius:8px" alt="Lampade">',
  tags: ['lampada']
 },
 'docceesterne': {
  name: 'Docce Esterne',
  icon: '<img src="https://cdn.shopify.com/s/files/1/0949/7713/0845/collections/icon-docce-esterne.png" style="width:80px;height:80px;object-fit:contain;border-radius:8px" alt="Docce Esterne">',
  tags: ['doccia esterno']
 },
 'oggettiDecorativi': {
  name: 'Oggetti Decorativi',
  icon: '<img src="https://cdn.shopify.com/s/files/1/0949/7713/0845/collections/icon-oggetti-decorativi.png" style="width:80px;height:80px;object-fit:contain;border-radius:8px" alt="Oggetti Decorativi">',
  tags: ['oggetto decorativo']
 },
 'pergolegazebo': {
  name: 'Pergole e Gazebo',
  icon: '<img src="//home-up.shop/cdn/shop/t/21/assets/icon-pergole-gazebo.png?v=20405351129583408181790690729" style="width:80px;height:80px;object-fit:contain;border-radius:8px;transform:scale(1.3)" alt="Pergole e Gazebo">',
  tags: ['pergolato']
 }
};
function detectProductEffects(product) {
 if (!product) return [];
 // Match ONLY against product tags (exact match), NOT title/type/vendor
 // This prevents false matches like "cera" in "CALCECRETA" title
 const productTags = product.tags
  ? product.tags.split(',').map(t => t.trim().toLowerCase())
  : [];
 const foundEffects = [];
 for (const [effectKey, effectData] of Object.entries(EFFECTS_DEFINITIONS)) {
  for (const tag of effectData.tags) {
   if (productTags.includes(tag.toLowerCase())) {
    if (!foundEffects.includes(effectKey)) {
     foundEffects.push(effectKey);
    }
    break;
   }
  }
 }
 return foundEffects;
}
/* Definisci quali card mostrare per ogni pagina collezione */
var COLLECTION_EFFECTS_FILTER = {
 'bagno': ['wc','cassettewc','placcescarico','bidet','lavabo','coprivaso','vasca','boxdocciabattente','boxdocciascorrevole','walkin','sopravasca','piattodoccia','colonnadoccia','soffionedoccia','nicchiedoccia','setdoccia','doccetteigieniche','specchio','rubinetteria','accessoribagno','lavanderia','illuminazione','maniglioni','sgabelli'],
 'arredo-outdoor': ['poltronedivani','sediesgabelli','tavoli','lettinidaybed','fioriere','lampade','docceesterne','oggettiDecorativi','pergolegazebo'],
 'rubinetteria-bagno': ['rubinetteria']
};
function groupProductsByEffect(products) {
 const grouped = {};
 const noEffect = [];
 var collHandle = (window._collectionTitle || '').toLowerCase();
 /* Trova l handle dalla URL */
 var pathParts = window.location.pathname.split('/');
 var urlHandle = pathParts[pathParts.length - 1] || pathParts[pathParts.length - 2] || '';
 var allowedEffects = COLLECTION_EFFECTS_FILTER[urlHandle] || null;
 products.forEach(product => {
  const effects = detectProductEffects(product);
  if (effects.length > 0) {
   effects.forEach(effect => {
    if (allowedEffects && !allowedEffects.includes(effect)) return;
    if (!grouped[effect]) {
     grouped[effect] = [];
    }
    grouped[effect].push(product);
   });
  } else {
   noEffect.push(product);
  }
 });
 return { grouped, noEffect };
}
function populateEffectsNavBar(groupedEffects) {
 const navBar = document.getElementById('fx-effects-nav-bar');
 const navItems = document.getElementById('fx-effects-nav-items');
 if (!navBar || !navItems) return;
 if (Object.keys(groupedEffects).length === 0) {
  navBar.style.display = 'none';
  return;
 }
 if (Object.keys(groupedEffects).length <= 1) {
  navBar.style.setProperty('display', 'none', 'important');
  var effectsBtn = document.getElementById('fx-floating-effects-btn');
  if (effectsBtn) effectsBtn.style.setProperty('display', 'none', 'important');
  return;
 }
 navBar.style.setProperty('display', 'block', 'important');
 navItems.innerHTML = '';
 /* Ordina card in base all'ordine definito in COLLECTION_EFFECTS_FILTER, altrimenti per numero prodotti */
 var pathParts = window.location.pathname.split('/');
 var urlHandle = pathParts[pathParts.length - 1] || pathParts[pathParts.length - 2] || '';
 var orderList = COLLECTION_EFFECTS_FILTER[urlHandle] || null;
 var sortedEffects;
 if (orderList) {
  sortedEffects = [];
  orderList.forEach(function(key) {
   if (groupedEffects[key]) sortedEffects.push([key, groupedEffects[key]]);
  });
  Object.entries(groupedEffects).forEach(function(entry) {
   if (!orderList.includes(entry[0])) sortedEffects.push(entry);
  });
 } else {
  sortedEffects = Object.entries(groupedEffects).sort((a, b) => b[1].length - a[1].length);
 }
 sortedEffects.forEach(([effectKey, products]) => {
  const effectData = EFFECTS_DEFINITIONS[effectKey];
  if (!effectData) {
   return;
  }
  const navItem = document.createElement('a');
  navItem.className = 'fx-effect-nav-item';
  navItem.href = `#effect-${effectKey}`;
  navItem.onclick = (e) => {
   e.preventDefault();
   setTimeout(() => {
    const section = document.getElementById(`effect-${effectKey}`);
    if (!section) {
     return;
    }
    // Offset = altezza degli elementi REALMENTE sticky/fixed in cima (es. header fisso ~148px).
    // La barra effetti e' position:relative (scorre via) quindi NON va contata. Niente numeri magici.
    const stickyOffset = () => {
     let off = 0; const seen = new Set();
     document.querySelectorAll('.Header, header, .site-header, #fx-effects-nav-bar').forEach(el => {
      if (seen.has(el)) return; seen.add(el);
      const cs = getComputedStyle(el);
      const r = el.getBoundingClientRect();
      if ((cs.position === 'fixed' || cs.position === 'sticky') && r.top <= 5 && el.offsetHeight < 300) {
       off += el.offsetHeight;
      }
     });
     return off + 12;
    };
    const targetTop = () => section.getBoundingClientRect().top + window.pageYOffset - stickyOffset();
    window.scrollTo({ top: targetTop(), behavior: 'smooth' });
    // Le sezioni si popolano di card progressivamente (batch) e le immagini lazy caricano dopo:
    // il bersaglio si sposta -> ri-aggancio finche' la pagina non si stabilizza (o l'utente scrolla a mano).
    let _khAbort = false;
    const _khStop = () => { _khAbort = true; };
    window.addEventListener('wheel', _khStop, { passive: true });
    window.addEventListener('touchmove', _khStop, { passive: true });
    let _tries = 0, _stable = 0;
    const _settle = () => {
     if (_khAbort || _stable >= 3 || _tries >= 25) {
      window.removeEventListener('wheel', _khStop);
      window.removeEventListener('touchmove', _khStop);
      return;
     }
     const t = targetTop();
     if (Math.abs(t - window.pageYOffset) <= 3) { _stable++; }
     else { _stable = 0; window.scrollTo({ top: t, behavior: _tries < 2 ? 'smooth' : 'auto' }); }
     _tries++;
     setTimeout(_settle, 180);
    };
    setTimeout(_settle, 350);
    setTimeout(() => {
     section.style.transition = 'all 0.3s ease';
     const originalBg = section.style.backgroundColor;
     // RIMOSSO 2026-05-27: barra verticale verde rimossa su richiesta utente
     // section.style.borderLeft = '4px solid #2D5A3D';
     // section.style.paddingLeft = '16px';
     // section.style.marginLeft = '-4px';
     const cards = [];
     let nextElement = section.nextElementSibling;
     let count = 0;
     while (nextElement && count < 6) {
      if (nextElement.classList.contains('fx-effect-section')) {
       break;
      }
      if (nextElement.classList.contains('ProductItem')) {
       cards.push(nextElement);
       count++;
      }
      nextElement = nextElement.nextElementSibling;
     }
     cards.forEach((card, index) => {
      setTimeout(() => {
       card.style.transition = 'all 0.3s ease';
       card.style.transform = 'translateY(-4px) scale(1.01)';
       card.style.boxShadow = '0 8px 16px rgba(45, 90, 61, 0.2)'; // Ombra verde brand
      }, index * 50);
     });
     setTimeout(() => {
      section.style.backgroundColor = originalBg;
      // section.style.borderLeft = '';  // RIMOSSO 2026-05-27
      // section.style.paddingLeft = '';
      // section.style.marginLeft = '';
      cards.forEach(card => {
       card.style.transform = '';
       card.style.boxShadow = '';
      });
      setTimeout(() => {
       section.style.transition = '';
       cards.forEach(card => {
        card.style.transition = '';
       });
      }, 300);
     }, 1500);
    }, 100);
   }, 50);
  };
  navItem.innerHTML = `
   <span class="fx-effect-nav-count">${products.length}</span>
   <span class="fx-effect-nav-icon" style="position:relative;z-index:1">${effectData.icon}</span>
   <span class="fx-effect-nav-name" style="position:relative;z-index:3;text-shadow:0 0 5px #fff,0 0 8px #fff,0 1px 2px #fff">${effectData.name}</span>
  `;
  navItems.appendChild(navItem);
 });
}
function initEffectCarousel(effectKey) {
 const effectGrid = document.getElementById(`effect-grid-${effectKey}`);
 const effectSection = document.getElementById(`effect-${effectKey}`);
 if (!effectGrid || !effectSection) return;
 const prevArrow = effectSection.querySelector('.fx-nav-arrow-prev');
 const nextArrow = effectSection.querySelector('.fx-nav-arrow-next');
 const getScrollAmount = () => {
  const card = effectGrid.querySelector('.fx-product-standard-card');
  if (card) {
   const cardWidth = card.offsetWidth;
   const gap = parseInt(window.getComputedStyle(effectGrid).gap) || 24;
   return cardWidth + gap;
  }
  return 300;
 };
 const updateArrows = () => {
  if (window.innerWidth <= 768) return; /* KH-SCROLLFLUID: frecce nascoste su mobile, niente reflow per frame */
  const scrollLeft = effectGrid.scrollLeft;
  const maxScrollLeft = effectGrid.scrollWidth - effectGrid.clientWidth;
  if (prevArrow) {
   prevArrow.style.opacity = scrollLeft <= 10 ? '0.3' : '1';
   prevArrow.style.pointerEvents = scrollLeft <= 10 ? 'none' : 'auto';
  }
  if (nextArrow) {
   nextArrow.style.opacity = scrollLeft >= maxScrollLeft - 10 ? '0.3' : '1';
   nextArrow.style.pointerEvents = scrollLeft >= maxScrollLeft - 10 ? 'none' : 'auto';
  }
 };
 if (prevArrow) {
  prevArrow.addEventListener('click', () => {
   effectGrid.scrollBy({ left: -getScrollAmount(), behavior: 'smooth' });
   setTimeout(updateArrows, 300);
  });
 }
 if (nextArrow) {
  nextArrow.addEventListener('click', () => {
   effectGrid.scrollBy({ left: getScrollAmount(), behavior: 'smooth' });
   setTimeout(updateArrows, 300);
  });
 }
 effectGrid.addEventListener('scroll', updateArrows, { passive: true });
 forceHorizontalScrollOnGrid(effectGrid);
 addDesktopDrag(effectGrid);
 updateArrows();
}
function initProductCarousels() {
 const grids = document.querySelectorAll('.fx-product-standard-grid:not(.fx-effect-products-grid):not(#fx-products-grid)');
 grids.forEach((grid, index) => {
  if (!grid.parentElement.classList.contains('fx-carousel-wrapper')) {
   wrapGridWithCarousel(grid, index);
  }
  forceHorizontalScrollOnGrid(grid);
  initCarouselArrows(grid);
  addDesktopDrag(grid);
 });
}
function wrapGridWithCarousel(grid, index) {
 const wrapper = document.createElement('div');
 wrapper.className = 'fx-carousel-wrapper';
 wrapper.id = `fx-carousel-wrapper-${index}`;
 grid.parentNode.insertBefore(wrapper, grid);
 wrapper.appendChild(grid);
 const prevArrow = document.createElement('button');
 prevArrow.className = 'fx-carousel-arrow fx-carousel-arrow-prev';
 prevArrow.setAttribute('aria-label', 'Precedente');
 prevArrow.type = 'button';
 const nextArrow = document.createElement('button');
 nextArrow.className = 'fx-carousel-arrow fx-carousel-arrow-next';
 nextArrow.setAttribute('aria-label', 'Successivo');
 nextArrow.type = 'button';
 wrapper.insertBefore(prevArrow, grid);
 wrapper.appendChild(nextArrow);
}
function initCarouselArrows(grid) {
 const wrapper = grid.parentElement;
 if (!wrapper || !wrapper.classList.contains('fx-carousel-wrapper')) return;
 const prevArrow = wrapper.querySelector('.fx-carousel-arrow-prev');
 const nextArrow = wrapper.querySelector('.fx-carousel-arrow-next');
 if (!prevArrow || !nextArrow) return;
 const getScrollAmount = () => {
  const card = grid.querySelector('.fx-product-standard-card');
  if (card) {
   const cardWidth = card.offsetWidth;
   const gap = parseInt(window.getComputedStyle(grid).gap) || 24;
   return cardWidth + gap;
  }
  return 300;
 };
 prevArrow.addEventListener('click', () => {
  const scrollAmount = getScrollAmount();
  grid.scrollBy({ left: -scrollAmount, behavior: 'smooth' });
  updateCarouselState(grid);
 });
 nextArrow.addEventListener('click', () => {
  const scrollAmount = getScrollAmount();
  grid.scrollBy({ left: scrollAmount, behavior: 'smooth' });
  updateCarouselState(grid);
 });
 /* KH-SCROLLFLUID 2026-10-07: listener 'scroll' rimosso (era DOPPIO: forceHorizontalScrollOnGrid
    ne aggancia gia' uno passive). Un solo handler = meno lavoro per frame. */
 updateCarouselState(grid);
}
function updateCarouselState(grid) {
 /* KH-SCROLLFLUID 2026-10-07: su MOBILE le frecce sono display:none, quindi aggiornarle ad ogni
    frame di scroll faceva solo forced-reflow (lettura scrollLeft/scrollWidth) = micro-scatti.
    Qui esco subito su mobile. Su desktop throttle con rAF (1 lettura/frame max) per non frullare. */
 if (window.innerWidth <= 768) return;
 if (grid._khArrowRAF) return;
 grid._khArrowRAF = requestAnimationFrame(function() {
  grid._khArrowRAF = null;
  const wrapper = grid.parentElement;
  if (!wrapper) return;
  const prevArrow = wrapper.querySelector('.fx-carousel-arrow-prev');
  const nextArrow = wrapper.querySelector('.fx-carousel-arrow-next');
  const scrollLeft = grid.scrollLeft;
  const maxScrollLeft = grid.scrollWidth - grid.clientWidth;
  if (prevArrow) {
   prevArrow.style.opacity = scrollLeft <= 10 ? '0.3' : '1';
   prevArrow.style.pointerEvents = scrollLeft <= 10 ? 'none' : 'auto';
  }
  if (nextArrow) {
   nextArrow.style.opacity = scrollLeft >= maxScrollLeft - 10 ? '0.3' : '1';
   nextArrow.style.pointerEvents = scrollLeft >= maxScrollLeft - 10 ? 'none' : 'auto';
  }
 });
}
function addDesktopDrag(grid) {
 if (!grid || window.innerWidth <= 749) return;
 var isDragging = false, wasDragged = false, dragStartX, dragScrollLeft;
 grid.style.cursor = 'grab';
 grid.addEventListener('mousedown', function(e) {
  isDragging = true;
  wasDragged = false;
  dragStartX = e.pageX;
  dragScrollLeft = grid.scrollLeft;
  grid.style.cursor = 'grabbing';
  grid.style.scrollBehavior = 'auto';
  grid.style.scrollSnapType = 'none';
  e.preventDefault();
 });
 document.addEventListener('mousemove', function(e) {
  if (!isDragging) return;
  if (Math.abs(e.pageX - dragStartX) > 5) wasDragged = true;
  grid.scrollLeft = dragScrollLeft - (e.pageX - dragStartX);
 });
 document.addEventListener('mouseup', function() {
  if (!isDragging) return;
  isDragging = false;
  grid.style.cursor = 'grab';
  grid.style.scrollBehavior = '';
  grid.style.scrollSnapType = '';
  updateCarouselState(grid);
 });
 grid.addEventListener('click', function(e) {
  if (wasDragged) {
   e.preventDefault();
   e.stopPropagation();
   wasDragged = false;
  }
 }, true);
}
function forceHorizontalScrollOnGrid(grid) {
 if (!grid || grid._khTouchInit) return;
 grid._khTouchInit = true;
 /* KH-SCROLLFLUID 2026-10-07 (it.3): scroll MANUALE identico a "Le nostre proposte" (home) — l'unico
    fluido su QUESTO tema. Il tema (theme.liquid ~r.432) forza touch-action:pan-y su quasi tutto:
    lo scroll NATIVO orizzontale ne usciva scattoso/bloccato. L'handler manuale prende il controllo e,
    chiamando preventDefault sul drag orizzontale, impedisce al browser di entrare in :hover/tap
    emulato -> l'effetto hover e' ELIMINATO durante lo scroll (non solo nascosto).
    KH-MOMENTUM 2026-10-07: aggiunta INERZIA (flick) con attrito -> scorrimento piu' fluido e veloce,
    come le app native, pur mantenendo il tracking 1:1 durante il drag. */
 grid.style.webkitOverflowScrolling = 'touch';
 grid.style.touchAction = 'pan-x pan-y';
 grid.style.overscrollBehaviorX = 'contain';
 /* se un antenato ha touch-action:pan-y (regola globale del tema) blocca il pan-x del figlio: lo sblocco */
 var p = grid.parentElement;
 while (p && p !== document.documentElement) {
  try { if (getComputedStyle(p).touchAction === 'pan-y') p.style.setProperty('touch-action', 'auto', 'important'); } catch (e) {}
  p = p.parentElement;
 }
 var startX = 0, startY = 0, scrollStartX = 0, active = false, horiz = null;
 var lastX = 0, lastT = 0, vel = 0, raf = 0;
 function stopInertia() { if (raf) { cancelAnimationFrame(raf); raf = 0; } }
 function inertia() {
  raf = requestAnimationFrame(function() {
   var max = grid.scrollWidth - grid.clientWidth;
   grid.scrollLeft += vel * 16;          /* vel in px/ms, ~16ms a frame */
   vel *= 0.95;                           /* attrito: coast morbido */
   if (grid.scrollLeft <= 0 || grid.scrollLeft >= max || Math.abs(vel) < 0.03) { raf = 0; updateCarouselState(grid); return; }
   inertia();
  });
 }
 grid.addEventListener('touchstart', function(e) {
  if (e.touches.length !== 1) return;
  stopInertia();
  startX = e.touches[0].clientX; startY = e.touches[0].clientY;
  scrollStartX = grid.scrollLeft; active = true; horiz = null;
  lastX = startX; lastT = e.timeStamp; vel = 0;
  grid.style.scrollBehavior = 'auto';
 }, { passive: true });
 grid.addEventListener('touchmove', function(e) {
  if (!active || e.touches.length !== 1) return;
  var cx = e.touches[0].clientX;
  var dx = startX - cx, dy = startY - e.touches[0].clientY;
  if (horiz === null && (Math.abs(dx) > 5 || Math.abs(dy) > 5)) horiz = Math.abs(dx) > Math.abs(dy);
  if (horiz) {
   e.preventDefault();
   grid.scrollLeft = scrollStartX + dx;
   var dt = e.timeStamp - lastT;
   if (dt > 0) { var v = (lastX - cx) / dt; vel = vel * 0.4 + v * 0.6; } /* velocita' smussata */
   lastX = cx; lastT = e.timeStamp;
  }
 }, { passive: false });
 grid.addEventListener('touchend', function() {
  active = false;
  if (horiz && Math.abs(vel) > 0.08) { if (vel > 2.5) vel = 2.5; if (vel < -2.5) vel = -2.5; inertia(); } /* flick -> inerzia */
 }, { passive: true });
 grid.addEventListener('scroll', function() { updateCarouselState(grid); }, { passive: true });
}
document.addEventListener('DOMContentLoaded', function() {
 setTimeout(() => {
  initProductCarousels();
 }, 500);
 const observer = new MutationObserver(function(mutations) {
  mutations.forEach(function(mutation) {
   mutation.addedNodes.forEach(function(node) {
    if (node.nodeType === Node.ELEMENT_NODE) {
     const newGrids = node.querySelectorAll('.fx-product-standard-grid:not([data-carousel-initialized])');
     if (newGrids.length > 0) {
      setTimeout(() => {
       initProductCarousels();
      }, 200);
     }
    }
   });
  });
 });
 observer.observe(document.body, { childList: true, subtree: true });
});
let carouselResizeTimeout;
window.addEventListener('resize', function() {
 clearTimeout(carouselResizeTimeout);
 carouselResizeTimeout = setTimeout(() => {
  const grids = document.querySelectorAll('.fx-product-standard-grid:not(.fx-effect-products-grid):not(#fx-products-grid)');
  grids.forEach(grid => {
   updateCarouselState(grid);
  });
 }, 300);
});
